import { Upload } from './graphql-types';
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { useFetchData } from '../hooks/use-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  HexColorCode: { input: any; output: any; }
  Json: { input: any; output: any; }
  LocalDate: { input: string; output: string; }
  URL: { input: string; output: string; }
  Upload: { input: Upload; output: Upload; }
  Void: { input: any; output: any; }
};

export type AiFormattedProductDescriptionInput = {
  description: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  traceId: Scalars['ID']['input'];
};

export type AiProductDataPayload = {
  __typename?: 'AIProductDataPayload';
  description: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['ID']['output']>;
};

export type AiProductErrorPayload = {
  __typename?: 'AIProductErrorPayload';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AiProductInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export enum AiProductLanguageEnum {
  En = 'EN',
  Fr = 'FR'
}

export type AiProductsInput = {
  example?: InputMaybe<Scalars['String']['input']>;
  lang: AiProductLanguageEnum;
  products: Array<AiProductInput>;
  prompt: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  withNames?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiProductsUpdatedPayload = {
  __typename?: 'AIProductsUpdatedPayload';
  data: AiProductDataPayload;
  error?: Maybe<AiProductErrorPayload>;
  sessionId: Scalars['ID']['output'];
};

export type AccentuateReferralInput = {
  bigImage: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
  smallImage: Scalars['String']['input'];
  store: StoreRegion;
};

export type Ad = {
  __typename?: 'Ad';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  is_cold?: Maybe<Scalars['Boolean']['output']>;
  is_retarget?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
};

export type AddTextPayload = {
  isPrefix: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

export type BadgeInput = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  is_special?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type BadgeSvg = {
  __typename?: 'BadgeSvg';
  name: Scalars['String']['output'];
  svg: Scalars['String']['output'];
};

export type Brand = {
  __typename?: 'Brand';
  about?: Maybe<Scalars['String']['output']>;
  accept_contract?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['Json']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  emailedAt?: Maybe<Scalars['DateTime']['output']>;
  hasShopify?: Maybe<Scalars['Boolean']['output']>;
  hubspot_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  invitationLink?: Maybe<Scalars['String']['output']>;
  is_autoentrepreneur?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plugins?: Maybe<Plugins>;
  sale_objectif_name?: Maybe<Scalars['String']['output']>;
  shipping_restricted_to_france?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandUpdate = {
  brand: BrandUpdateJson;
  saleId?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdateAddress = {
  bp?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdateJson = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<BrandUpdateAddress>;
  category?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_email_ops?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  has_shopify?: InputMaybe<Scalars['Boolean']['input']>;
  hubspot_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  is_autoentrepreneur?: InputMaybe<Scalars['Boolean']['input']>;
  max_delivery_delay?: InputMaybe<Scalars['Int']['input']>;
  min_delivery_delay?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sale_objectif_name?: InputMaybe<Scalars['String']['input']>;
  shipping_restricted_to_france?: InputMaybe<Scalars['Boolean']['input']>;
  store_id?: InputMaybe<StoreRegion>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/**
 * Lightweight Sale projection tailored for the admin calendar view.
 * It contains only the fields the calendar UI needs and avoids resolving
 * heavy sub-objects (widgets, invoices, orders, ads, cashback, giveaways, etc.).
 */
export type CalendarSale = {
  __typename?: 'CalendarSale';
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['String']['output']>;
  cancellation_level?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  deal?: Maybe<Deal>;
  deliver_by_choose?: Maybe<Scalars['Boolean']['output']>;
  end_at_date: Scalars['LocalDate']['output'];
  forecast?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  hasDescription: Scalars['Boolean']['output'];
  hasHeader: Scalars['Boolean']['output'];
  hasPreviews: Scalars['Boolean']['output'];
  hide?: Maybe<Scalars['Boolean']['output']>;
  hubspot_category?: Maybe<Scalars['String']['output']>;
  hubspot_deal_id?: Maybe<Scalars['String']['output']>;
  hubspot_demande_point_relais?: Maybe<PointRelais>;
  hubspot_selection_id?: Maybe<Scalars['String']['output']>;
  hubspot_team_name?: Maybe<TeamName>;
  hubspot_tiering?: Maybe<Tiering>;
  hubspot_top_brand_type?: Maybe<TopBrandType>;
  id: Scalars['String']['output'];
  isShopify?: Maybe<Scalars['Boolean']['output']>;
  is_cancelled?: Maybe<Scalars['Boolean']['output']>;
  is_ready?: Maybe<Scalars['Boolean']['output']>;
  is_setup?: Maybe<Scalars['Boolean']['output']>;
  logistics_manager?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  operation_type?: Maybe<Scalars['String']['output']>;
  pricingErrorsCount?: Maybe<Scalars['Int']['output']>;
  sale_status?: Maybe<SaleStatusFilter>;
  selection_name?: Maybe<Scalars['String']['output']>;
  setup_by?: Maybe<Scalars['String']['output']>;
  setup_status?: Maybe<SaleSetupStatus>;
  shippingPolicy: ShippingPolicy;
  shopify?: Maybe<ShopifyData>;
  start_at_date: Scalars['LocalDate']['output'];
  stats_stock?: Maybe<Scalars['Json']['output']>;
  storeId: StoreRegion;
  total_sales?: Maybe<Scalars['Int']['output']>;
  url_google_drive?: Maybe<Scalars['String']['output']>;
  url_google_drive_not_validated?: Maybe<Scalars['String']['output']>;
};

export type CalendarSalesResult = {
  __typename?: 'CalendarSalesResult';
  sales: Array<CalendarSale>;
  total_sales: Scalars['Int']['output'];
};

export enum CampaignType {
  LastChance = 'last_chance',
  Marketing = 'marketing',
  Private = 'private',
  Regular = 'regular',
  Spotlight = 'spotlight'
}

export type Canvas = {
  color?: InputMaybe<Scalars['String']['input']>;
  flipHorizontal?: InputMaybe<Scalars['Boolean']['input']>;
  height: Scalars['Float']['input'];
  rotate?: InputMaybe<Scalars['Float']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CashbackPolicy = {
  __typename?: 'CashbackPolicy';
  delayInDays: Scalars['Int']['output'];
  thresholds: Array<CashbackThreshold>;
};

export type CashbackPolicyInput = {
  delayInDays: Scalars['Int']['input'];
  thresholds: Array<CashbackThresholdInput>;
};

export type CashbackThreshold = {
  __typename?: 'CashbackThreshold';
  cashbackAmount: Scalars['Int']['output'];
  threshold: Scalars['Int']['output'];
};

export type CashbackThresholdInput = {
  cashbackAmount: Scalars['Int']['input'];
  threshold: Scalars['Int']['input'];
};

export type CatalogItemReference = {
  __typename?: 'CatalogItemReference';
  /** GTIN of the reference */
  gtin: Scalars['String']['output'];
  /** Id of the reference */
  id: Scalars['ID']['output'];
  /** Secondary identifiers of the reference */
  secondaryIdentifiers: Array<CatalogItemSecondaryIdentifier>;
};

export type CatalogItemSecondaryIdentifier = {
  __typename?: 'CatalogItemSecondaryIdentifier';
  /** Type of the unique ID */
  type: Scalars['String']['output'];
  /** Value of the unique ID */
  value: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  category: Scalars['String']['output'];
  ids: Array<Scalars['String']['output']>;
  sub_categories: Array<SubCategory>;
};

export type CategoryOption = {
  __typename?: 'CategoryOption';
  placeholders: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CategoryTree = {
  __typename?: 'CategoryTree';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  notReturnable: Scalars['Boolean']['output'];
  subCategories?: Maybe<Array<CategoryTree>>;
  tva?: Maybe<Scalars['Float']['output']>;
};

export enum CodeType {
  Amount = 'AMOUNT',
  FreeShipping = 'FREE_SHIPPING',
  GiftCard = 'GIFT_CARD',
  Percentage = 'PERCENTAGE'
}

export type CoherenceCheckData = {
  __typename?: 'CoherenceCheckData';
  errors: Array<Scalars['String']['output']>;
};

export type CollectionSale = {
  __typename?: 'CollectionSale';
  bestsellersProducts: Array<Scalars['ID']['output']>;
  customFilters: Array<CustomFilter>;
  name: Scalars['String']['output'];
  readonlyFilters?: Maybe<Array<CustomFilter>>;
  saleId: Scalars['ID']['output'];
};

export type CopyBrandParams = {
  shopifyPlugin: Scalars['Boolean']['input'];
};

export type CopyProductsParams = {
  resetPrice?: InputMaybe<Scalars['Boolean']['input']>;
  shippingFeesValue?: InputMaybe<Scalars['Int']['input']>;
  /** Products data */
  stockValue?: InputMaybe<Scalars['Int']['input']>;
};

export type CopyProductsV3Param = {
  productId: Scalars['String']['input'];
  stockValue?: InputMaybe<Scalars['Int']['input']>;
  variantId: Scalars['String']['input'];
};

export type CopySaleParams = {
  images: Scalars['Boolean']['input'];
  previews: Scalars['Boolean']['input'];
};

export type Correction = {
  __typename?: 'Correction';
  correction: Scalars['String']['output'];
  original: Scalars['String']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  code?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  first_order_only?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minimum_order_amount?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantity_per_user?: Maybe<Scalars['Int']['output']>;
  start_at?: Maybe<Scalars['DateTime']['output']>;
  store_id?: Maybe<StoreRegion>;
  total_used?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CodeType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum CouponStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Expired = 'EXPIRED',
  Programmated = 'PROGRAMMATED'
}

export type CouponUpdate = {
  data?: InputMaybe<CouponUpdateInput>;
};

export type CouponUpdateInput = {
  code: Scalars['String']['input'];
  expires_at?: InputMaybe<Scalars['String']['input']>;
  first_order_only?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minimum_order_amount?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantity_per_user?: InputMaybe<Scalars['Int']['input']>;
  start_at?: InputMaybe<Scalars['String']['input']>;
  store_id: StoreRegion;
  type?: InputMaybe<CodeType>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CrawlDriveUrlDataInput = {
  googleDriveUrl: Scalars['String']['input'];
  gtin?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type CrawlingDriveProductImage = {
  __typename?: 'CrawlingDriveProductImage';
  images: Array<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
};

export type CreateSaleCustomFilterInput = {
  /** Trimmed, non empty, unique among the custom filters of the sale */
  name: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
};

export type CrossSelling = {
  __typename?: 'CrossSelling';
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  products: Array<CrossSellingProduct>;
};

export type CrossSellingPreview = {
  __typename?: 'CrossSellingPreview';
  durationMs: Scalars['Int']['output'];
  evaluatedPairCount: Scalars['Int']['output'];
  inputTokens: Scalars['Int']['output'];
  minimumScore: Scalars['Float']['output'];
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  productCount: Scalars['Int']['output'];
  saleId: Scalars['ID']['output'];
  suggestions: Array<CrossSelling>;
  traceIds: Array<Scalars['String']['output']>;
};

export enum CrossSellingPreviewPhase {
  Pairs = 'PAIRS',
  Shortlist = 'SHORTLIST'
}

/**
 * Requests are only known phase by phase: the SHORTLIST total can grow while finalists are reranked,
 * and the PAIRS total is known once the shortlist is done.
 */
export type CrossSellingPreviewProgress = {
  __typename?: 'CrossSellingPreviewProgress';
  completedRequests: Scalars['Int']['output'];
  phase: CrossSellingPreviewPhase;
  totalRequests: Scalars['Int']['output'];
};

export type CrossSellingPreviewSession = {
  __typename?: 'CrossSellingPreviewSession';
  createdAt: Scalars['DateTime']['output'];
  /**
   * A DomainException code, set once the status is FAILED: cross_selling_preview_timed_out (retry with a smaller
   * sale or a narrower intent), cross_selling_recommender_unavailable (retry later), cross_selling_preview_expired
   * (the job was lost), cross_selling_preview_failed (unexpected error).
   */
  errorCode?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  intent: Scalars['String']['output'];
  /** Set once the status is SUCCEEDED. */
  preview?: Maybe<CrossSellingPreview>;
  progress?: Maybe<CrossSellingPreviewProgress>;
  saleId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
  status: CrossSellingPreviewStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CrossSellingPreviewSessionReturn = CrossSellingPreviewSession | DomainException;

export enum CrossSellingPreviewStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type CrossSellingProduct = {
  __typename?: 'CrossSellingProduct';
  /** Concentration of Jev's answer distribution, not a probability of purchase. */
  confidence?: Maybe<Scalars['Float']['output']>;
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  /** Jev relevance score from 0 to 3; absent for legacy recommendations. */
  score?: Maybe<Scalars['Float']['output']>;
  type: CrossSellingType;
};

export enum CrossSellingType {
  RecoAi = 'reco_ai',
  RecoAiAndBoughtTogether = 'reco_ai_and_bought_together',
  RecoBoughtTogether = 'reco_bought_together'
}

/** *** Represent the "Detail" scope of a product */
export type CustomField = {
  __typename?: 'CustomField';
  /** id of said custom field */
  key: Scalars['ID']['output'];
  /** position of said custom field */
  position: Scalars['Int']['output'];
  /** type of said custom field */
  type?: Maybe<Scalars['String']['output']>;
  /** name of the custom field. ie: Parfum */
  value: Scalars['String']['output'];
};

export type CustomFieldInput = {
  /** id of said custom field */
  key: Scalars['ID']['input'];
  /** position of said custom field */
  position: Scalars['Int']['input'];
  /** type of the custom field */
  type?: InputMaybe<Scalars['String']['input']>;
  /** name of the custom field. ie: Parfum */
  value: Scalars['String']['input'];
};

export type CustomFilter = {
  __typename?: 'CustomFilter';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  values: Array<CustomFilterValue>;
};

/** Input for custom filter associations when adding a product to collection */
export type CustomFilterInput = {
  /** ID of the custom filter */
  filterId: Scalars['ID']['input'];
  /** List of values within this filter to associate the product variants with */
  selectedValues: Array<Scalars['String']['input']>;
};

export type CustomFilterValue = {
  __typename?: 'CustomFilterValue';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DateRange = {
  __typename?: 'DateRange';
  endAt: Scalars['DateTime']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type Deal = {
  __typename?: 'Deal';
  link: Scalars['String']['output'];
};

export type DeprecatedDescriptionCheckData = {
  __typename?: 'DeprecatedDescriptionCheckData';
  informations: InformationCheckData;
  spelling: SpellingCheckData;
};

export enum DifficultySetupLevel {
  /** Très difficile, problèmes critiques */
  Black = 'BLACK',
  /** Facile, sans problème majeur */
  Green = 'GREEN',
  /** Moyen, quelques complications */
  Orange = 'ORANGE',
  /** Difficile, nombreux problèmes */
  Red = 'RED'
}

export type DomainException = {
  __typename?: 'DomainException';
  errorCode: Scalars['String']['output'];
  extra: Array<ExceptionExtraTuple>;
};

export type ErrorLike = {
  __typename?: 'ErrorLike';
  message: Scalars['String']['output'];
};

export type ExceptionExtraTuple = {
  __typename?: 'ExceptionExtraTuple';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum FileUploadType {
  Product = 'PRODUCT',
  Sale = 'SALE'
}

export type GiveawayPolicyInput = {
  overOrderAmount: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  /**
   * Explicitly null: no trigger product (amount or no-minimum offer). Omitted: refused with
   * `giveaway_sale_policy_trigger_product_missing` when the sale currently has a trigger product,
   * read as null otherwise. Every policy of the list carries the same value; a trigger product
   * requires overOrderAmount = 0.
   */
  triggerProductId?: InputMaybe<Scalars['ID']['input']>;
};

export type GiveawaySalePolicy = {
  __typename?: 'GiveawaySalePolicy';
  /** When null, the giveaway policy is active all sale's durations */
  dateRange?: Maybe<DateRange>;
  id: Scalars['ID']['output'];
  overOrderAmount: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  saleId: Scalars['ID']['output'];
  /**
   * Product whose purchase triggers the gift (one gift per unit bought). Null when the offer
   * depends on the cart amount (overOrderAmount > 0) or has no minimum (overOrderAmount = 0).
   */
  triggerProductId?: Maybe<Scalars['ID']['output']>;
};

export type IaTransform = {
  expand?: InputMaybe<Scalars['Boolean']['input']>;
  removeBackground?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image = {
  __typename?: 'Image';
  baseKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
};

export type ImageAdded = {
  __typename?: 'ImageAdded';
  image_storage_path_key: Scalars['String']['output'];
  image_updated_url: Scalars['String']['output'];
  /** @deprecated image_storage_path_key */
  key: Scalars['String']['output'];
  source_store_path_key: Scalars['String']['output'];
  source_url: Scalars['String']['output'];
  /** @deprecated image_updated_url */
  url: Scalars['String']['output'];
};

export enum ImageAspect {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

export type ImageData = {
  baseKey?: InputMaybe<Scalars['String']['input']>;
  canvas?: InputMaybe<Canvas>;
  defaultSize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['Json']['input']>;
  type: ImageDataType;
  version?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum ImageDataType {
  Preview = 'preview',
  Product = 'product',
  Sale = 'sale',
  Size = 'size'
}

export type ImageDimensions = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type ImageInput = {
  id: Scalars['ID']['input'];
  url: Scalars['URL']['input'];
};

export type ImagePreview = {
  __typename?: 'ImagePreview';
  url: Scalars['String']['output'];
};

export type ImagePreviewReturn = ErrorLike | ImagePreview;

export type ImageProccessed = {
  __typename?: 'ImageProccessed';
  /** id sent by the client to the related mutation */
  actionId: Scalars['ID']['output'];
  /** id of the processed image */
  id: Scalars['ID']['output'];
  /** new processed image url */
  url: Scalars['URL']['output'];
};

export type ImageSaveReturn = ErrorLike | ImageAdded;

export type ImageTransformation = {
  canvas?: InputMaybe<Canvas>;
  ia?: InputMaybe<IaTransform>;
};

export type ImmersiveCalendarDay = {
  __typename?: 'ImmersiveCalendarDay';
  current: Array<Maybe<ImmersiveSale>>;
  date: Scalars['LocalDate']['output'];
  stillActive: Array<Maybe<ImmersiveSale>>;
};

export type ImmersiveCatchlineGenerationResult = {
  __typename?: 'ImmersiveCatchlineGenerationResult';
  status: ImmersiveCatchlineGenerationStatus;
  suggestions: Array<Scalars['String']['output']>;
};

export type ImmersiveCatchlineGenerationReturn = DomainException | ImmersiveCatchlineGenerationResult;

export enum ImmersiveCatchlineGenerationStatus {
  InsufficientInformation = 'INSUFFICIENT_INFORMATION',
  Success = 'SUCCESS'
}

export enum ImmersiveCatchlineType {
  Teasing = 'TEASING',
  TopApp = 'TOP_APP'
}

export type ImmersiveSale = {
  __typename?: 'ImmersiveSale';
  brandLogoUrl?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endAt: Scalars['LocalDate']['output'];
  forceFirstPosition: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  saleId: Scalars['String']['output'];
  saleName: Scalars['String']['output'];
  showForDays: Scalars['Int']['output'];
  startAt: Scalars['LocalDate']['output'];
  status: SaleImmersiveStatus;
  stickerUrl?: Maybe<Scalars['String']['output']>;
  universeIds: Array<Maybe<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ImmersiveSaleAssetsInput = {
  removeSticker?: InputMaybe<Scalars['Boolean']['input']>;
  sourceLogoKey?: InputMaybe<Scalars['String']['input']>;
  sourceStickerKey?: InputMaybe<Scalars['String']['input']>;
  sourceVideoKey?: InputMaybe<Scalars['String']['input']>;
};

export type ImmersiveSaleInput = {
  /** Source keys returned by createUploadUrls. Omitted fields keep the existing asset on update. */
  assets?: InputMaybe<ImmersiveSaleAssetsInput>;
  /** Description displayed on the app */
  description?: InputMaybe<Scalars['String']['input']>;
  /** End date of the immersive sale. If not provided, use startAt + 24h. (YYYY-MM-DD) */
  endAt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pin this immersive sale to the first position of the homepage.
   * Only one immersive sale can be pinned for a given day: pinning one un-pins the other one.
   */
  forceFirstPosition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the immersive sale to update. If not provided, a new immersive sale is created for the sale. */
  immersiveSaleId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the sale this immersive is related to */
  saleId: Scalars['String']['input'];
  /** Number of days the immersive sale should be displayed */
  showForDays?: InputMaybe<Scalars['Int']['input']>;
  /** Start date of the immersive sale. If not provided, use the sale start date. (YYYY-MM-DD) */
  startAt?: InputMaybe<Scalars['String']['input']>;
  /** Status of the immersive sale. if not provided, it will be set to draft or pending */
  status?: InputMaybe<SaleImmersiveStatus>;
  /** Universes linked to the immersive sale. If empty, the immersive sale will be linked to all universes. */
  universeIds: Array<InputMaybe<Scalars['String']['input']>>;
  /** url that should be opened when the immersive sale is clicked */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ImmersiveSaleReturn = DomainException | ImmersiveSale;

export type InformationCheckData = {
  __typename?: 'InformationCheckData';
  missing: Array<InformationMissingData>;
  present: Array<Scalars['String']['output']>;
};

export type InformationMissingData = {
  __typename?: 'InformationMissingData';
  importance: InformationMissingDataImportance;
  key: Scalars['String']['output'];
};

export enum InformationMissingDataImportance {
  Recommended = 'recommended',
  Required = 'required'
}

export type InventoryAvailable = {
  __typename?: 'InventoryAvailable';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  invoice_amount?: Maybe<Scalars['String']['output']>;
  invoice_by?: Maybe<Scalars['String']['output']>;
  invoice_on?: Maybe<Scalars['DateTime']['output']>;
  is_invoice_ready?: Maybe<Scalars['Boolean']['output']>;
  paid_amount?: Maybe<Scalars['Int']['output']>;
  paid_by?: Maybe<Scalars['String']['output']>;
  paid_on?: Maybe<Scalars['DateTime']['output']>;
  proof_paid_url?: Maybe<Scalars['String']['output']>;
};

export type LinkedProduct = {
  __typename?: 'LinkedProduct';
  productId: Scalars['ID']['output'];
  relatedProductId: Scalars['ID']['output'];
};

export type LinkedProductsInput = {
  productId: Scalars['ID']['input'];
  relatedProductId: Scalars['ID']['input'];
};

export type LinkedProductsMetadata = {
  __typename?: 'LinkedProductsMetadata';
  titleFallback: Scalars['String']['output'];
  titleKey: Scalars['String']['output'];
};

export type LinkedProductsMetadataInput = {
  titleFallback: Scalars['String']['input'];
  titleKey: Scalars['String']['input'];
};

export type MarketingQueries = {
  __typename?: 'MarketingQueries';
  /** Get the immersive calendar for a store */
  getImmersiveCalendar: Array<Maybe<ImmersiveCalendarDay>>;
  /** Get the expected immersive sales for a store */
  getImmersiveSales: Array<Maybe<ImmersiveSale>>;
  /** Get the expected next immersive sales for a store */
  getNextImmersiveSales: Array<Maybe<NextImmersiveSale>>;
  getReferralUploadUrl?: Maybe<UploadUrl>;
  referralBlock?: Maybe<MarketingReferralBlock>;
};


export type MarketingQueriesGetImmersiveCalendarArgs = {
  endAt?: InputMaybe<Scalars['LocalDate']['input']>;
  startAt: Scalars['LocalDate']['input'];
  store: StoreRegion;
};


export type MarketingQueriesGetImmersiveSalesArgs = {
  endAt?: InputMaybe<Scalars['LocalDate']['input']>;
  startAt: Scalars['LocalDate']['input'];
  store: StoreRegion;
};


export type MarketingQueriesGetNextImmersiveSalesArgs = {
  endAt?: InputMaybe<Scalars['LocalDate']['input']>;
  startAt: Scalars['LocalDate']['input'];
  store: StoreRegion;
};


export type MarketingQueriesGetReferralUploadUrlArgs = {
  fileType: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
  uploadType: MarketingReferralImageType;
};


export type MarketingQueriesReferralBlockArgs = {
  store: StoreRegion;
};

export type MarketingReferralBlock = {
  __typename?: 'MarketingReferralBlock';
  bigImage: Scalars['String']['output'];
  btnCta: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  smallImage: Scalars['String']['output'];
  tagline: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum MarketingReferralImageType {
  BigImage = 'bigImage',
  SmallImage = 'smallImage'
}

export enum MarketingType {
  Bulletpoint = 'BULLETPOINT',
  Rsvp = 'RSVP',
  Selection = 'SELECTION'
}

export type MarketingVideo = {
  __typename?: 'MarketingVideo';
  /** URL of the cover image used to display the marketing video */
  coverImageUrl: Scalars['String']['output'];
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** URL of the video used to display the marketing video */
  url: Scalars['String']['output'];
};

export enum MeusnidusRole {
  Admin = 'Admin',
  Hr = 'Hr',
  Ops = 'Ops',
  Sale = 'Sale',
  Setup = 'Setup'
}

export type MondialRelayData = {
  __typename?: 'MondialRelayData';
  shippingCost: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addImagesToProducts?: Maybe<Scalars['Void']['output']>;
  /** Replace a sale's linked products. Omitting metadata or passing null preserves the saved title. */
  addLinkedProducts?: Maybe<Scalars['Boolean']['output']>;
  addProductCouponsV2?: Maybe<Scalars['Void']['output']>;
  /** Add a product to a sale collection and associate all its variants with selected custom filter values */
  addProductToCollection?: Maybe<Scalars['Boolean']['output']>;
  addProductsBadges?: Maybe<Scalars['Void']['output']>;
  addSizeGuidesToProducts?: Maybe<Scalars['Void']['output']>;
  addTextToProductsDescription?: Maybe<Scalars['Void']['output']>;
  addTextToProductsName?: Maybe<Scalars['Void']['output']>;
  alignBottomImages?: Maybe<Scalars['Void']['output']>;
  alignTopImages?: Maybe<Scalars['Void']['output']>;
  changeProductColorToOption?: Maybe<Scalars['Void']['output']>;
  changeProductOptionToColor?: Maybe<Scalars['Void']['output']>;
  checkPricesWithAI: Scalars['String']['output'];
  copyBrandV2?: Maybe<Scalars['String']['output']>;
  copyProductV2: Scalars['ID']['output'];
  copyProductsV2?: Maybe<Scalars['String']['output']>;
  copyProductsV3?: Maybe<Scalars['String']['output']>;
  /** ** Full duplication ** */
  copySale?: Maybe<Scalars['String']['output']>;
  /** ** Useful for copying products from one sale to another ** */
  copySaleV2?: Maybe<Scalars['String']['output']>;
  crawlDriveImages: Array<CrawlingDriveProductImage>;
  crawlProducts?: Maybe<Scalars['String']['output']>;
  createDurationWidget?: Maybe<Scalars['String']['output']>;
  createLogisticFile?: Maybe<Scalars['String']['output']>;
  /**
   * WIP - Create a product with a new domain
   * input types are not defined yet.
   */
  createProduct?: Maybe<Scalars['String']['output']>;
  /**
   * Create a custom filter with no option yet (an empty shell): it appears in saleCustomFilters,
   * and the app ignores it until an import feeds it.
   */
  createSaleCustomFilter: SaleCustomFilterReturn;
  /** Creates a test order on the seller's Shopify store to verify integration */
  createShopifyTestOrder: ShopifyTestOrderOutput;
  createUploadUrls: Array<UploadUrlReturn>;
  cropBelowFacesImages?: Maybe<Scalars['Void']['output']>;
  deleteDealToCalendar?: Maybe<Scalars['String']['output']>;
  /**
   * Delete the filter with its options and variant attachments, and purge its traces from the
   * sale's filters configuration (hidden, shortcut and image entries), leaving no orphan behind.
   */
  deleteSaleCustomFilter?: Maybe<Scalars['Boolean']['output']>;
  /** Dismiss a product quality check (marks as reviewed, logs to Langfuse for feedback) */
  dismissProductCheck: Scalars['Boolean']['output'];
  extendImages?: Maybe<Scalars['Void']['output']>;
  fillImages?: Maybe<Scalars['Void']['output']>;
  fitImages?: Maybe<Scalars['Void']['output']>;
  formatProductsDescription?: Maybe<Scalars['Void']['output']>;
  formatProductsWithAI: Scalars['String']['output'];
  /** Generate three editorial catchline suggestions for an immersive sale or teasing. */
  generateImmersiveCatchlines: ImmersiveCatchlineGenerationReturn;
  /**
   * Extract the first frame of a story screen video uploaded through
   * createUploadUrls(SALE_SPOTLIGHT_VIDEO) to `thumbnail.png`, in the video's folder.
   * To call once the upload to the signed URL is done: `videoKey` is the key it returned.
   */
  generateSpotlightVideoThumbnail: SpotlightVideoThumbnailReturn;
  hideOutOfStockProductsAndVariants?: Maybe<Scalars['Void']['output']>;
  importProducts?: Maybe<Scalars['String']['output']>;
  markSaleTrackingsAsDelivered?: Maybe<Scalars['String']['output']>;
  /**
   * Move selected products to a specific position in the sale.
   * The first ID in the array will be in position `startPosition`, the second in position `startPosition + 1`, etc.
   */
  moveProductsToPosition?: Maybe<Scalars['Void']['output']>;
  newAddImage: ImageAdded;
  previewImage: ImagePreviewReturn;
  /** Transcode an uploaded product audio extract to AAC 64 kbps mono (.m4a) and return its final URL */
  processProductAudio: ProcessProductAudioResult;
  /** Process a product video with FFmpeg blur/overlay effect */
  processProductVideo: ProcessProductVideoResult;
  publishProducts?: Maybe<Scalars['Void']['output']>;
  /**
   * Validate the saved spotlight configuration as complete, then serve it to the app.
   * Returns a SpotlightConfigValidationError listing every invalid field when it is incomplete.
   */
  publishSpotlightConfig: SpotlightConfigReturn;
  referenceProducts?: Maybe<Scalars['Void']['output']>;
  removeBackgroundImages?: Maybe<Scalars['Void']['output']>;
  removeCoupon?: Maybe<Scalars['String']['output']>;
  removeGtins?: Maybe<Scalars['Void']['output']>;
  /** Remove the immersive sale */
  removeImmersiveSale?: Maybe<Scalars['Boolean']['output']>;
  /** Remove the next immersive sale */
  removeImmersiveSaleNext?: Maybe<Scalars['Boolean']['output']>;
  removeProductCoupons?: Maybe<Scalars['String']['output']>;
  /** Remove a product from a sale collection and clean up all its filter associations */
  removeProductFromCollection?: Maybe<Scalars['Boolean']['output']>;
  removeProducts?: Maybe<Scalars['String']['output']>;
  removeProductsBadges?: Maybe<Scalars['Void']['output']>;
  removeProductsImages?: Maybe<Scalars['Void']['output']>;
  removeProductsShopifyVariantIds?: Maybe<Scalars['Void']['output']>;
  removeProductsSizeGuide?: Maybe<Scalars['Void']['output']>;
  removeProductsVariantsImages?: Maybe<Scalars['Void']['output']>;
  removeSale?: Maybe<Scalars['String']['output']>;
  /** Drop the filters configuration of a sale, reverting it to the default filter behaviour */
  removeSaleFiltersConfig?: Maybe<Scalars['Boolean']['output']>;
  /** Remove the plugin */
  removeShopifyPlugin?: Maybe<Scalars['Boolean']['output']>;
  removeSkus?: Maybe<Scalars['Void']['output']>;
  removeWidget?: Maybe<Scalars['String']['output']>;
  renameSaleCustomFilter: SaleCustomFilterReturn;
  /**
   * Rename one option everywhere it appears: every variant attachment follows. Renaming onto an
   * existing option is refused (custom_filter_option_name_taken) rather than silently merging.
   */
  renameSaleCustomFilterOption: SaleCustomFilterReturn;
  /**
   * Set the order the options of a filter are displayed in, in the app as in the back-office.
   *
   * `values` carries the whole option set of the filter, ordered; the positions are rewritten
   * 0..n-1 along it. Nothing is written when it does not match that set exactly: a duplicate
   * refuses with custom_filter_reorder_duplicate_value, a value the filter does not hold with
   * custom_filter_value_not_found, and a set missing options with
   * custom_filter_reorder_incomplete_values, the missing values listed in extra under the
   * "values" key (comma-separated).
   *
   * This is the only thing that moves an option the filter already holds: a re-import never
   * renumbers them, it only appends what it brings. Calling this right after
   * replaceSaleCustomFilterContent with the resulting option set is the way to place the newcomers.
   */
  reorderSaleCustomFilterOptions: SaleCustomFilterReturn;
  replaceProductsDescription?: Maybe<Scalars['Void']['output']>;
  replaceProductsName?: Maybe<Scalars['Void']['output']>;
  /**
   * The entries become the whole content of the filter, atomically: options absent from the
   * entries are removed with their attachments, and nothing is imported when any entry is invalid.
   * A variantId outside the sale refuses the import with custom_filter_unknown_variants, the
   * unknown ids listed in extra under the "variantIds" key (comma-separated).
   *
   * Options are matched on their value, so re-importing the very file an option was renamed from
   * keeps the rename: only a value the file no longer carries loses its label along with itself.
   * An option the file still carries keeps its rank too, so the order the e-merch put the options
   * in survives any number of re-imports; an option the file brings for the first time is appended
   * after all of them, alphabetically among the newcomers.
   */
  replaceSaleCustomFilterContent: SaleCustomFilterReturn;
  saveImage: ImageSaveReturn;
  saveImages?: Maybe<Scalars['Void']['output']>;
  /** Braze will send a preview a email */
  sendMarketingEmail?: Maybe<Scalars['String']['output']>;
  sendOnboardingEmail?: Maybe<Scalars['String']['output']>;
  /** Set or unset a product as a best seller in its own sale. */
  setProductAsBestSeller?: Maybe<Scalars['Void']['output']>;
  /**
   * Set (isCover: true) or unset (isCover: false) a product as the cover product of its sale.
   * A sale has at most one cover product; setting a new one replaces the previous.
   */
  setProductAsCover?: Maybe<Scalars['Void']['output']>;
  /** Set or unset a product as new. */
  setProductHighlightedAsNew?: Maybe<Scalars['Void']['output']>;
  setProductsAsUnique?: Maybe<Scalars['Void']['output']>;
  setProductsHide?: Maybe<Scalars['Void']['output']>;
  setSaleReady?: Maybe<Scalars['String']['output']>;
  setSetupReady?: Maybe<Scalars['String']['output']>;
  setSetupWaitingForElements?: Maybe<Scalars['String']['output']>;
  setShopifyStockProtection?: Maybe<Scalars['Void']['output']>;
  setUserAdmin?: Maybe<Scalars['Boolean']['output']>;
  showHiddenProductsAndVariants?: Maybe<Scalars['Void']['output']>;
  shuffleProductList?: Maybe<Scalars['Void']['output']>;
  /**
   * Starts a Jev cross-selling preview of the sale's eligible products and returns its pending session at once;
   * the inference runs in a job. Follow it with the crossSellingPreviewUpdated subscription, or reload it with
   * crossSellingPreviewSession. Nothing is saved on the sale: persist the reviewed selection with addLinkedProducts.
   * Omit intent, pass null or leave it blank to use the default complementary-product recommendations;
   * a custom intent replaces it. While a preview of the sale is pending or running, that session is
   * returned instead, whatever its intent. Refusals known before the job (unknown or collection sale,
   * intent or eligible products over the CROSS_SELLING_LIMITS of @choose/catalog) are returned as a
   * DomainException.
   */
  startCrossSellingsPreview: CrossSellingPreviewSessionReturn;
  /** Synchronizes all unsynchronized Choose orders to the seller's Shopify store */
  syncPendingShopifyOrders: ShopifySyncPendingOrdersOutput;
  /** Synchronizes the stock of a sale to the seller's Shopify store */
  syncShopifyStock: ShopifyStockSyncOutput;
  translateProductsWithAI: Scalars['String']['output'];
  /** Manually trigger a quality check for a product */
  triggerProductQualityCheck: Scalars['Boolean']['output'];
  /** Stop serving the spotlight configuration to the app: it goes back to `draft`. */
  unpublishSpotlightConfig: SpotlightConfigReturn;
  updateAccentuateReferral?: Maybe<Scalars['String']['output']>;
  updateBrand?: Maybe<Scalars['String']['output']>;
  updateCoupon?: Maybe<Scalars['String']['output']>;
  updateDealKey?: Maybe<Scalars['String']['output']>;
  updateInvoice?: Maybe<Scalars['String']['output']>;
  updateManyProduct?: Maybe<Scalars['Void']['output']>;
  updateManyProductCoupon?: Maybe<Scalars['Void']['output']>;
  updateManyProductOptions?: Maybe<Array<ProductOptionError>>;
  /**
   * WIP - update a product with a new domain
   * return type is not defined yet.
   */
  updateProductV4: ProductV3;
  updateProductsBuyingPrice?: Maybe<Scalars['Void']['output']>;
  updateProductsCategory?: Maybe<Scalars['Void']['output']>;
  updateProductsCouponExpiresAt?: Maybe<Scalars['Void']['output']>;
  updateProductsDelivery?: Maybe<Scalars['Void']['output']>;
  updateProductsGender?: Maybe<Scalars['Void']['output']>;
  updateProductsOriginCountry?: Maybe<Scalars['Void']['output']>;
  updateProductsRetailPrice?: Maybe<Scalars['Void']['output']>;
  updateProductsReturnEligibility?: Maybe<Scalars['Void']['output']>;
  updateProductsShippingCost?: Maybe<Scalars['Void']['output']>;
  updateProductsVatMargin?: Maybe<Scalars['Void']['output']>;
  updateProfilePicture?: Maybe<Scalars['Boolean']['output']>;
  updateSale?: Maybe<Scalars['String']['output']>;
  /** **Batch update of references (sku or gtin) for a specific sale** */
  updateStocksByRef: Array<VariantUpdated>;
  /** **Batch update of references (sku or gtin) for a specific sale** */
  updateVariantsByRef: Array<VariantUpdated>;
  /** Upsert the immersive sales for a store */
  upsertImmersiveSale: ImmersiveSaleReturn;
  /** Upsert the next immersive sales for a store */
  upsertNextImmersiveSale: NextImmersiveSaleReturn;
  /**
   * Replace the filters and shortcuts configuration of a sale.
   * The whole configuration is replaced: a sale holds at most one of them.
   */
  upsertSaleFiltersConfig: SaleFiltersConfigReturn;
  /**
   * Create or replace the content of the spotlight configuration of a sale, keeping its status.
   * The whole content is replaced: a sale holds at most one configuration, and the rank schedule
   * is entirely swapped for the one sent.
   * A new configuration starts as a `draft`, which can be saved incomplete. Editing a `published`
   * one is validated as strictly as publishing it.
   */
  upsertSpotlightConfig: SpotlightConfigReturn;
  validateAIFormattedProductDescriptions: Scalars['Int']['output'];
  validateProductCheckSpelling: Scalars['Boolean']['output'];
};


export type MutationAddImagesToProductsArgs = {
  images: Array<Scalars['String']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationAddLinkedProductsArgs = {
  metadata?: InputMaybe<LinkedProductsMetadataInput>;
  products: Array<LinkedProductsInput>;
};


export type MutationAddProductCouponsV2Args = {
  codes: Array<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationAddProductToCollectionArgs = {
  collectionSaleId: Scalars['ID']['input'];
  filters: Array<CustomFilterInput>;
  isBestseller: Scalars['Boolean']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAddProductsBadgesArgs = {
  badges: Array<ProductBadgeInput>;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationAddSizeGuidesToProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  sizeGuides: Array<Scalars['String']['input']>;
};


export type MutationAddTextToProductsDescriptionArgs = {
  payload: AddTextPayload;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationAddTextToProductsNameArgs = {
  payload: AddTextPayload;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationAlignBottomImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationAlignTopImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationChangeProductColorToOptionArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationChangeProductOptionToColorArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCheckPricesWithAiArgs = {
  saleId: Scalars['String']['input'];
};


export type MutationCopyBrandV2Args = {
  brandIdFrom: Scalars['String']['input'];
  brandIdTo: Scalars['String']['input'];
  params: CopyBrandParams;
};


export type MutationCopyProductV2Args = {
  keepImages: Scalars['Boolean']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationCopyProductsV2Args = {
  params: CopyProductsParams;
  saleIdFrom: Scalars['String']['input'];
  saleIdTo: Scalars['String']['input'];
};


export type MutationCopyProductsV3Args = {
  params: Array<CopyProductsV3Param>;
  saleIdTo: Scalars['String']['input'];
};


export type MutationCopySaleArgs = {
  saleId: Scalars['String']['input'];
};


export type MutationCopySaleV2Args = {
  params: CopySaleParams;
  saleIdFrom: Scalars['String']['input'];
  saleIdTo: Scalars['String']['input'];
};


export type MutationCrawlDriveImagesArgs = {
  urlData: Array<CrawlDriveUrlDataInput>;
};


export type MutationCrawlProductsArgs = {
  saleId: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']>;
};


export type MutationCreateDurationWidgetArgs = {
  saleId: Scalars['String']['input'];
};


export type MutationCreateLogisticFileArgs = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
};


export type MutationCreateProductArgs = {
  data: Scalars['Json']['input'];
};


export type MutationCreateSaleCustomFilterArgs = {
  input: CreateSaleCustomFilterInput;
};


export type MutationCreateShopifyTestOrderArgs = {
  input: ShopifyTestOrderInput;
};


export type MutationCreateUploadUrlsArgs = {
  input: Array<UploadUrlInput>;
};


export type MutationCropBelowFacesImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationDeleteDealToCalendarArgs = {
  dataKey?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSaleCustomFilterArgs = {
  filterId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
};


export type MutationDismissProductCheckArgs = {
  checkId: Scalars['ID']['input'];
};


export type MutationExtendImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationFillImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationFitImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationFormatProductsDescriptionArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationFormatProductsWithAiArgs = {
  input: AiProductsInput;
};


export type MutationGenerateImmersiveCatchlinesArgs = {
  saleId: Scalars['ID']['input'];
  type: ImmersiveCatchlineType;
};


export type MutationGenerateSpotlightVideoThumbnailArgs = {
  saleId: Scalars['ID']['input'];
  videoKey: Scalars['String']['input'];
};


export type MutationHideOutOfStockProductsAndVariantsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationImportProductsArgs = {
  csvContent?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkSaleTrackingsAsDeliveredArgs = {
  filters: MarkSaleTrackingsAsDeliveredFilter;
  saleId: Scalars['String']['input'];
};


export type MutationMoveProductsToPositionArgs = {
  productIds: Array<Scalars['ID']['input']>;
  saleId: Scalars['String']['input'];
  startPosition: Scalars['Int']['input'];
};


export type MutationNewAddImageArgs = {
  image: ImageData;
  upload: Scalars['Upload']['input'];
};


export type MutationPreviewImageArgs = {
  image: TransformImageData;
};


export type MutationProcessProductAudioArgs = {
  input: ProcessProductAudioInput;
};


export type MutationProcessProductVideoArgs = {
  input: ProcessProductVideoInput;
};


export type MutationPublishProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationPublishSpotlightConfigArgs = {
  saleId: Scalars['ID']['input'];
};


export type MutationReferenceProductsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveBackgroundImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationRemoveCouponArgs = {
  couponId: Scalars['Int']['input'];
};


export type MutationRemoveGtinsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveImmersiveSaleArgs = {
  immersiveId: Scalars['String']['input'];
};


export type MutationRemoveImmersiveSaleNextArgs = {
  nextImmersiveId: Scalars['String']['input'];
};


export type MutationRemoveProductCouponsArgs = {
  productId: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type MutationRemoveProductFromCollectionArgs = {
  collectionSaleId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationRemoveProductsArgs = {
  productsIds: Array<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
};


export type MutationRemoveProductsBadgesArgs = {
  badges: Array<ProductBadgeInput>;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveProductsImagesArgs = {
  imageIds: Array<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveProductsShopifyVariantIdsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveProductsSizeGuideArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveProductsVariantsImagesArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveSaleArgs = {
  saleId: Scalars['String']['input'];
};


export type MutationRemoveSaleFiltersConfigArgs = {
  saleId: Scalars['ID']['input'];
};


export type MutationRemoveShopifyPluginArgs = {
  sellerId: Scalars['ID']['input'];
};


export type MutationRemoveSkusArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveWidgetArgs = {
  id: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
};


export type MutationRenameSaleCustomFilterArgs = {
  input: RenameSaleCustomFilterInput;
};


export type MutationRenameSaleCustomFilterOptionArgs = {
  input: RenameSaleCustomFilterOptionInput;
};


export type MutationReorderSaleCustomFilterOptionsArgs = {
  input: ReorderSaleCustomFilterOptionsInput;
};


export type MutationReplaceProductsDescriptionArgs = {
  payload: Array<ReplacePayload>;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationReplaceProductsNameArgs = {
  payload: Array<ReplacePayload>;
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationReplaceSaleCustomFilterContentArgs = {
  input: ReplaceSaleCustomFilterContentInput;
};


export type MutationSaveImageArgs = {
  data: SaveImage;
};


export type MutationSaveImagesArgs = {
  actionId: Scalars['ID']['input'];
  images: Array<ImageInput>;
  options?: InputMaybe<SaveImagesOptions>;
  sessionId: Scalars['ID']['input'];
};


export type MutationSendMarketingEmailArgs = {
  type?: InputMaybe<MarketingType>;
  url: Scalars['String']['input'];
  userAliasId: UserAliasBraze;
  userEmail: Scalars['String']['input'];
};


export type MutationSendOnboardingEmailArgs = {
  brandId: Scalars['String']['input'];
};


export type MutationSetProductAsBestSellerArgs = {
  isBestSeller: Scalars['Boolean']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetProductAsCoverArgs = {
  isCover: Scalars['Boolean']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetProductHighlightedAsNewArgs = {
  isHighlightedAsNew: Scalars['Boolean']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationSetProductsAsUniqueArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationSetProductsHideArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationSetSaleReadyArgs = {
  checkBy: Scalars['String']['input'];
  previewEmailInfoText?: InputMaybe<Scalars['String']['input']>;
  previewEmailText?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
};


export type MutationSetSetupReadyArgs = {
  comments?: InputMaybe<Scalars['String']['input']>;
  difficulty: DifficultySetupLevel;
  reasons: Array<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
  timeRange: TimeRange;
};


export type MutationSetSetupWaitingForElementsArgs = {
  comments?: InputMaybe<Scalars['String']['input']>;
  reasons: Array<SetupWaitingReason>;
  saleId: Scalars['String']['input'];
};


export type MutationSetShopifyStockProtectionArgs = {
  protect: Scalars['Boolean']['input'];
  sellerId: Scalars['ID']['input'];
};


export type MutationSetUserAdminArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  userEmail: Scalars['String']['input'];
};


export type MutationShowHiddenProductsAndVariantsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationShuffleProductListArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationStartCrossSellingsPreviewArgs = {
  intent?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['ID']['input'];
};


export type MutationSyncPendingShopifyOrdersArgs = {
  isDryRun: Scalars['Boolean']['input'];
  saleId?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncShopifyStockArgs = {
  brandId: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
};


export type MutationTranslateProductsWithAiArgs = {
  input: AiProductsInput;
};


export type MutationTriggerProductQualityCheckArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationUnpublishSpotlightConfigArgs = {
  saleId: Scalars['ID']['input'];
};


export type MutationUpdateAccentuateReferralArgs = {
  data: AccentuateReferralInput;
};


export type MutationUpdateBrandArgs = {
  data?: InputMaybe<BrandUpdate>;
};


export type MutationUpdateCouponArgs = {
  data: CouponUpdate;
};


export type MutationUpdateDealKeyArgs = {
  data?: InputMaybe<Scalars['Json']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateInvoiceArgs = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  saleId: Scalars['String']['input'];
};


export type MutationUpdateManyProductArgs = {
  data: Array<UpdateProductManyInput>;
};


export type MutationUpdateManyProductCouponArgs = {
  data: Array<UpdateProductCouponManyInput>;
};


export type MutationUpdateManyProductOptionsArgs = {
  data: Array<UpdateProductOptionManyInput>;
  saleId: Scalars['String']['input'];
};


export type MutationUpdateProductV4Args = {
  data: ProductUpdateInputV3;
};


export type MutationUpdateProductsBuyingPriceArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Float']['input'];
};


export type MutationUpdateProductsCategoryArgs = {
  category: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateProductsCouponExpiresAtArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['LocalDate']['input'];
};


export type MutationUpdateProductsDeliveryArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationUpdateProductsGenderArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Int']['input'];
};


export type MutationUpdateProductsOriginCountryArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};


export type MutationUpdateProductsRetailPriceArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Int']['input'];
};


export type MutationUpdateProductsReturnEligibilityArgs = {
  isReturnable: Scalars['Boolean']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateProductsShippingCostArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Float']['input'];
};


export type MutationUpdateProductsVatMarginArgs = {
  productIds: Array<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationUpdateProfilePictureArgs = {
  url: Scalars['String']['input'];
};


export type MutationUpdateSaleArgs = {
  brandNameChanged?: InputMaybe<Scalars['Boolean']['input']>;
  sale: SaleInput;
  skipReadyTrigger?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateStocksByRefArgs = {
  saleId: Scalars['String']['input'];
  stocks: Array<StockUpdateByRef>;
};


export type MutationUpdateVariantsByRefArgs = {
  saleId: Scalars['String']['input'];
  variants: Array<VariantUpdateByRef>;
};


export type MutationUpsertImmersiveSaleArgs = {
  immersiveSale: ImmersiveSaleInput;
};


export type MutationUpsertNextImmersiveSaleArgs = {
  nextImmersiveSale: NextImmersiveSaleInput;
};


export type MutationUpsertSaleFiltersConfigArgs = {
  input: SaleFiltersConfigInput;
};


export type MutationUpsertSpotlightConfigArgs = {
  input: SpotlightConfigInput;
};


export type MutationValidateAiFormattedProductDescriptionsArgs = {
  input: ValidateAiFormattedProductDescriptionsInput;
};


export type MutationValidateProductCheckSpellingArgs = {
  checkId: Scalars['ID']['input'];
};

export type NextImmersiveSale = {
  __typename?: 'NextImmersiveSale';
  brandLogoUrl?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTranslationKey?: Maybe<Scalars['String']['output']>;
  displayFromDayOffset: Scalars['Int']['output'];
  endAt: Scalars['LocalDate']['output'];
  forceFirstPositionDates: Array<Scalars['LocalDate']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  preTeasingDates?: Maybe<Array<PreTeasingDate>>;
  saleId: Scalars['String']['output'];
  saleStartAt: Scalars['DateTime']['output'];
  startAt: Scalars['LocalDate']['output'];
  status: SaleImmersiveNextStatus;
  universeIds: Array<Maybe<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type NextImmersiveSaleInput = {
  /** Source keys returned by createUploadUrls. Stickers are not accepted for teasings. */
  assets?: InputMaybe<ImmersiveSaleAssetsInput>;
  /** Description displayed on the app */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display from day offset */
  displayFromDayOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Days on which this teasing must be displayed first. Every day must belong to its display period. */
  forceFirstPositionDates?: InputMaybe<Array<Scalars['LocalDate']['input']>>;
  /** Id of the next immersive sale to update. If not provided, a new next immersive sale is created for the sale. */
  immersiveSaleNextId?: InputMaybe<Scalars['String']['input']>;
  /** Pre-teasing dates of the next immersive sale */
  preTeasingDates: Array<InputMaybe<PreTeasingDateInput>>;
  /** Id of the next immersive sale */
  saleId: Scalars['String']['input'];
  /** Status of the next immersive sale. if not provided, it will be set to draft or pending */
  status?: InputMaybe<SaleImmersiveNextStatus>;
  /** Universes linked to the next immersive sale. If empty, the next immersive sale will be linked to all universes. */
  universeIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type NextImmersiveSaleReturn = DomainException | NextImmersiveSale;

/** **Pickup point network** */
export enum PickupPointNetwork {
  /** **Colissimo** */
  Colissimo = 'COLISSIMO',
  /** **Mondial relay** */
  MondialRelay = 'MONDIAL_RELAY',
  /** **Shop 2 shop** */
  Shop2Shop = 'SHOP2SHOP'
}

export type Plugins = {
  __typename?: 'Plugins';
  shopify?: Maybe<Scalars['Json']['output']>;
};

export enum PointRelais {
  MondialRelay = 'mondial_relay',
  Shop2shop = 'shop2shop'
}

export type PreTeasingDate = {
  __typename?: 'PreTeasingDate';
  endAt: Scalars['LocalDate']['output'];
  startAt: Scalars['LocalDate']['output'];
};

export type PreTeasingDateInput = {
  /** End date of the pre-teasing date (YYYY-MM-DD) */
  endAt: Scalars['String']['input'];
  /** Start date of the pre-teasing date (YYYY-MM-DD) */
  startAt: Scalars['String']['input'];
};

export type Preview = {
  __typename?: 'Preview';
  baseKey: Scalars['String']['output'];
  full?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
};

export type PreviewPropertie = {
  id: Scalars['String']['input'];
  properties?: InputMaybe<PreviewProperties>;
};

export type PreviewProperties = {
  full?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessProductAudioInput = {
  productId: Scalars['ID']['input'];
  /** Key of the source file uploaded through createUploadUrls(PRODUCT_AUDIO) */
  sourceAudioKey: Scalars['String']['input'];
};

export type ProcessProductAudioResult = {
  __typename?: 'ProcessProductAudioResult';
  /** Public URL of the transcoded audio (AAC 64 kbps mono, .m4a), to persist with updateProductV4 */
  audioUrl: Scalars['String']['output'];
};

export type ProcessProductVideoInput = {
  productId: Scalars['ID']['input'];
  removeAudio: Scalars['Boolean']['input'];
  sourceVideoKey: Scalars['String']['input'];
};

export type ProcessProductVideoResult = {
  __typename?: 'ProcessProductVideoResult';
  videoUrl: Scalars['String']['output'];
};

export type ProductAudio = {
  __typename?: 'ProductAudio';
  /** Short caption displayed under the heading, e.g. "Chapitre 1". */
  label?: Maybe<Scalars['String']['output']>;
  /** Heading displayed above the player. Null lets the app use its default wording. */
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProductAudioInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** *** Represent the badges of a product (ie: Made in XXX, vegan, ...) */
export type ProductBadge = {
  __typename?: 'ProductBadge';
  isSpecial: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type ProductBadgeInput = {
  /** is this badge special */
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  /** position of said badge */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Badge label */
  value: Scalars['String']['input'];
};

export type ProductBrand = {
  __typename?: 'ProductBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProductCampaign = {
  __typename?: 'ProductCampaign';
  endAt: Scalars['DateTime']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  name: Scalars['String']['output'];
  vat: Scalars['Float']['output'];
};

export type ProductCheckData = CoherenceCheckData | DeprecatedDescriptionCheckData | InformationCheckData | PublicPriceCheckData | SizesCheckData | SpellingCheckData;

export enum ProductCheckSeverity {
  Critical = 'CRITICAL',
  Important = 'IMPORTANT',
  Warning = 'WARNING'
}

export type ProductCheckStatus = {
  __typename?: 'ProductCheckStatus';
  checkType: ProductCheckType;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<ProductCheckData>;
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  dismissedBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  severity?: Maybe<ProductCheckSeverity>;
  status: ProductCheckStatusValue;
  updatedAt: Scalars['DateTime']['output'];
  variantId?: Maybe<Scalars['ID']['output']>;
};

export enum ProductCheckStatusValue {
  Error = 'ERROR',
  Passed = 'PASSED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Warning = 'WARNING'
}

export enum ProductCheckType {
  /** @deprecated in favor of SPELLING and COHERENCE */
  Description = 'DESCRIPTION',
  DescriptionCoherence = 'DESCRIPTION_COHERENCE',
  DescriptionSpelling = 'DESCRIPTION_SPELLING',
  HistoryPrice = 'HISTORY_PRICE',
  Informations = 'INFORMATIONS',
  PublicPrice = 'PUBLIC_PRICE',
  Sizes = 'SIZES',
  Title = 'TITLE',
  Tva = 'TVA',
  UnitPrice = 'UNIT_PRICE',
  Warranties = 'WARRANTIES',
  WrongBarcode = 'WRONG_BARCODE',
  WrongShopifyVariantId = 'WRONG_SHOPIFY_VARIANT_ID'
}

export type ProductCoupon = {
  __typename?: 'ProductCoupon';
  code: Scalars['String']['output'];
  order_id?: Maybe<Scalars['String']['output']>;
  product_id: Scalars['String']['output'];
  variant_id?: Maybe<Scalars['String']['output']>;
};

export type ProductCouponsV2 = {
  __typename?: 'ProductCouponsV2';
  boughtCodes: Scalars['Int']['output'];
  codes: Array<ProductCoupon>;
  total: Scalars['Int']['output'];
};

export type ProductCustomFilter = {
  __typename?: 'ProductCustomFilter';
  filterId: Scalars['ID']['output'];
  selectedValues: Array<Scalars['String']['output']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  aspect?: Maybe<ImageAspect>;
  currentVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isCover: Scalars['Boolean']['output'];
  isOriginal: Scalars['Boolean']['output'];
  isVariantCover: Scalars['Boolean']['output'];
  originalUrl: Scalars['URL']['output'];
  productId: Scalars['ID']['output'];
  url: Scalars['URL']['output'];
};

export type ProductInCollection = {
  __typename?: 'ProductInCollection';
  collectionSaleId: Scalars['ID']['output'];
  customFilters: Array<ProductCustomFilter>;
  isBestseller: Scalars['Boolean']['output'];
};

export type ProductOptionError = {
  __typename?: 'ProductOptionError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type ProductOptionInput = {
  /** Product option id */
  id: Scalars['ID']['input'];
  /** Product option images */
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Product option name */
  name: Scalars['String']['input'];
  /** Product option position */
  position: Scalars['Int']['input'];
  /** Product option type */
  type: Scalars['String']['input'];
  /** Product option values */
  values: Array<ProductOptionValueInput>;
};

export type ProductOptionV3 = {
  __typename?: 'ProductOptionV3';
  /** Product option id */
  id: Scalars['ID']['output'];
  /** Product option images */
  images?: Maybe<Array<Image>>;
  /** Product option name */
  name: Scalars['String']['output'];
  /** Product option position */
  position: Scalars['Int']['output'];
  /** Product option type */
  type?: Maybe<Scalars['String']['output']>;
  /** Product option values */
  values: Array<ProductOptionValueV2>;
};

export type ProductOptionValueInput = {
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductOptionValueV2 = {
  __typename?: 'ProductOptionValueV2';
  /** Product option value id */
  id: Scalars['ID']['output'];
  /** Product option value position. */
  position: Scalars['Int']['output'];
  /** Product option value displayed value. ie: blue when the main option is color */
  value: Scalars['String']['output'];
};

export enum ProductType {
  Coupon = 'coupon',
  Object = 'object'
}

export type ProductUpdateInputV3 = {
  audio?: InputMaybe<ProductAudioInput>;
  badges: Array<ProductBadgeInput>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  category: Scalars['String']['input'];
  cgu?: InputMaybe<Array<Scalars['String']['input']>>;
  couponExpireAt?: InputMaybe<Scalars['LocalDate']['input']>;
  couponOffer?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<Array<Scalars['String']['input']>>;
  faqAfterOrder?: InputMaybe<Scalars['String']['input']>;
  faqBeforeOrder?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  hasVatMargin: Scalars['Boolean']['input'];
  hide: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  isCobrand?: InputMaybe<Scalars['Boolean']['input']>;
  isCobrandFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredByChoose?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft: Scalars['Boolean']['input'];
  isReturnable?: InputMaybe<Scalars['Boolean']['input']>;
  modelSizeInfos?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<ProductOptionInput>>;
  sizeAdvices?: InputMaybe<Scalars['String']['input']>;
  variants: Array<VariantToUpsert>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type ProductV3 = {
  __typename?: 'ProductV3';
  audio?: Maybe<ProductAudio>;
  badges: Array<ProductBadge>;
  brand: ProductBrand;
  campaign?: Maybe<ProductCampaign>;
  category?: Maybe<ProductCategory>;
  cgu?: Maybe<Array<Scalars['String']['output']>>;
  couponDetail?: Maybe<Scalars['String']['output']>;
  couponExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: StoreCurrency;
  customFields?: Maybe<Array<CustomField>>;
  description?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<Array<Scalars['String']['output']>>;
  faqPostOrder?: Maybe<Scalars['String']['output']>;
  faqPreOrder?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  hasVatMargin: Scalars['Boolean']['output'];
  hide: Scalars['Boolean']['output'];
  hideAt?: Maybe<Scalars['DateTime']['output']>;
  hideBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Image>>;
  importCsvPosition?: Maybe<Scalars['Int']['output']>;
  inCollections: Array<ProductInCollection>;
  isAlcohol?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when this product is highlighted as a best seller in its own sale.
   * Collection sales use their own product-level selection instead.
   */
  isBestSeller: Scalars['Boolean']['output'];
  isCobrand: Scalars['Boolean']['output'];
  isCobrandFeatured: Scalars['Boolean']['output'];
  /** True when this product is the cover product of its sale. */
  isCover: Scalars['Boolean']['output'];
  isDeliveredByChoose?: Maybe<Scalars['Boolean']['output']>;
  isDraft: Scalars['Boolean']['output'];
  isGiveaway: Scalars['Boolean']['output'];
  /** True when this product is highlighted as new. */
  isHighlightedAsNew: Scalars['Boolean']['output'];
  isReturnable: Scalars['Boolean']['output'];
  /** Saved, directional cross-selling links originating from this product. */
  linkedProducts: Array<LinkedProduct>;
  modelSizeInfos?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Product options */
  options?: Maybe<Array<ProductOptionV3>>;
  position?: Maybe<Scalars['Int']['output']>;
  readonlyFilters?: Maybe<Array<ProductCustomFilter>>;
  sizeAdvices?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  type: ProductType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Product variants */
  variants: Array<ProductVariantV2>;
  video?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantOptionInput = {
  optionId: Scalars['ID']['input'];
  valueId: Scalars['ID']['input'];
};

export type ProductVariantOptionV2 = {
  __typename?: 'ProductVariantOptionV2';
  /** Id refering to a product option */
  productOptionId: Scalars['String']['output'];
  /** id of a production option value */
  valueId: Scalars['String']['output'];
};

export type ProductVariantV2 = {
  __typename?: 'ProductVariantV2';
  /** @deprecated not used anymore */
  absorbedShipping?: Maybe<Scalars['Int']['output']>;
  /** Product variant price choose pay */
  buyingPrice?: Maybe<Scalars['Int']['output']>;
  /** Choose fees */
  chooseFees?: Maybe<Scalars['Int']['output']>;
  /** Time computed for the product to be shipped (based on product.delivery and sale.delivery) */
  computedDeliveryDelays?: Maybe<Scalars['Int']['output']>;
  /** Custom filters associated to the variant */
  customFilters: Array<ProductCustomFilter>;
  /** Time set for the product to be shipped */
  deliveryDelays?: Maybe<Scalars['Int']['output']>;
  /** discount percentage express as thousand. ie: 20% = 2000 */
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  /** Eco tax for the product */
  eeePrice?: Maybe<Scalars['Int']['output']>;
  /** Product variant gtin */
  gtin?: Maybe<Scalars['String']['output']>;
  /** height of the product in millimeters */
  heightMillimeter?: Maybe<Scalars['Int']['output']>;
  /** TBD */
  hide: Scalars['Boolean']['output'];
  /** If the variant is hidden, this is the date it was hidden */
  hideAt?: Maybe<Scalars['DateTime']['output']>;
  /** If the variant is hidden, this is the user who hid it */
  hideBy?: Maybe<Scalars['String']['output']>;
  /** Product variant id */
  id: Scalars['ID']['output'];
  /** Product variant images */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** is the variant unique */
  isUnique: Scalars['Boolean']['output'];
  /** length of the product in millimeters */
  lengthMillimeter?: Maybe<Scalars['Int']['output']>;
  /** Product variant options */
  options: Array<ProductVariantOptionV2>;
  /** where the variant is made */
  originCountry?: Maybe<Scalars['String']['output']>;
  /** Product variant position */
  position?: Maybe<Scalars['Int']['output']>;
  /** Product variant price (includes tax depending on the store) */
  price?: Maybe<Scalars['Int']['output']>;
  /** Reference of the variant (POC) */
  reference?: Maybe<CatalogItemReference>;
  /** Product variant retail price (public price) */
  retailPrice?: Maybe<Scalars['Int']['output']>;
  /** Fees to ship */
  shippingFees?: Maybe<Scalars['Int']['output']>;
  /** Shopify variant id */
  shopify_variant_id?: Maybe<Scalars['String']['output']>;
  /** Product variant sku */
  sku?: Maybe<Scalars['String']['output']>;
  /** Product variant stock count. If null means there is unlimited stock */
  stockCount?: Maybe<Scalars['Int']['output']>;
  /** Number of units per pack for purchase by Choose. Used to generate the purchase orders */
  unitsPerPack?: Maybe<Scalars['Int']['output']>;
  /** weight of the product in gramms */
  weightGram?: Maybe<Scalars['Int']['output']>;
  /** width of the product in millimeters */
  widthMillimeter?: Maybe<Scalars['Int']['output']>;
  /** Yuka nutritional/cosmetics score (0-100) */
  yukaRate?: Maybe<Scalars['Int']['output']>;
};

/** **Provisional sale (a sale that is still in negociation)** */
export type ProvisionalSale = {
  __typename?: 'ProvisionalSale';
  /** Does the brand have a shopify ? */
  brandHasShopify?: Maybe<Scalars['Boolean']['output']>;
  /**
   * **Count of sales for the brand**
   *
   * - > null if brand hubspot id is not present
   */
  brandSaleCount?: Maybe<Scalars['Int']['output']>;
  /**
   * **Cancellation level of the sale**
   *
   * - > high
   */
  cancellationLevel?: Maybe<Scalars['String']['output']>;
  /** **Category of the sale** */
  category?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  deal?: Maybe<Deal>;
  forecast?: Maybe<Scalars['Int']['output']>;
  /**
   * **Gender of the sale**
   *
   * - > 0 => female
   * - > 1 => male
   * - > 2 => unisex
   */
  gender?: Maybe<Scalars['Int']['output']>;
  /** **Hubspot category of the sale** */
  hubspotCategory?: Maybe<Scalars['String']['output']>;
  /** **Hubspot ID of the sale** */
  hubspotId?: Maybe<Scalars['ID']['output']>;
  hubspot_demande_point_relais?: Maybe<PointRelais>;
  hubspot_team_name?: Maybe<TeamName>;
  hubspot_tiering?: Maybe<Tiering>;
  hubspot_top_brand_type?: Maybe<TopBrandType>;
  /** **ID of the sale** */
  id: Scalars['ID']['output'];
  /** **Instagram ID of the sale (or brand)** */
  instagramId?: Maybe<Scalars['String']['output']>;
  /** **Name of the sale** */
  name: Scalars['String']['output'];
  /** **Note of the sale (text for choose members)** */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * **Operation type of the sale**
   *
   * - > dropshipping
   * - > firm_purchase
   * - > post_operation_purchase
   * - > reseller
   * - > clearance
   */
  operationType?: Maybe<Scalars['String']['output']>;
  /** **Name of the Choose sale team member assigned to the sale** */
  saleBy?: Maybe<Scalars['String']['output']>;
  shopify?: Maybe<ShopifyData>;
  /** **Date when the sale should start** */
  startsAt: Scalars['DateTime']['output'];
  /** **Website URL of the sale (or brand)** */
  website?: Maybe<Scalars['String']['output']>;
};

export type PublicPriceCheckData = {
  __typename?: 'PublicPriceCheckData';
  choose_discount_price?: Maybe<Scalars['Float']['output']>;
  choose_price?: Maybe<Scalars['Float']['output']>;
  shopify_discount_price?: Maybe<Scalars['Float']['output']>;
  shopify_price?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** *** Get all the badges sorted for the selected region */
  badges: Array<BadgeSvg>;
  brand?: Maybe<Brand>;
  /**
   * Optimized query for the admin calendar view.
   * Only returns the fields used by the calendar, skipping heavy sub-resolvers
   * (giveaway policies, translations, images pipeline, widgets, invoices, etc.)
   */
  calendarSales: CalendarSalesResult;
  categories: Array<Category>;
  /** **Get the category's essential options** */
  categoryEssentialOptions: Array<CategoryOption>;
  /** **Get the category's options** */
  categoryOptions: Array<CategoryOption>;
  /** **Get the categories and their sub categories as a tree list** */
  categoryTree: Array<CategoryTree>;
  coupons: Array<Coupon>;
  /** **Get the PDF of an oder. If forBrand is set we only get the order without credit/cash options, often useful for Brands and shipments ** */
  createInvoice?: Maybe<Scalars['String']['output']>;
  /** A Jev cross-selling preview session, to resume following it; null once it has expired from storage (2 hours). */
  crossSellingPreviewSession?: Maybe<CrossSellingPreviewSession>;
  crossSellings: Array<CrossSelling>;
  getImagesByProductIds: Array<ProductImage>;
  getProductCouponsV2: ProductCouponsV2;
  getSetupIssues: Array<SetupIssue>;
  getUploadUrl?: Maybe<Scalars['Json']['output']>;
  makePublicFile?: Maybe<Scalars['Json']['output']>;
  /** *** */
  marketing: MarketingQueries;
  nextCollectionSale?: Maybe<CollectionSale>;
  /** Get one product */
  product: ProductV3;
  /** Get quality check statuses for a product */
  productCheckStatuses: Array<ProductCheckStatus>;
  /** **Get provisional sales** */
  provisionalSales: Array<ProvisionalSale>;
  sale?: Maybe<Sale>;
  /**
   * Filters the app builds for a sale, to configure its filters and shortcuts.
   *
   * A root query rather than a field on Sale: answering it loads every product of the sale, which
   * would be multiplied by each item of a sale list.
   */
  saleAppFilters?: Maybe<SaleAppFilters>;
  /**
   * The custom filters of a sale as entities, empty shells included with their volumes — unlike
   * saleAppFilters.displayed, which keeps reporting only what the app can actually show.
   */
  saleCustomFilters: Array<SaleCustomFilter>;
  saleProductCheckCount: SaleProductCheckCount;
  /** Get quality check statuses for all products in a sale */
  saleProductCheckStatuses: Array<ProductCheckStatus>;
  sales?: Maybe<SalesCache>;
  salesCount?: Maybe<Array<Maybe<SaleCount>>>;
  searchBrand: Array<Brand>;
  searchSalesV2: SalesElasticSearch;
  shopify: ShopifyQueries;
  /** The editorial spotlight configuration of a sale. Null when the sale has none yet. */
  spotlightConfig?: Maybe<SpotlightConfig>;
  users: Array<User>;
};


export type QueryBadgesArgs = {
  storeId: StoreRegion;
};


export type QueryBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalendarSalesArgs = {
  status: SaleStatus;
  storeId: StoreRegion;
};


export type QueryCategoryEssentialOptionsArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryCategoryOptionsArgs = {
  categoryId: Scalars['String']['input'];
};


export type QueryCouponsArgs = {
  status: CouponStatus;
  store_id?: InputMaybe<StoreRegion>;
};


export type QueryCreateInvoiceArgs = {
  forBrand?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['String']['input'];
};


export type QueryCrossSellingPreviewSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryCrossSellingsArgs = {
  forceModel?: InputMaybe<Scalars['String']['input']>;
  onlyWithHistory?: InputMaybe<Scalars['Boolean']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type QueryGetImagesByProductIdsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type QueryGetProductCouponsV2Args = {
  count: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetUploadUrlArgs = {
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  saleId: Scalars['String']['input'];
  uploadType: FileUploadType;
};


export type QueryMakePublicFileArgs = {
  url: Scalars['String']['input'];
};


export type QueryProductArgs = {
  productId: Scalars['String']['input'];
};


export type QueryProductCheckStatusesArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProvisionalSalesArgs = {
  storeId: StoreRegion;
};


export type QuerySaleArgs = {
  key: Scalars['String']['input'];
};


export type QuerySaleAppFiltersArgs = {
  saleId: Scalars['ID']['input'];
};


export type QuerySaleCustomFiltersArgs = {
  saleId: Scalars['ID']['input'];
};


export type QuerySaleProductCheckCountArgs = {
  saleId: Scalars['ID']['input'];
};


export type QuerySaleProductCheckStatusesArgs = {
  saleId: Scalars['ID']['input'];
};


export type QuerySalesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  status: SaleStatus;
  storeId: StoreRegion;
};


export type QuerySalesCountArgs = {
  storeId: StoreRegion;
};


export type QuerySearchBrandArgs = {
  name: Scalars['String']['input'];
};


export type QuerySearchSalesV2Args = {
  limit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  store: StoreRegion;
};


export type QuerySpotlightConfigArgs = {
  saleId: Scalars['ID']['input'];
};

export type RenameSaleCustomFilterInput = {
  filterId: Scalars['ID']['input'];
  /** Trimmed, non empty, unique among the custom filters of the sale */
  name: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
};

export type RenameSaleCustomFilterOptionInput = {
  filterId: Scalars['ID']['input'];
  /**
   * Trimmed, non empty. Refused when another option of the filter already displays that label (no
   * silent merge).
   */
  newName: Scalars['String']['input'];
  /**
   * Value of the option to rename (`SaleCustomFilterOption.value`), not its current label: only
   * the display label changes, so a later re-import of the same file keeps the new one.
   */
  option: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
};

export type ReorderSaleCustomFilterOptionsInput = {
  filterId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  /**
   * The whole option set of the filter, in the wanted order: every `SaleCustomFilterOption.value`
   * exactly once. Positions are rewritten 0..n-1 along it.
   */
  values: Array<Scalars['String']['input']>;
};

export type ReplacePayload = {
  new: Scalars['String']['input'];
  old: Scalars['String']['input'];
};

export type ReplaceSaleCustomFilterContentInput = {
  entries: Array<SaleCustomFilterEntryInput>;
  filterId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
};

export type Sale = {
  __typename?: 'Sale';
  ads?: Maybe<Array<Maybe<Ad>>>;
  badges?: Maybe<Scalars['Json']['output']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['String']['output']>;
  brand_name?: Maybe<Scalars['String']['output']>;
  cancellation_level?: Maybe<Scalars['String']['output']>;
  cashbackPolicy?: Maybe<CashbackPolicy>;
  /** @deprecated use hubspot_category instead */
  categorie_choose?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  category_choose?: Maybe<Scalars['String']['output']>;
  collectionSale?: Maybe<CollectionSale>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<StoreCurrency>;
  customFilters: Array<CustomFilter>;
  deal?: Maybe<Deal>;
  deliver_by_choose?: Maybe<Scalars['Boolean']['output']>;
  delivery_delays?: Maybe<Scalars['Int']['output']>;
  delivery_offered_until?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disable_automatic_extension?: Maybe<Scalars['Boolean']['output']>;
  disable_sorting?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use on the homepage */
  discount?: Maybe<Scalars['Float']['output']>;
  /** If the sale is the origin of duplicated sales, this field will contain the last duplicated sale id */
  duplicated_sale_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated use end_at_date */
  end_at: Scalars['DateTime']['output'];
  end_at_date: Scalars['LocalDate']['output'];
  /** Filters and shortcuts configuration. Null when the sale uses the default filter behaviour. */
  filtersConfig?: Maybe<SaleFiltersConfig>;
  forecast?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  /**
   * Giveaway policies for the sale.
   * Every policy configured on the sale is returned, including those whose date range has expired.
   */
  giveawayPolicies: Array<GiveawaySalePolicy>;
  hasDescription: Scalars['Boolean']['output'];
  hasHeader: Scalars['Boolean']['output'];
  hasPreviews: Scalars['Boolean']['output'];
  /**
   * True if at least one product for sale can be returned within the 14-day
   * withdrawal period.
   */
  hasReturnableProducts: Scalars['Boolean']['output'];
  has_orders?: Maybe<Scalars['Boolean']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  hubspot_campaign_type?: Maybe<CampaignType>;
  hubspot_category?: Maybe<Scalars['String']['output']>;
  hubspot_deal_id?: Maybe<Scalars['String']['output']>;
  hubspot_demande_point_relais?: Maybe<PointRelais>;
  hubspot_selection_id?: Maybe<Scalars['String']['output']>;
  hubspot_team_name?: Maybe<TeamName>;
  hubspot_tiering?: Maybe<Tiering>;
  hubspot_top_brand_type?: Maybe<TopBrandType>;
  id: Scalars['String']['output'];
  image_header?: Maybe<Scalars['String']['output']>;
  initial_start_at?: Maybe<Scalars['DateTime']['output']>;
  invoice?: Maybe<Invoice>;
  /** @deprecated use collectionSale instead */
  isCollectionSale: Scalars['Boolean']['output'];
  isShopify?: Maybe<Scalars['Boolean']['output']>;
  is_cancelled?: Maybe<Scalars['Boolean']['output']>;
  is_ready?: Maybe<Scalars['Boolean']['output']>;
  is_selection?: Maybe<Scalars['Boolean']['output']>;
  is_setup?: Maybe<Scalars['Boolean']['output']>;
  /** Saved cross-selling links originating from products in this sale. */
  linkedProducts: Array<LinkedProduct>;
  /**
   * The cross-selling title saved for this sale, null when none was saved: the app then shows the default
   * title (key cross_selling_modal_linked_products_title), which is never stored.
   */
  linkedProductsMetadata?: Maybe<LinkedProductsMetadata>;
  logistics_manager?: Maybe<Scalars['String']['output']>;
  logistics_manager_id?: Maybe<Scalars['String']['output']>;
  marketingVideo?: Maybe<MarketingVideo>;
  newImages?: Maybe<Array<SaleImage>>;
  newPreviews?: Maybe<Array<Preview>>;
  note?: Maybe<Scalars['String']['output']>;
  operation_type?: Maybe<Scalars['String']['output']>;
  original_sale_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated use on the calendarpage */
  previews?: Maybe<Scalars['Json']['output']>;
  pricingErrorsCount?: Maybe<Scalars['Int']['output']>;
  products: Array<ProductV3>;
  rating?: Maybe<Scalars['Json']['output']>;
  /**
   * Only used for collection sales, to display the filters that are not editable by the user
   * @deprecated use collectionSale.readonlyFilters instead
   */
  readonlyFilters?: Maybe<Array<CustomFilter>>;
  sale_status?: Maybe<SaleStatusFilter>;
  selection_name?: Maybe<Scalars['String']['output']>;
  setup_by?: Maybe<Scalars['String']['output']>;
  setup_by_id?: Maybe<Scalars['String']['output']>;
  setup_status?: Maybe<SaleSetupStatus>;
  shippingPolicy: ShippingPolicy;
  /** Shopify connection and stock info */
  shopify?: Maybe<ShopifyData>;
  /** @deprecated use start_at_date */
  start_at: Scalars['DateTime']['output'];
  start_at_date: Scalars['LocalDate']['output'];
  stats_stock?: Maybe<Scalars['Json']['output']>;
  /** @deprecated use on the salepage */
  status?: Maybe<SaleSetupStatus>;
  storeId: StoreRegion;
  store_id?: Maybe<StoreRegion>;
  total_sales?: Maybe<Scalars['Int']['output']>;
  tva?: Maybe<Scalars['Int']['output']>;
  upcoming_display_forced: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  url_google_drive?: Maybe<Scalars['String']['output']>;
  url_google_drive_not_validated?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['Json']['output']>;
  video_header?: Maybe<Scalars['String']['output']>;
  widgets?: Maybe<Array<Maybe<Widget>>>;
};

export type SaleAppFilter = {
  __typename?: 'SaleAppFilter';
  id: Scalars['String']['output'];
  /** Human name when the filter has one; generic filters carry their id and the caller labels them. */
  label: Scalars['String']['output'];
};

/** What the app does with a sale's filters, so the back-office never has to guess. */
export type SaleAppFilters = {
  __typename?: 'SaleAppFilters';
  /**
   * Filters the sale can display. A gender, category or badge filter that would offer a single
   * choice is absent.
   *
   * Both lists report the sale as if nothing were hidden: a filter the configuration turned off is
   * still listed, so it can be turned back on and its shortcut still has somewhere to point.
   */
  displayed: Array<SaleAppFilter>;
  /**
   * Filter ids a shortcut may point to. Currently mirrors `displayed`: any filter the app shows may
   * carry a shortcut. `search` and `all` are absent on purpose: those shortcuts are mandatory and
   * the app renders them by itself.
   */
  shortcutable: Array<SaleAppFilter>;
};

export type SaleCount = {
  __typename?: 'SaleCount';
  count?: Maybe<Scalars['Int']['output']>;
};

/**
 * A custom filter of a sale, as an entity of its own: it exists independently of its content, so a
 * freshly created filter with no option yet (an empty shell) is listed here while the app ignores
 * it entirely (no Filtrer row, no shortcut) until an import feeds it.
 */
export type SaleCustomFilter = {
  __typename?: 'SaleCustomFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Ordered by `position`, the order the app displays them in */
  options: Array<SaleCustomFilterOption>;
  /** Distinct products across all options of the filter */
  productsCount: Scalars['Int']['output'];
};

export type SaleCustomFilterEntryInput = {
  /**
   * Value of the option the variant is attached to, as the import file carries it — never a display
   * label. An option already known by that value keeps the label it was given; an unknown one is
   * created displaying its own value. A variant may appear in several entries, one per option.
   */
  option: Scalars['String']['input'];
  variantId: Scalars['ID']['input'];
};

export type SaleCustomFilterOption = {
  __typename?: 'SaleCustomFilterOption';
  /** What the app displays. Equal to `value` until someone renames the option. */
  label: Scalars['String']['output'];
  /**
   * Where the option sits among the filter's. An opaque rank: only its order carries meaning, and
   * it is neither 0-based nor contiguous — a re-import leaves the gap of an option it dropped. The
   * options always come ordered by it, here and in the app, and
   * `reorderSaleCustomFilterOptions` is what changes it.
   */
  position: Scalars['Int']['output'];
  /** Distinct products with at least one variant attached to this option */
  productsCount: Scalars['Int']['output'];
  /**
   * The option's identity: the value the import file carries for it. Stable across re-imports, and
   * what the export writes in the option column.
   */
  value: Scalars['String']['output'];
};

export type SaleCustomFilterReturn = DomainException | SaleCustomFilter;

export type SaleFilterImage = {
  __typename?: 'SaleFilterImage';
  /**
   * Id of the filter the artwork belongs to, in the saleAppFilters id format ("search" and "all"
   * included)
   */
  filterId: Scalars['String']['output'];
  /** Public URL of the filter artwork */
  imageUrl: Scalars['String']['output'];
};

export type SaleFilterImageInput = {
  filterId: Scalars['String']['input'];
  /**
   * Either a public URL, or the key returned by createUploadUrls (it is then resolved
   * against the public CDN).
   */
  imageUrl: Scalars['String']['input'];
};

/** Per-sale filter configuration. Absent when the sale uses the default filter behaviour. */
export type SaleFiltersConfig = {
  __typename?: 'SaleFiltersConfig';
  /**
   * Filter artworks, kept independently of shortcut, visibility and illustrated status: an image
   * survives its filter losing the shortcut or being hidden. "search" and "all" may carry one.
   */
  filterImages: Array<SaleFilterImage>;
  /**
   * Filter ids hidden from the app, in the saleAppFilters id format (e.g. "genders", "price_range",
   * "option:Taille"). An unchecked VISIBLE row lands here.
   */
  hiddenFilterIds: Array<Scalars['String']['output']>;
  /**
   * « Raccourcis avec image » mode, sale-wide. When true the app renders shortcuts with their image
   * (a shortcut without one falls back to text); when false every shortcut is text. Turning the mode
   * off never deletes stored images.
   */
  illustrated: Scalars['Boolean']['output'];
  /**
   * Hex colour (#RRGGBB) applied to the selected shortcut. The shortcut row is only rendered when
   * set.
   */
  selectedColor?: Maybe<Scalars['String']['output']>;
  /**
   * Ordered shortcut list. Never holds "search" or "all": those shortcuts are mandatory and the app
   * renders them by itself.
   */
  shortcutFilterIds: Array<Scalars['String']['output']>;
};

export type SaleFiltersConfigInput = {
  /** `filterId` unique across entries */
  filterImages: Array<SaleFilterImageInput>;
  hiddenFilterIds: Array<Scalars['String']['input']>;
  illustrated: Scalars['Boolean']['input'];
  saleId: Scalars['ID']['input'];
  /**
   * Hex colour (#RRGGBB). Required as soon as `shortcutFilterIds` is not empty: the app only builds
   * the shortcut row when a colour is set, so shortcuts saved without one would never render.
   * Sending shortcuts with no colour is rejected rather than silently stored.
   */
  selectedColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique, and never overlapping `hiddenFilterIds`: a hidden filter cannot carry a shortcut. A
   * shortcut without an image is valid, illustrated mode or not (it renders as text).
   */
  shortcutFilterIds: Array<Scalars['String']['input']>;
};

export type SaleFiltersConfigReturn = DomainException | SaleFiltersConfig;

export type SaleImage = {
  __typename?: 'SaleImage';
  baseKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  properties?: Maybe<SaleImageProperties>;
};

export type SaleImageProperties = {
  __typename?: 'SaleImageProperties';
  full?: Maybe<Scalars['Boolean']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
};

export enum SaleImmersiveNextStatus {
  Draft = 'draft',
  Pending = 'pending',
  Published = 'published'
}

export enum SaleImmersiveStatus {
  Draft = 'draft',
  Pending = 'pending',
  Published = 'published'
}

export type SaleInput = {
  badges?: InputMaybe<Array<BadgeInput>>;
  brand_id?: InputMaybe<Scalars['String']['input']>;
  cancel_reason?: InputMaybe<Scalars['String']['input']>;
  cancellation_level?: InputMaybe<Scalars['String']['input']>;
  cashbackPolicy?: InputMaybe<CashbackPolicyInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_choose?: InputMaybe<Scalars['String']['input']>;
  check_by?: InputMaybe<Scalars['String']['input']>;
  /**
   * GCS key of an uploaded sale cover video (via createUploadUrls with SALE_COVER_VIDEO).
   * When provided, the video is transcoded and the result is set as the sale's cover video (video_header).
   */
  coverVideo?: InputMaybe<Scalars['String']['input']>;
  deliver_by_choose?: InputMaybe<Scalars['Boolean']['input']>;
  delivery_delays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disable_automatic_extension?: InputMaybe<Scalars['Boolean']['input']>;
  disable_sorting?: InputMaybe<Scalars['Boolean']['input']>;
  end_at_date?: InputMaybe<Scalars['LocalDate']['input']>;
  fix_top?: InputMaybe<Scalars['Boolean']['input']>;
  forecast?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Giveaway policies for the sale.
   * Multiple policies are accepted; the list replaces every policy of the sale.
   * Remove all policies if empty array is provided.
   * Do nothing if null is provided.
   * Every policy of a sale must carry the same overOrderAmount: the app exposes a single threshold
   * per sale, so a list with diverging thresholds is rejected with the error code
   * `order_over_amount_should_be_the_same`. The check reads the submitted list only — it does not
   * repair a sale configured before it, and does not stop two concurrent saves from leaving diverging
   * thresholds behind. On refusal the giveaway policies keep their previous value, but the rest of
   * updateSale has already been applied and is not rolled back; pass null to leave the policies of a
   * legacy diverging sale untouched while saving the sale itself.
   * The trigger product is checked the same way, each refusal with its own error code:
   * `giveaway_sale_policy_trigger_product_missing` (triggerProductId left out while the sale has a
   * trigger product), `giveaway_sale_policy_trigger_product_should_be_the_same` (the policies carry
   * different triggers, null included), `giveaway_sale_policy_trigger_product_with_over_order_amount`
   * (a trigger product with overOrderAmount > 0), `giveaway_sale_policy_trigger_product_not_found`
   * (not a product of the sale, or deleted) and `giveaway_sale_policy_trigger_product_not_sellable`
   * (draft, hidden, no paid variant, or one of the gifts of the list).
   */
  giveawayPolicies?: InputMaybe<Array<GiveawayPolicyInput>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hubspot_deal_id?: InputMaybe<Scalars['String']['input']>;
  hubspot_selection_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image_header?: InputMaybe<Scalars['String']['input']>;
  initial_start_at?: InputMaybe<Scalars['DateTime']['input']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  is_ready?: InputMaybe<Scalars['Boolean']['input']>;
  is_selection?: InputMaybe<Scalars['Boolean']['input']>;
  is_setup?: InputMaybe<Scalars['Boolean']['input']>;
  logistics_manager?: InputMaybe<Scalars['String']['input']>;
  logistics_manager_id?: InputMaybe<Scalars['String']['input']>;
  newImagesRemoved?: InputMaybe<Array<Scalars['String']['input']>>;
  new_images?: InputMaybe<Array<Scalars['String']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  operation_type?: InputMaybe<Scalars['String']['input']>;
  previews?: InputMaybe<Array<Scalars['String']['input']>>;
  previews_properties?: InputMaybe<Array<PreviewPropertie>>;
  selection_name?: InputMaybe<Scalars['String']['input']>;
  setup_by?: InputMaybe<Scalars['String']['input']>;
  setup_by_id?: InputMaybe<Scalars['String']['input']>;
  shippingPolicy?: InputMaybe<ShippingPolicyInput>;
  start_at_date?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<SaleSetupStatus>;
  store_id?: InputMaybe<StoreRegion>;
  tva?: InputMaybe<Scalars['Int']['input']>;
  upcoming_display_forced?: InputMaybe<Scalars['Boolean']['input']>;
  url_google_drive?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<SaleVideoInput>;
};

export type SaleProductCheckCount = {
  __typename?: 'SaleProductCheckCount';
  /** @deprecated in favor of SPELLING and COHERENCE */
  description?: Maybe<Scalars['Int']['output']>;
  description_coherence?: Maybe<Scalars['Int']['output']>;
  description_spelling?: Maybe<Scalars['Int']['output']>;
  history_price?: Maybe<Scalars['Int']['output']>;
  informations?: Maybe<Scalars['Int']['output']>;
  public_price?: Maybe<Scalars['Int']['output']>;
  sizes?: Maybe<Scalars['Int']['output']>;
  tva?: Maybe<Scalars['Int']['output']>;
  unit_price?: Maybe<Scalars['Int']['output']>;
  warranties?: Maybe<Scalars['Int']['output']>;
  wrong_barcode?: Maybe<Scalars['Int']['output']>;
  wrong_shopify_variant_id?: Maybe<Scalars['Int']['output']>;
};

export enum SaleSetupStatus {
  Normal = 'normal',
  Ready = 'ready',
  SetupReady = 'setup_ready',
  SetupReadyOps = 'setup_ready_ops',
  SetupWaitingElements = 'setup_waiting_elements'
}

export enum SaleStatus {
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Ongoing = 'ONGOING',
  Upcoming = 'UPCOMING'
}

export enum SaleStatusFilter {
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Hided = 'HIDED',
  Ongoing = 'ONGOING',
  Stopped = 'STOPPED',
  Upcoming = 'UPCOMING'
}

export type SaleVideoInput = {
  /**
   * URL key of the cover image file
   * Can be either the key of a file in the bucket or the complete url
   */
  coverImageUrlKey: Scalars['String']['input'];
  label: Scalars['String']['input'];
  title: Scalars['String']['input'];
  /**
   * URL key of the video file
   * Can be either the key of a file in the bucket or the complete url
   */
  urlKey: Scalars['String']['input'];
};

export type SalesCache = {
  __typename?: 'SalesCache';
  has_more?: Maybe<Scalars['Boolean']['output']>;
  pagination?: Maybe<Scalars['Int']['output']>;
  sales: Array<Sale>;
  total_sales?: Maybe<Scalars['Int']['output']>;
};

export type SalesElasticSearch = {
  __typename?: 'SalesElasticSearch';
  hits?: Maybe<Array<Maybe<SalesElasticSearchHit>>>;
  max_score?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SalesElasticSearchHit = {
  __typename?: 'SalesElasticSearchHit';
  _id: Scalars['String']['output'];
  _score: Scalars['Float']['output'];
  _source: Scalars['Json']['output'];
  highlight: Scalars['Json']['output'];
  status?: Maybe<SaleStatusFilter>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SaveImage = {
  image: TransformImageData;
  item: SaveImageItem;
};

export type SaveImageItem = {
  baseKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
  type: ImageDataType;
};

export type SaveImagesOptions = {
  backgroundColor: Scalars['HexColorCode']['input'];
};

export type SetupIssue = {
  __typename?: 'SetupIssue';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: SetupIssueType;
};

export enum SetupIssueType {
  BrandWebsite = 'brand_website',
  Catalog = 'catalog',
  CsvFile = 'csv_file',
  Description = 'description',
  Price = 'price',
  Tech = 'tech',
  VisualAsset = 'visual_asset'
}

export enum SetupWaitingReason {
  /** Catalogue incomplet (csv) */
  IncompleteCatalog = 'INCOMPLETE_CATALOG',
  /** Descriptions manquantes */
  IncompleteDescriptions = 'INCOMPLETE_DESCRIPTIONS',
  /** Images manquantes */
  MissingVisualAssets = 'MISSING_VISUAL_ASSETS',
  /** Erreur de prix */
  PriceErrors = 'PRICE_ERRORS',
  /** Bug technique */
  TechIssues = 'TECH_ISSUES',
  /** URL 404 */
  Url_404Errors = 'URL_404_ERRORS'
}

/**
 * Delivery method a free shipping rule applies to.
 * Distinct from `ShippingDeliveryType` (support-schema): different semantics,
 * schemas are compiled separately via codegen.yml.
 */
export enum ShippingDeliveryMethod {
  HomeDelivery = 'HOME_DELIVERY',
  PickupPoint = 'PICKUP_POINT'
}

/** Free shipping rule for a (group of countries × delivery method) of a sale. */
export type ShippingFreeShippingRule = {
  __typename?: 'ShippingFreeShippingRule';
  /**
   * Minimum order amount to get free shipping when eligible to commercial offer.
   * `null` means no commercial free shipping override for this case.
   */
  commercialOfferMinimumOrderAmount?: Maybe<Scalars['Int']['output']>;
  /** Countries covered by the rule. `null` means all the sale's countries. */
  countries?: Maybe<Array<Scalars['String']['output']>>;
  deliveryMethod: ShippingDeliveryMethod;
  /**
   * Minimum order amount to get free shipping for this case. A rule always
   * carries a threshold: a paid delivery method is expressed by the absence of
   * its rule in `freeShippingRules`, never by a rule without a threshold.
   */
  freeShippingMinimumOrderAmount: Scalars['Int']['output'];
};

/** Free shipping rule input for a (group of countries × delivery method) of a sale. */
export type ShippingFreeShippingRuleInput = {
  /**
   * Minimum order amount to get free shipping when eligible to commercial offer.
   * `null` means no commercial free shipping override for this case.
   */
  commercialOfferMinimumOrderAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Countries covered by the rule. `null` means all the sale's countries. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryMethod: ShippingDeliveryMethod;
  /**
   * Minimum order amount to get free shipping for this case. A rule always
   * carries a threshold: a paid delivery method is expressed by omitting its
   * rule from `freeShippingRules`, never by sending a rule without a threshold.
   */
  freeShippingMinimumOrderAmount: Scalars['Int']['input'];
};

export type ShippingPolicy = {
  __typename?: 'ShippingPolicy';
  /**
   * If defined, gives the minimum amount to order to get free shipping
   * @deprecated use freeShippingRules; kept as a degraded fallback for old clients
   */
  freeShippingMinimumOrderAmount?: Maybe<Scalars['Int']['output']>;
  /**
   * Free shipping matrix (countries × delivery method) of the sale.
   * `null` when no rule is configured: clients then read the deprecated
   * `freeShippingMinimumOrderAmount` scalar.
   */
  freeShippingRules?: Maybe<Array<ShippingFreeShippingRule>>;
  /** True when the sale's active policy is pickup point only. */
  isPickupPointOnly: Scalars['Boolean']['output'];
  /**
   * If defined, Mondial relay delivery offer is available for all sale's variants
   * @deprecated use pickupPoint
   */
  mondialRelay?: Maybe<MondialRelayData>;
  /** If defined, pickup network is available for all sale's variants */
  pickupPoint?: Maybe<ShippingPolicyPickupPoint>;
};

export type ShippingPolicyInput = {
  /**
   * Price, in cents, of the fr store pickup point delivery offered by the sale.
   * Omitted → the existing pickup point configuration is left untouched.
   * `null` → pickup point delivery is removed from the sale.
   * A value → pickup point delivery is enabled for every variant of the sale, and
   * `pickupPointNetwork` becomes mandatory. Only accepted on the fr store.
   */
  basicFrPickupPointDeliveryPrice?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of days after given sale startAt date to get free shipping
   * If null, removes this rule from sale shipping policy
   */
  deliveryOfferedNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Free shipping matrix (countries × delivery method) of the sale.
   * Omitted → the existing matrix is left untouched.
   * `null` or empty list → legacy mode: the deprecated `freeShippingMinimumOrderAmount`
   * scalar is used and any existing rules are purged.
   * Non-empty → replace-all: existing rules are deleted, the new ones inserted and the
   * degraded `freeShippingMinimumOrderAmount` scalar recomputed, all in one transaction.
   */
  freeShippingRules?: InputMaybe<Array<ShippingFreeShippingRuleInput>>;
  /**
   * Pickup-point-only mode of the sale (fr store only): no home delivery, France only.
   * Omitted → left untouched. `true` requires a pickup point (already configured or set by
   * this same input) and positive sale delivery delays. While `true`, removing the pickup
   * point is refused unless this same input sets it back to `false`. `null` is rejected.
   */
  isPickupPointOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Pickup point network serving the sale — a single one per sale.
   * Mandatory as soon as `basicFrPickupPointDeliveryPrice` carries a value,
   * rejected when it does not.
   */
  pickupPointNetwork?: InputMaybe<PickupPointNetwork>;
};

export type ShippingPolicyPickupPoint = {
  __typename?: 'ShippingPolicyPickupPoint';
  network: PickupPointNetwork;
  shippingCost: Scalars['Int']['output'];
};

export type ShopifyData = {
  __typename?: 'ShopifyData';
  hasCredentials: Scalars['Boolean']['output'];
  hasPlugin: Scalars['Boolean']['output'];
  hasStockProtection: Scalars['Boolean']['output'];
  isStockLive: Scalars['Boolean']['output'];
  testMondialRelayOn?: Maybe<Scalars['DateTime']['output']>;
  testOrderOn?: Maybe<Scalars['DateTime']['output']>;
  testShop2ShopOn?: Maybe<Scalars['DateTime']['output']>;
};

export type ShopifyPermissions = {
  __typename?: 'ShopifyPermissions';
  can_create_draft_order: Scalars['Boolean']['output'];
  can_create_order: Scalars['Boolean']['output'];
  can_create_order_products: Scalars['Boolean']['output'];
  can_create_order_with_specific_location_id: Scalars['Boolean']['output'];
  can_read_delivery_services: Scalars['Boolean']['output'];
  can_read_fulfillments: Scalars['Boolean']['output'];
  can_read_locations: Scalars['Boolean']['output'];
  can_read_returns: Scalars['Boolean']['output'];
  can_sync_stock: Scalars['Boolean']['output'];
  can_update_stock: Scalars['Boolean']['output'];
  can_write_returns: Scalars['Boolean']['output'];
  deliveries?: Maybe<Array<Scalars['String']['output']>>;
  deliveries_list: ShopifyPermissionsDeliveries;
  /** Delivery params */
  delivery?: Maybe<Scalars['String']['output']>;
  /** Choose Configuration */
  has_stock_protection: Scalars['Boolean']['output'];
  international_carrier_code?: Maybe<Scalars['String']['output']>;
  inventory_location_ids?: Maybe<Array<Scalars['String']['output']>>;
  is_disconnected: Scalars['Boolean']['output'];
  mondial_relay_code?: Maybe<Scalars['String']['output']>;
  set_product_price: Scalars['Boolean']['output'];
  warning_too_much_permissions: Scalars['Boolean']['output'];
};

export type ShopifyPermissionsDeliveries = {
  __typename?: 'ShopifyPermissionsDeliveries';
  BE: Array<Scalars['String']['output']>;
  ES: Array<Scalars['String']['output']>;
  FR: Array<Scalars['String']['output']>;
  US: Array<Scalars['String']['output']>;
};

export type ShopifyProductsOutput = {
  __typename?: 'ShopifyProductsOutput';
  error?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ShopifyQueries = {
  __typename?: 'ShopifyQueries';
  checkShopifyInventory: ShopifyStock;
  getShopifyInventoryAvailable: Array<InventoryAvailable>;
  getShopifyPermissions: ShopifyPermissions;
  /**
   * Get all the active products available on the Shopify store.
   * Useful to create a new sale on Choose or identify products with errors (incorrect SKUs, etc.)
   */
  getShopifyProducts: ShopifyProductsOutput;
  /**
   * Get fulfillment data from Shopify for unfulfilled orders on Choose.
   * Useful for resolving synchronization issues between platforms.
   */
  getShopifyUnfulfilledOrders: ShopifyUnfulfilledOrdersOutput;
};


export type ShopifyQueriesCheckShopifyInventoryArgs = {
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};


export type ShopifyQueriesGetShopifyInventoryAvailableArgs = {
  sellerId: Scalars['ID']['input'];
};


export type ShopifyQueriesGetShopifyPermissionsArgs = {
  sellerId: Scalars['ID']['input'];
};


export type ShopifyQueriesGetShopifyProductsArgs = {
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};


export type ShopifyQueriesGetShopifyUnfulfilledOrdersArgs = {
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};

export type ShopifyStock = {
  __typename?: 'ShopifyStock';
  skusCheck: Array<ShopifyStockCheck>;
  skusErrors: Array<ShopifyStockError>;
  skusOutofstock: Scalars['Int']['output'];
};

export type ShopifyStockCheck = {
  __typename?: 'ShopifyStockCheck';
  barcode?: Maybe<Scalars['String']['output']>;
  inventoryManagement: Scalars['String']['output'];
  inventoryPolicy: Scalars['String']['output'];
  sellableOnlineQuantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ShopifyStockError = {
  __typename?: 'ShopifyStockError';
  barcode?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  shopifyBarcodes?: Maybe<Array<Scalars['String']['output']>>;
  shopifyIds: Array<Scalars['String']['output']>;
  shopifySkus?: Maybe<Array<Scalars['String']['output']>>;
  shopifyStatus: Array<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type ShopifyStockSyncOutput = {
  __typename?: 'ShopifyStockSyncOutput';
  error_count: Scalars['Int']['output'];
  sync_count: Scalars['Int']['output'];
};

export type ShopifySyncPendingOrdersOutput = {
  __typename?: 'ShopifySyncPendingOrdersOutput';
  count: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

export enum ShopifyTestOrderCountry {
  Es = 'ES',
  Fr = 'FR'
}

export type ShopifyTestOrderInput = {
  countryToShipTo?: InputMaybe<ShopifyTestOrderCountry>;
  isPickup: Scalars['Boolean']['input'];
  network?: InputMaybe<ShopifyTestOrderNetwork>;
  refs?: InputMaybe<Array<Scalars['String']['input']>>;
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};

export enum ShopifyTestOrderNetwork {
  Colissimo = 'COLISSIMO',
  MondialRelay = 'MONDIAL_RELAY',
  Shop2Shop = 'SHOP2SHOP'
}

export type ShopifyTestOrderOutput = {
  __typename?: 'ShopifyTestOrderOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShopifyUnfulfilledOrdersOutput = {
  __typename?: 'ShopifyUnfulfilledOrdersOutput';
  count: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SizesCheckData = {
  __typename?: 'SizesCheckData';
  correction: Scalars['String']['output'];
  id: Scalars['String']['output'];
  original: Scalars['String']['output'];
};

export type SpellingCheckData = {
  __typename?: 'SpellingCheckData';
  errors: Array<Correction>;
};

/**
 * Editorial content of a spotlight sale, configured independently from the sale itself. Absent
 * when the sale has no spotlight configuration yet.
 */
export type SpotlightConfig = {
  __typename?: 'SpotlightConfig';
  /**
   * SpotlightBlock[] tree (container.main -> sections -> content blocks), as defined by
   * @appchoose/rest-api-types.
   */
  blocks: Scalars['Json']['output'];
  rankSchedule: Array<SpotlightRankTier>;
  status: SpotlightConfigurationStatus;
};

export type SpotlightConfigInput = {
  /**
   * Incomplete blocks are accepted in a draft config (each one only needs its `key` and `model`),
   * complete ones are required in a published config.
   */
  blocks: Scalars['Json']['input'];
  /** `fromDay` unique across entries */
  rankSchedule: Array<SpotlightRankTierInput>;
  saleId: Scalars['ID']['input'];
};

export type SpotlightConfigReturn = DomainException | SpotlightConfig | SpotlightConfigValidationError;

/** Every invalid field of the spotlight config, reported at once. */
export type SpotlightConfigValidationError = {
  __typename?: 'SpotlightConfigValidationError';
  issues: Array<SpotlightConfigValidationIssue>;
};

/** One invalid field of a spotlight config. */
export type SpotlightConfigValidationIssue = {
  __typename?: 'SpotlightConfigValidationIssue';
  /**
   * Validation rule broken by the field: a zod issue code (invalid_type, invalid_union, ...) or a
   * rank schedule rule (invalid_from_day, duplicate_from_day, invalid_rank).
   */
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /**
   * Path of the field in SpotlightConfigInput, e.g. ["blocks", "2", "stories", "0", "title"] or
   * ["rankSchedule", "1", "fromDay"].
   */
  path: Array<Scalars['String']['output']>;
};

/**
 * A `draft` config can be incomplete while the content is being gathered; a `published` one is
 * complete and served to the app.
 */
export enum SpotlightConfigurationStatus {
  Draft = 'draft',
  Published = 'published'
}

/**
 * One tier of a spotlight's rank schedule: from `fromDay` (included, 1-indexed on the sale
 * `startAt` day) the spotlight is inserted at `rank` in the sales ranking, until the next tier
 * applies.
 */
export type SpotlightRankTier = {
  __typename?: 'SpotlightRankTier';
  fromDay: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type SpotlightRankTierInput = {
  fromDay: Scalars['Int']['input'];
  rank: Scalars['Int']['input'];
};

export type SpotlightVideoThumbnail = {
  __typename?: 'SpotlightVideoThumbnail';
  /**
   * Key of the thumbnail, next to the video (`<video folder>/thumbnail.png`): it can be stored as is
   * in a story screen `image`, keys being resolved against the public CDN
   */
  key: Scalars['String']['output'];
  /** Public URL of the thumbnail */
  publicUrl: Scalars['String']['output'];
};

export type SpotlightVideoThumbnailReturn = DomainException | SpotlightVideoThumbnail;

export type StockUpdateByRef = {
  /** ** Gtin or SKU that the agent wants to update ** */
  productRef: Scalars['String']['input'];
  /** ** Value of the stock to set ** */
  stock: Scalars['Int']['input'];
};

export enum StoreCurrency {
  Eur = 'eur',
  Usd = 'usd'
}

export enum StoreRegion {
  Fr = 'fr',
  Us = 'us'
}

export type SubCategory = {
  __typename?: 'SubCategory';
  category: Scalars['String']['output'];
  ids: Array<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  aiProductsUpdated: AiProductsUpdatedPayload;
  couponsChanged?: Maybe<Scalars['Json']['output']>;
  crawlingProductsUpdated?: Maybe<CrawlingProductsUpdatedPayload>;
  /**
   * Every change of a Jev cross-selling preview session, from its start to its result. Changes published
   * before the subscription is open are not replayed: subscribe first, then read crossSellingPreviewSession
   * once, so that a preview finishing right away is not missed.
   */
  crossSellingPreviewUpdated: CrossSellingPreviewSession;
  /** triggered when an image processing is done */
  imageProccessed: ImageProccessed;
  importProductsUpdated?: Maybe<ImportProductsUpdatedPayload>;
};


export type SubscriptionAiProductsUpdatedArgs = {
  sessionId: Scalars['ID']['input'];
};


export type SubscriptionCrawlingProductsUpdatedArgs = {
  saleId: Scalars['String']['input'];
};


export type SubscriptionCrossSellingPreviewUpdatedArgs = {
  sessionId: Scalars['ID']['input'];
};


export type SubscriptionImageProccessedArgs = {
  sessionId: Scalars['ID']['input'];
};


export type SubscriptionImportProductsUpdatedArgs = {
  saleId: Scalars['String']['input'];
};

export enum TeamName {
  Cosmetiques = 'cosmetiques',
  Kids = 'kids',
  Maison = 'maison',
  Mode = 'mode'
}

export enum Tiering {
  Core = 'core',
  Discovery = 'discovery',
  Key = 'key'
}

export enum TimeRange {
  From_0To_30Min = 'FROM_0_TO_30_MIN',
  From_1HTo_2H = 'FROM_1H_TO_2H',
  From_2HTo_3H = 'FROM_2H_TO_3H',
  From_3HTo_4H = 'FROM_3H_TO_4H',
  From_4HTo_5H = 'FROM_4H_TO_5H',
  From_5HTo_6H = 'FROM_5H_TO_6H',
  From_30MinTo_1H = 'FROM_30_MIN_TO_1H',
  MoreThan_6H = 'MORE_THAN_6H'
}

export enum TopBrandType {
  ASuivre = 'a_suivre',
  Banger = 'banger',
  Business = 'business',
  Dead = 'dead',
  Image = 'image',
  MiddleNon = 'middle_non',
  MiddleOui = 'middle_oui',
  NoGo = 'no_go'
}

export type TransformImageData = {
  dimensions: ImageDimensions;
  key: Scalars['String']['input'];
  transformations: Array<ImageTransformation>;
};

export type UpdateOptionManyInput = {
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOptionVariantManyInput = {
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type UpdateProductCouponManyInput = {
  cgu?: InputMaybe<Array<Scalars['String']['input']>>;
  couponExpireAt?: InputMaybe<Scalars['LocalDate']['input']>;
  couponOffer?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<Array<Scalars['String']['input']>>;
  faqAfterOrder?: InputMaybe<Scalars['String']['input']>;
  faqBeforeOrder?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Array<CustomFieldInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Array<UpdateVariantManyInput>>;
};

export type UpdateProductOptionManyInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<UpdateOptionVariantManyInput>>;
};

export type UpdateVariantManyInput = {
  gtin?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadResourceType {
  ImmersiveSourceLogo = 'IMMERSIVE_SOURCE_LOGO',
  ImmersiveSourceSticker = 'IMMERSIVE_SOURCE_STICKER',
  ImmersiveSourceVideo = 'IMMERSIVE_SOURCE_VIDEO',
  ProductsCsv = 'PRODUCTS_CSV',
  ProductAudio = 'PRODUCT_AUDIO',
  ProductImage = 'PRODUCT_IMAGE',
  ProductVideo = 'PRODUCT_VIDEO',
  SaleCoverVideo = 'SALE_COVER_VIDEO',
  SaleFilterImage = 'SALE_FILTER_IMAGE',
  SaleImage = 'SALE_IMAGE',
  SaleSpotlightImage = 'SALE_SPOTLIGHT_IMAGE',
  SaleSpotlightVideo = 'SALE_SPOTLIGHT_VIDEO',
  SaleVideo = 'SALE_VIDEO'
}

export type UploadUrl = {
  __typename?: 'UploadUrl';
  key: Scalars['String']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type UploadUrlInput = {
  fileName: Scalars['String']['input'];
  /** If provided, the key parts will be used to build the key of the file. */
  keyParts?: InputMaybe<Array<Scalars['String']['input']>>;
  mimeType: Scalars['String']['input'];
  resourceType: UploadResourceType;
};

export type UploadUrlReturn = ErrorLike | UploadUrl;

export type User = {
  __typename?: 'User';
  auth0Id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  meusnidusRoles: Array<MeusnidusRole>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  stores_id: Array<StoreRegion>;
};

export enum UserAliasBraze {
  TeamFr = 'TEAM_FR',
  TeamUs = 'TEAM_US'
}

export type ValidateAiFormattedProductDescriptionsInput = {
  products: Array<AiFormattedProductDescriptionInput>;
};

export type VariantToUpsert = {
  buyingPrice?: InputMaybe<Scalars['Int']['input']>;
  /** Null when buying price is given */
  chooseFees?: InputMaybe<Scalars['Int']['input']>;
  deliveryDelays?: InputMaybe<Scalars['Int']['input']>;
  eeePrice?: InputMaybe<Scalars['Int']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** height of the product with packaging in millimeters */
  heightMillimeter?: InputMaybe<Scalars['Int']['input']>;
  hide: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** indicates if the current variant is unique */
  isUnique: Scalars['Boolean']['input'];
  /** length of the product with packaging in millimeters */
  lengthMillimeter?: InputMaybe<Scalars['Int']['input']>;
  options: Array<ProductVariantOptionInput>;
  /** where the product is made from */
  originCountry?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Price on Choose app */
  price?: InputMaybe<Scalars['Int']['input']>;
  retailPrice: Scalars['Int']['input'];
  shippingFees: Scalars['Int']['input'];
  /** Shopify variant id */
  shopify_variant_id?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Product variant stock count. null means unlimited stock */
  stockCount?: InputMaybe<Scalars['Int']['input']>;
  /** Number of units per pack for purchase by Choose. Used to generate the purchase orders */
  unitsPerPack?: InputMaybe<Scalars['Int']['input']>;
  /** weight of the product with packaging in grams */
  weightGram?: InputMaybe<Scalars['Int']['input']>;
  /** width of the product with packaging in millimeters */
  widthMillimeter?: InputMaybe<Scalars['Int']['input']>;
};

export type VariantUpdateByRef = {
  /** ** Buying price to set ** */
  buyingPrice?: InputMaybe<Scalars['Int']['input']>;
  /** ** Choose price to set ** */
  choosePrice?: InputMaybe<Scalars['Int']['input']>;
  /** ** Delivery delays to set ** */
  deliveryDelays?: InputMaybe<Scalars['Int']['input']>;
  /** ** Eco taxe price to set ** */
  eeePrice?: InputMaybe<Scalars['Int']['input']>;
  /** ** Height in millimeters ** */
  heightMillimeter?: InputMaybe<Scalars['Int']['input']>;
  /** ** Length in millimeters ** */
  lengthMillimeter?: InputMaybe<Scalars['Int']['input']>;
  /** ** Gtin or SKU that the agent wants to update ** */
  productRef: Scalars['String']['input'];
  /** ** Retail price to set ** */
  retailPrice?: InputMaybe<Scalars['Int']['input']>;
  /** ** Shipping price to set ** */
  shippingPrice?: InputMaybe<Scalars['Int']['input']>;
  /** ** Value of the stock to set ** */
  stock?: InputMaybe<Scalars['Int']['input']>;
  /** ** Number of units per pack for purchase by Choose. Used to generate the purchase orders ** */
  unitsPerPack?: InputMaybe<Scalars['Int']['input']>;
  /** ** Weight in grams ** */
  weightGram?: InputMaybe<Scalars['Int']['input']>;
  /** ** Width in millimeters ** */
  widthMillimeter?: InputMaybe<Scalars['Int']['input']>;
  /** Yuka nutritional/cosmetics score (0-100) */
  yukaRate?: InputMaybe<Scalars['Int']['input']>;
};

/** ** Payload returned to the Front to inform the agent how many refs were updated ** */
export type VariantUpdated = {
  __typename?: 'VariantUpdated';
  error?: Maybe<Scalars['String']['output']>;
  productRef: Scalars['String']['output'];
  result: Scalars['Boolean']['output'];
};

export type Widget = {
  __typename?: 'Widget';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  proposition?: Maybe<Scalars['Json']['output']>;
  results?: Maybe<Scalars['Json']['output']>;
  state?: Maybe<WidgetState>;
  type?: Maybe<WidgetType>;
};

export enum WidgetState {
  Accepted = 'ACCEPTED',
  Refused = 'REFUSED'
}

export enum WidgetType {
  Duration = 'DURATION',
  Stock = 'STOCK'
}

export type CrawlingProductsUpdatedErrorPayload = {
  __typename?: 'crawlingProductsUpdatedErrorPayload';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CrawlingProductsUpdatedPayload = {
  __typename?: 'crawlingProductsUpdatedPayload';
  data?: Maybe<CrawlingProductsUpdatedProductInfoPayload>;
  error?: Maybe<CrawlingProductsUpdatedErrorPayload>;
  id: Scalars['String']['output'];
  saleId: Scalars['String']['output'];
};

export type CrawlingProductsUpdatedProductInfoPayload = {
  __typename?: 'crawlingProductsUpdatedProductInfoPayload';
  composition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ImportProductsUpdatedErrorPayload = {
  __typename?: 'importProductsUpdatedErrorPayload';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ImportProductsUpdatedPayload = {
  __typename?: 'importProductsUpdatedPayload';
  error?: Maybe<ImportProductsUpdatedErrorPayload>;
  id: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  saleId: Scalars['String']['output'];
};

export type MarkSaleTrackingsAsDeliveredFilter = {
  includeExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  includeNotPrepared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddImagesToProductsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  images: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddImagesToProductsMutation = { __typename?: 'Mutation', addImagesToProducts?: any | null };

export type AddLinkedProductsMutationVariables = Exact<{
  products: Array<LinkedProductsInput> | LinkedProductsInput;
  metadata?: InputMaybe<LinkedProductsMetadataInput>;
}>;


export type AddLinkedProductsMutation = { __typename?: 'Mutation', addLinkedProducts?: boolean | null };

export type AddProductCouponsMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  codes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  variantId: Scalars['ID']['input'];
}>;


export type AddProductCouponsMutation = { __typename?: 'Mutation', addProductCouponsV2?: any | null };

export type AddProductToCollectionMutationVariables = Exact<{
  collectionSaleId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  isBestseller: Scalars['Boolean']['input'];
  filters: Array<CustomFilterInput> | CustomFilterInput;
}>;


export type AddProductToCollectionMutation = { __typename?: 'Mutation', addProductToCollection?: boolean | null };

export type AddProductsBadgesMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  badges: Array<ProductBadgeInput> | ProductBadgeInput;
}>;


export type AddProductsBadgesMutation = { __typename?: 'Mutation', addProductsBadges?: any | null };

export type AddSizeGuidesToProductsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  sizeGuides: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddSizeGuidesToProductsMutation = { __typename?: 'Mutation', addSizeGuidesToProducts?: any | null };

export type AddTextToProductsDescriptionMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  payload: AddTextPayload;
}>;


export type AddTextToProductsDescriptionMutation = { __typename?: 'Mutation', addTextToProductsDescription?: any | null };

export type AddTextToProductsNameMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  payload: AddTextPayload;
}>;


export type AddTextToProductsNameMutation = { __typename?: 'Mutation', addTextToProductsName?: any | null };

export type AiProductsUpdatedSubscriptionVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type AiProductsUpdatedSubscription = { __typename?: 'Subscription', aiProductsUpdated: { __typename?: 'AIProductsUpdatedPayload', sessionId: string, data: { __typename?: 'AIProductDataPayload', productId: string, description: string, name?: string | null, traceId?: string | null }, error?: { __typename?: 'AIProductErrorPayload', code: string, message: string } | null } };

export type AlignBottomImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type AlignBottomImagesMutation = { __typename?: 'Mutation', alignBottomImages?: any | null };

export type AlignTopImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type AlignTopImagesMutation = { __typename?: 'Mutation', alignTopImages?: any | null };

export type ChangeProductColorToOptionMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ChangeProductColorToOptionMutation = { __typename?: 'Mutation', changeProductColorToOption?: any | null };

export type ChangeProductOptionToColorMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ChangeProductOptionToColorMutation = { __typename?: 'Mutation', changeProductOptionToColor?: any | null };

export type CheckShopifyInventoryQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
}>;


export type CheckShopifyInventoryQuery = { __typename?: 'Query', shopify: { __typename?: 'ShopifyQueries', checkShopifyInventory: { __typename?: 'ShopifyStock', skusOutofstock: number, skusErrors: Array<{ __typename?: 'ShopifyStockError', sku?: string | null, barcode?: string | null, reason: string, shopifySkus?: Array<string> | null, shopifyBarcodes?: Array<string> | null, shopifyStatus: Array<string>, shopifyIds: Array<string> }>, skusCheck: Array<{ __typename?: 'ShopifyStockCheck', sku?: string | null, barcode?: string | null, sellableOnlineQuantity: number, inventoryPolicy: string, inventoryManagement: string, status: string }> } } };

export type CopyProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  keepImages: Scalars['Boolean']['input'];
}>;


export type CopyProductMutation = { __typename?: 'Mutation', copyProductV2: string };

export type CopySaleMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type CopySaleMutation = { __typename?: 'Mutation', copySale?: string | null };

export type CouponsChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CouponsChangedSubscription = { __typename?: 'Subscription', couponsChanged?: any | null };

export type CrawlDriveImagesMutationVariables = Exact<{
  urlData: Array<CrawlDriveUrlDataInput> | CrawlDriveUrlDataInput;
}>;


export type CrawlDriveImagesMutation = { __typename?: 'Mutation', crawlDriveImages: Array<{ __typename?: 'CrawlingDriveProductImage', productName: string, images: Array<string> }> };

export type CrawlProductsMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CrawlProductsMutation = { __typename?: 'Mutation', crawlProducts?: string | null };

export type CrawlingProductsUpdatedSubscriptionVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type CrawlingProductsUpdatedSubscription = { __typename?: 'Subscription', crawlingProductsUpdated?: { __typename?: 'crawlingProductsUpdatedPayload', id: string, saleId: string, data?: { __typename?: 'crawlingProductsUpdatedProductInfoPayload', composition?: string | null, description?: string | null, images?: Array<string | null> | null } | null, error?: { __typename?: 'crawlingProductsUpdatedErrorPayload', code?: string | null, message?: string | null } | null } | null };

export type CreateDurationWidgetMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type CreateDurationWidgetMutation = { __typename?: 'Mutation', createDurationWidget?: string | null };

export type CreateLogisticFileMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateLogisticFileMutation = { __typename?: 'Mutation', createLogisticFile?: string | null };

export type CreateSaleCustomFilterMutationVariables = Exact<{
  input: CreateSaleCustomFilterInput;
}>;


export type CreateSaleCustomFilterMutation = { __typename?: 'Mutation', createSaleCustomFilter:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SaleCustomFilter', id: string, name: string }
   };

export type CreateShopifyTestOrderMutationVariables = Exact<{
  input: ShopifyTestOrderInput;
}>;


export type CreateShopifyTestOrderMutation = { __typename?: 'Mutation', createShopifyTestOrder: { __typename?: 'ShopifyTestOrderOutput', error?: string | null, success: boolean } };

export type CreateUploadUrlsMutationVariables = Exact<{
  input: Array<UploadUrlInput> | UploadUrlInput;
}>;


export type CreateUploadUrlsMutation = { __typename?: 'Mutation', createUploadUrls: Array<
    | { __typename: 'ErrorLike', message: string }
    | { __typename: 'UploadUrl', url: string, key: string, publicUrl?: string | null }
  > };

export type CropBelowFacesImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type CropBelowFacesImagesMutation = { __typename?: 'Mutation', cropBelowFacesImages?: any | null };

export type CrossSellingPreviewUpdatedSubscriptionVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type CrossSellingPreviewUpdatedSubscription = { __typename?: 'Subscription', crossSellingPreviewUpdated: { __typename?: 'CrossSellingPreviewSession', sessionId: string, saleId: string, intent: string, status: CrossSellingPreviewStatus, errorCode?: string | null, expiresAt: string, progress?: { __typename?: 'CrossSellingPreviewProgress', phase: CrossSellingPreviewPhase, completedRequests: number, totalRequests: number } | null, preview?: { __typename?: 'CrossSellingPreview', suggestions: Array<{ __typename?: 'CrossSelling', productId: string, products: Array<{ __typename?: 'CrossSellingProduct', productId: string, score?: number | null }> }> } | null } };

export type DeleteSaleCustomFilterMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
  filterId: Scalars['ID']['input'];
}>;


export type DeleteSaleCustomFilterMutation = { __typename?: 'Mutation', deleteSaleCustomFilter?: boolean | null };

export type DismissProductCheckMutationVariables = Exact<{
  checkId: Scalars['ID']['input'];
}>;


export type DismissProductCheckMutation = { __typename?: 'Mutation', dismissProductCheck: boolean };

export type ExtendImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type ExtendImagesMutation = { __typename?: 'Mutation', extendImages?: any | null };

export type FillImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type FillImagesMutation = { __typename?: 'Mutation', fillImages?: any | null };

export type FitImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type FitImagesMutation = { __typename?: 'Mutation', fitImages?: any | null };

export type FormatProductsDescriptionMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormatProductsDescriptionMutation = { __typename?: 'Mutation', formatProductsDescription?: any | null };

export type FormatProductsWithAiMutationVariables = Exact<{
  input: AiProductsInput;
}>;


export type FormatProductsWithAiMutation = { __typename?: 'Mutation', formatProductsWithAI: string };

export type GenerateImmersiveCatchlinesMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
  type: ImmersiveCatchlineType;
}>;


export type GenerateImmersiveCatchlinesMutation = { __typename?: 'Mutation', generateImmersiveCatchlines:
    | { __typename: 'DomainException', errorCode: string }
    | { __typename: 'ImmersiveCatchlineGenerationResult', status: ImmersiveCatchlineGenerationStatus, suggestions: Array<string> }
   };

export type GenerateSpotlightVideoThumbnailMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
  videoKey: Scalars['String']['input'];
}>;


export type GenerateSpotlightVideoThumbnailMutation = { __typename?: 'Mutation', generateSpotlightVideoThumbnail:
    | { __typename: 'DomainException', errorCode: string }
    | { __typename: 'SpotlightVideoThumbnail', key: string, publicUrl: string }
   };

export type BadgesQueryVariables = Exact<{
  storeId: StoreRegion;
}>;


export type BadgesQuery = { __typename?: 'Query', badges: Array<{ __typename?: 'BadgeSvg', name: string, svg: string }> };

export type BrandQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type BrandQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', about?: string | null, contactName?: string | null, id: string, instagram?: string | null, name?: string | null } | null };

export type CalendarSalesQueryVariables = Exact<{
  status: SaleStatus;
  storeId: StoreRegion;
}>;


export type CalendarSalesQuery = { __typename?: 'Query', calendarSales: { __typename?: 'CalendarSalesResult', sales: Array<{ __typename?: 'CalendarSale', cancellation_level?: string | null, category?: string | null, deliver_by_choose?: boolean | null, end_at_date: string, forecast?: number | null, gender?: number | null, hide?: boolean | null, hubspot_category?: string | null, hubspot_deal_id?: string | null, hubspot_selection_id?: string | null, hubspot_team_name?: TeamName | null, hubspot_tiering?: Tiering | null, hubspot_top_brand_type?: TopBrandType | null, id: string, is_cancelled?: boolean | null, is_ready?: boolean | null, is_setup?: boolean | null, isShopify?: boolean | null, hubspot_demande_point_relais?: PointRelais | null, logistics_manager?: string | null, note?: string | null, operation_type?: string | null, hasPreviews: boolean, hasHeader: boolean, hasDescription: boolean, sale_status?: SaleStatusFilter | null, selection_name?: string | null, setup_status?: SaleSetupStatus | null, setup_by?: string | null, start_at_date: string, stats_stock?: any | null, storeId: StoreRegion, total_sales?: number | null, url_google_drive?: string | null, url_google_drive_not_validated?: string | null, pricingErrorsCount?: number | null, brand?: { __typename?: 'Brand', id: string, name?: string | null, contactEmail?: string | null, contactName?: string | null, website?: string | null, instagram?: string | null } | null, shippingPolicy: { __typename?: 'ShippingPolicy', pickupPoint?: { __typename?: 'ShippingPolicyPickupPoint', network: PickupPointNetwork, shippingCost: number } | null }, shopify?: { __typename?: 'ShopifyData', hasCredentials: boolean, isStockLive: boolean, testMondialRelayOn?: string | null, testOrderOn?: string | null, testShop2ShopOn?: string | null } | null, deal?: { __typename?: 'Deal', link: string } | null }> } };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', ids: Array<string>, category: string, sub_categories: Array<{ __typename?: 'SubCategory', category: string, ids: Array<string> }> }> };

export type CategoryEssentialOptionsQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type CategoryEssentialOptionsQuery = { __typename?: 'Query', categoryEssentialOptions: Array<{ __typename?: 'CategoryOption', text: string, type: string, values: Array<string>, placeholders: Array<string> }> };

export type CategoryOptionsQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type CategoryOptionsQuery = { __typename?: 'Query', categoryOptions: Array<{ __typename?: 'CategoryOption', text: string, type: string, values: Array<string>, placeholders: Array<string> }> };

export type CategoryTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoryTreeQuery = { __typename?: 'Query', categoryTree: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean, subCategories?: Array<{ __typename?: 'CategoryTree', id: string, label: string, tva?: number | null, notReturnable: boolean }> | null }> | null }> | null }> | null }> | null }> | null }> };

export type CouponsQueryVariables = Exact<{
  status: CouponStatus;
  storeId: StoreRegion;
}>;


export type CouponsQuery = { __typename?: 'Query', coupons: Array<{ __typename?: 'Coupon', id?: number | null, code?: string | null, type?: CodeType | null, value?: number | null, start_at?: string | null, expires_at?: string | null, quantity?: number | null, quantity_per_user?: number | null, minimum_order_amount?: number | null, first_order_only?: boolean | null, total_used?: number | null, store_id?: StoreRegion | null }> };

export type CrossSellingPreviewSessionQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type CrossSellingPreviewSessionQuery = { __typename?: 'Query', crossSellingPreviewSession?: { __typename?: 'CrossSellingPreviewSession', sessionId: string, saleId: string, intent: string, status: CrossSellingPreviewStatus, errorCode?: string | null, expiresAt: string, progress?: { __typename?: 'CrossSellingPreviewProgress', phase: CrossSellingPreviewPhase, completedRequests: number, totalRequests: number } | null, preview?: { __typename?: 'CrossSellingPreview', suggestions: Array<{ __typename?: 'CrossSelling', productId: string, products: Array<{ __typename?: 'CrossSellingProduct', productId: string, score?: number | null }> }> } | null } | null };

export type GetImagesByProductIdsQueryVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetImagesByProductIdsQuery = { __typename?: 'Query', getImagesByProductIds: Array<{ __typename?: 'ProductImage', id: string, productId: string, url: string, originalUrl: string, currentVersion: number, isCover: boolean, isVariantCover: boolean, isOriginal: boolean, aspect?: ImageAspect | null }> };

export type GetImmersiveCalendarQueryVariables = Exact<{
  storeId: StoreRegion;
  startAt: Scalars['LocalDate']['input'];
  endAt: Scalars['LocalDate']['input'];
}>;


export type GetImmersiveCalendarQuery = { __typename?: 'Query', marketing: { __typename?: 'MarketingQueries', getImmersiveCalendar: Array<{ __typename?: 'ImmersiveCalendarDay', date: string, current: Array<{ __typename?: 'ImmersiveSale', id: string, saleId: string, videoUrl?: string | null, imageUrl?: string | null, brandLogoUrl?: string | null, stickerUrl?: string | null, description?: string | null, saleName: string, buttonText?: string | null, url?: string | null, startAt: string, endAt: string, universeIds: Array<string | null>, status: SaleImmersiveStatus, showForDays: number, forceFirstPosition: boolean } | null>, stillActive: Array<{ __typename?: 'ImmersiveSale', id: string, saleId: string, videoUrl?: string | null, imageUrl?: string | null, brandLogoUrl?: string | null, stickerUrl?: string | null, description?: string | null, saleName: string, buttonText?: string | null, url?: string | null, startAt: string, endAt: string, universeIds: Array<string | null>, status: SaleImmersiveStatus, showForDays: number, forceFirstPosition: boolean } | null> } | null> } };

export type GetImmersiveSalesQueryVariables = Exact<{
  storeId: StoreRegion;
  startAt: Scalars['LocalDate']['input'];
  endAt: Scalars['LocalDate']['input'];
}>;


export type GetImmersiveSalesQuery = { __typename?: 'Query', marketing: { __typename?: 'MarketingQueries', getImmersiveSales: Array<{ __typename?: 'ImmersiveSale', id: string, saleId: string, videoUrl?: string | null, imageUrl?: string | null, brandLogoUrl?: string | null, stickerUrl?: string | null, description?: string | null, saleName: string, buttonText?: string | null, url?: string | null, startAt: string, endAt: string, universeIds: Array<string | null>, status: SaleImmersiveStatus, showForDays: number, forceFirstPosition: boolean } | null> } };

export type NextCollectionSaleQueryVariables = Exact<{ [key: string]: never; }>;


export type NextCollectionSaleQuery = { __typename?: 'Query', nextCollectionSale?: { __typename?: 'CollectionSale', saleId: string, name: string, customFilters: Array<{ __typename?: 'CustomFilter', id: string, label: string, values: Array<{ __typename?: 'CustomFilterValue', value: string, label: string }> }> } | null };

export type GetNextImmersiveSalesQueryVariables = Exact<{
  storeId: StoreRegion;
  startAt: Scalars['LocalDate']['input'];
  endAt: Scalars['LocalDate']['input'];
}>;


export type GetNextImmersiveSalesQuery = { __typename?: 'Query', marketing: { __typename?: 'MarketingQueries', getNextImmersiveSales: Array<{ __typename?: 'NextImmersiveSale', id: string, saleId: string, displayFromDayOffset: number, videoUrl?: string | null, imageUrl?: string | null, brandLogoUrl?: string | null, brandName?: string | null, description?: string | null, descriptionTranslationKey?: string | null, url?: string | null, startAt: string, endAt: string, forceFirstPositionDates: Array<string>, saleStartAt: string, status: SaleImmersiveNextStatus, universeIds: Array<string | null>, preTeasingDates?: Array<{ __typename?: 'PreTeasingDate', startAt: string, endAt: string }> | null } | null> } };

export type GetProductCouponsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['ID']['input']>;
  count: Scalars['Int']['input'];
}>;


export type GetProductCouponsQuery = { __typename?: 'Query', getProductCouponsV2: { __typename?: 'ProductCouponsV2', boughtCodes: number, total: number, codes: Array<{ __typename?: 'ProductCoupon', code: string, order_id?: string | null, product_id: string, variant_id?: string | null }> } };

export type ProductLinkedProductsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type ProductLinkedProductsQuery = { __typename?: 'Query', product: { __typename?: 'ProductV3', id: string, linkedProducts: Array<{ __typename?: 'LinkedProduct', productId: string, relatedProductId: string }> } };

export type GetProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product: { __typename?: 'ProductV3', id: string, type: ProductType, isDraft: boolean, isAlcohol?: boolean | null, sourceUrl?: string | null, hasVatMargin: boolean, hide: boolean, hideBy?: string | null, hideAt?: string | null, description?: string | null, name: string, modelSizeInfos?: string | null, sizeAdvices?: string | null, currency: StoreCurrency, gender?: number | null, couponDetail?: string | null, couponExpirationDate?: string | null, cgu?: Array<string> | null, faqPreOrder?: string | null, faq?: Array<string> | null, faqPostOrder?: string | null, isCobrand: boolean, isCobrandFeatured: boolean, isBestSeller: boolean, isHighlightedAsNew: boolean, isCover: boolean, isReturnable: boolean, isDeliveredByChoose?: boolean | null, isGiveaway: boolean, position?: number | null, video?: string | null, badges: Array<{ __typename?: 'ProductBadge', isSpecial: boolean, position: number, value: string }>, category?: { __typename?: 'ProductCategory', name: string, vat: number } | null, brand: { __typename?: 'ProductBrand', id: string, name: string }, variants: Array<{ __typename?: 'ProductVariantV2', id: string, position?: number | null, isUnique: boolean, hide: boolean, hideBy?: string | null, hideAt?: string | null, gtin?: string | null, sku?: string | null, shopify_variant_id?: string | null, images?: Array<string | null> | null, absorbedShipping?: number | null, buyingPrice?: number | null, chooseFees?: number | null, deliveryDelays?: number | null, discountPercentage?: number | null, eeePrice?: number | null, retailPrice?: number | null, price?: number | null, shippingFees?: number | null, weightGram?: number | null, widthMillimeter?: number | null, heightMillimeter?: number | null, lengthMillimeter?: number | null, unitsPerPack?: number | null, stockCount?: number | null, originCountry?: string | null, options: Array<{ __typename?: 'ProductVariantOptionV2', productOptionId: string, valueId: string }> }>, options?: Array<{ __typename?: 'ProductOptionV3', id: string, type?: string | null, name: string, position: number, images?: Array<{ __typename?: 'Image', id: string, baseKey?: string | null, image?: string | null }> | null, values: Array<{ __typename?: 'ProductOptionValueV2', id: string, value: string, position: number }> }> | null, customFields?: Array<{ __typename?: 'CustomField', key: string, position: number, type?: string | null, value: string }> | null, images?: Array<{ __typename?: 'Image', id: string, baseKey?: string | null, image?: string | null }> | null, audio?: { __typename?: 'ProductAudio', url: string, label?: string | null } | null, inCollections: Array<{ __typename?: 'ProductInCollection', collectionSaleId: string, isBestseller: boolean, customFilters: Array<{ __typename?: 'ProductCustomFilter', filterId: string, selectedValues: Array<string> }> }> } };

export type ProvisionalSalesQueryVariables = Exact<{
  storeId: StoreRegion;
}>;


export type ProvisionalSalesQuery = { __typename?: 'Query', provisionalSales: Array<{ __typename?: 'ProvisionalSale', id: string, name: string, category?: string | null, saleBy?: string | null, startsAt: string, brandHasShopify?: boolean | null, forecast?: number | null, hubspotId?: string | null, hubspotCategory?: string | null, hubspot_team_name?: TeamName | null, hubspot_tiering?: Tiering | null, hubspot_top_brand_type?: TopBrandType | null, hubspot_demande_point_relais?: PointRelais | null, cancellationLevel?: string | null, operationType?: string | null, gender?: number | null, instagramId?: string | null, website?: string | null, note?: string | null, brandSaleCount?: number | null, shopify?: { __typename?: 'ShopifyData', hasCredentials: boolean, isStockLive: boolean, testMondialRelayOn?: string | null, testOrderOn?: string | null, testShop2ShopOn?: string | null } | null, deal?: { __typename?: 'Deal', link: string } | null }> };

export type ReferralBlockQueryVariables = Exact<{
  store: StoreRegion;
}>;


export type ReferralBlockQuery = { __typename?: 'Query', marketing: { __typename?: 'MarketingQueries', referralBlock?: { __typename?: 'MarketingReferralBlock', bigImage: string, btnCta: string, date: string, smallImage: string, tagline: string, title: string } | null } };

export type GetReferralUploadUrlQueryVariables = Exact<{
  fileType: Scalars['String']['input'];
  saleId: Scalars['String']['input'];
  uploadType: MarketingReferralImageType;
}>;


export type GetReferralUploadUrlQuery = { __typename?: 'Query', marketing: { __typename?: 'MarketingQueries', getReferralUploadUrl?: { __typename?: 'UploadUrl', key: string, url: string } | null } };

export type SaleAppFiltersQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SaleAppFiltersQuery = { __typename?: 'Query', saleAppFilters?: { __typename?: 'SaleAppFilters', displayed: Array<{ __typename?: 'SaleAppFilter', id: string, label: string }>, shortcutable: Array<{ __typename?: 'SaleAppFilter', id: string, label: string }> } | null };

export type SaleCustomFiltersQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SaleCustomFiltersQuery = { __typename?: 'Query', saleCustomFilters: Array<{ __typename?: 'SaleCustomFilter', id: string, name: string, productsCount: number, options: Array<{ __typename?: 'SaleCustomFilterOption', value: string, label: string, position: number, productsCount: number }> }> };

export type SaleLinkedProductsMetadataQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type SaleLinkedProductsMetadataQuery = { __typename?: 'Query', sale?: { __typename?: 'Sale', id: string, linkedProductsMetadata?: { __typename?: 'LinkedProductsMetadata', titleKey: string, titleFallback: string } | null } | null };

export type SaleLinkedProductsQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type SaleLinkedProductsQuery = { __typename?: 'Query', sale?: { __typename?: 'Sale', id: string, linkedProducts: Array<{ __typename?: 'LinkedProduct', productId: string, relatedProductId: string }> } | null };

export type GetSaleProductCheckCountQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type GetSaleProductCheckCountQuery = { __typename?: 'Query', saleProductCheckCount: { __typename?: 'SaleProductCheckCount', tva?: number | null, unit_price?: number | null, public_price?: number | null, sizes?: number | null, informations?: number | null, description_coherence?: number | null, description_spelling?: number | null, warranties?: number | null, history_price?: number | null, wrong_shopify_variant_id?: number | null, wrong_barcode?: number | null } };

export type GetSaleProductCheckStatusesQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type GetSaleProductCheckStatusesQuery = { __typename?: 'Query', saleProductCheckStatuses: Array<{ __typename?: 'ProductCheckStatus', id: string, productId: string, variantId?: string | null, checkType: ProductCheckType, status: ProductCheckStatusValue, severity?: ProductCheckSeverity | null, message?: string | null, dismissedAt?: string | null, dismissedBy?: string | null, createdAt: string, updatedAt: string, data?:
      | { __typename?: 'CoherenceCheckData', coherenceErrors: Array<string> }
      | { __typename?: 'DeprecatedDescriptionCheckData' }
      | { __typename?: 'InformationCheckData', present: Array<string>, missing: Array<{ __typename?: 'InformationMissingData', key: string, importance: InformationMissingDataImportance }> }
      | { __typename?: 'PublicPriceCheckData', choose_price?: number | null, shopify_price?: number | null, choose_discount_price?: number | null, shopify_discount_price?: number | null }
      | { __typename?: 'SizesCheckData', id: string, original: string, correction: string }
      | { __typename?: 'SpellingCheckData', spellingErrors: Array<{ __typename?: 'Correction', original: string, correction: string }> }
     | null }> };

export type SaleQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type SaleQuery = { __typename?: 'Query', sale?: { __typename?: 'Sale', badges?: any | null, category?: string | null, currency?: StoreCurrency | null, deliver_by_choose?: boolean | null, delivery_delays?: number | null, delivery_offered_until?: string | null, description?: string | null, disable_sorting?: boolean | null, end_at: string, end_at_date: string, has_orders?: boolean | null, hasReturnableProducts: boolean, hide?: boolean | null, hubspot_campaign_type?: CampaignType | null, hubspot_deal_id?: string | null, hubspot_selection_id?: string | null, id: string, image_header?: string | null, video_header?: string | null, initial_start_at?: string | null, is_cancelled?: boolean | null, is_ready?: boolean | null, is_selection?: boolean | null, is_setup?: boolean | null, isShopify?: boolean | null, hubspot_demande_point_relais?: PointRelais | null, logistics_manager?: string | null, operation_type?: string | null, sale_status?: SaleStatusFilter | null, selection_name?: string | null, setup_by?: string | null, disable_automatic_extension?: boolean | null, start_at: string, start_at_date: string, status?: SaleSetupStatus | null, storeId: StoreRegion, tva?: number | null, upcoming_display_forced: boolean, url?: string | null, url_google_drive?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null, contactName?: string | null, sale_objectif_name?: string | null, contactPhone?: string | null, accept_contract?: boolean | null, about?: string | null, contactEmail?: string | null, instagram?: string | null, address?: any | null, is_autoentrepreneur?: boolean | null, shipping_restricted_to_france?: boolean | null, emailedAt?: string | null, invitationLink?: string | null, plugins?: { __typename?: 'Plugins', shopify?: any | null } | null } | null, cashbackPolicy?: { __typename?: 'CashbackPolicy', delayInDays: number, thresholds: Array<{ __typename?: 'CashbackThreshold', threshold: number, cashbackAmount: number }> } | null, collectionSale?: { __typename?: 'CollectionSale', saleId: string, name: string, bestsellersProducts: Array<string>, customFilters: Array<{ __typename?: 'CustomFilter', id: string, label: string }>, readonlyFilters?: Array<{ __typename?: 'CustomFilter', id: string, label: string, values: Array<{ __typename?: 'CustomFilterValue', value: string, label: string }> }> | null } | null, customFilters: Array<{ __typename?: 'CustomFilter', id: string, label: string, values: Array<{ __typename?: 'CustomFilterValue', value: string, label: string }> }>, filtersConfig?: { __typename?: 'SaleFiltersConfig', illustrated: boolean, selectedColor?: string | null, hiddenFilterIds: Array<string>, shortcutFilterIds: Array<string>, filterImages: Array<{ __typename?: 'SaleFilterImage', filterId: string, imageUrl: string }> } | null, deal?: { __typename?: 'Deal', link: string } | null, giveawayPolicies: Array<{ __typename?: 'GiveawaySalePolicy', saleId: string, overOrderAmount: number, productId: string, triggerProductId?: string | null, dateRange?: { __typename?: 'DateRange', startAt: string, endAt: string } | null }>, invoice?: { __typename?: 'Invoice', is_invoice_ready?: boolean | null, invoice_amount?: string | null, invoice_by?: string | null, invoice_on?: string | null, paid_on?: string | null, proof_paid_url?: string | null, paid_amount?: number | null, paid_by?: string | null } | null, marketingVideo?: { __typename?: 'MarketingVideo', url: string, coverImageUrl: string, label: string, title: string } | null, newImages?: Array<{ __typename?: 'SaleImage', baseKey: string, id: string, image: string, properties?: { __typename?: 'SaleImageProperties', full?: boolean | null, gender?: number | null } | null }> | null, newPreviews?: Array<{ __typename?: 'Preview', baseKey: string, full?: boolean | null, id: string, image: string }> | null, products: Array<{ __typename?: 'ProductV3', currency: StoreCurrency, description?: string | null, hasVatMargin: boolean, hide: boolean, hideBy?: string | null, hideAt?: string | null, id: string, video?: string | null, importCsvPosition?: number | null, isCobrand: boolean, isCobrandFeatured: boolean, isBestSeller: boolean, isHighlightedAsNew: boolean, isCover: boolean, isDeliveredByChoose?: boolean | null, isDraft: boolean, isGiveaway: boolean, isReturnable: boolean, modelSizeInfos?: string | null, name: string, position?: number | null, sourceUrl?: string | null, sizeAdvices?: string | null, couponDetail?: string | null, couponExpirationDate?: string | null, cgu?: Array<string> | null, faqPreOrder?: string | null, faq?: Array<string> | null, faqPostOrder?: string | null, type: ProductType, badges: Array<{ __typename?: 'ProductBadge', isSpecial: boolean, position: number, value: string }>, brand: { __typename?: 'ProductBrand', id: string, name: string }, campaign?: { __typename?: 'ProductCampaign', startAt: string, endAt: string } | null, category?: { __typename?: 'ProductCategory', name: string, vat: number } | null, customFields?: Array<{ __typename?: 'CustomField', key: string, position: number, type?: string | null, value: string }> | null, images?: Array<{ __typename?: 'Image', id: string, baseKey?: string | null, image?: string | null }> | null, audio?: { __typename?: 'ProductAudio', url: string, label?: string | null } | null, options?: Array<{ __typename?: 'ProductOptionV3', id: string, type?: string | null, name: string, position: number, images?: Array<{ __typename?: 'Image', id: string, baseKey?: string | null, image?: string | null }> | null, values: Array<{ __typename?: 'ProductOptionValueV2', id: string, value: string, position: number }> }> | null, variants: Array<{ __typename?: 'ProductVariantV2', id: string, position?: number | null, isUnique: boolean, hide: boolean, hideBy?: string | null, hideAt?: string | null, gtin?: string | null, sku?: string | null, shopify_variant_id?: string | null, images?: Array<string | null> | null, absorbedShipping?: number | null, buyingPrice?: number | null, chooseFees?: number | null, computedDeliveryDelays?: number | null, discountPercentage?: number | null, eeePrice?: number | null, retailPrice?: number | null, price?: number | null, shippingFees?: number | null, weightGram?: number | null, widthMillimeter?: number | null, heightMillimeter?: number | null, lengthMillimeter?: number | null, stockCount?: number | null, originCountry?: string | null, unitsPerPack?: number | null, options: Array<{ __typename?: 'ProductVariantOptionV2', productOptionId: string, valueId: string }>, customFilters: Array<{ __typename?: 'ProductCustomFilter', filterId: string, selectedValues: Array<string> }> }>, readonlyFilters?: Array<{ __typename?: 'ProductCustomFilter', filterId: string, selectedValues: Array<string> }> | null }>, shopify?: { __typename?: 'ShopifyData', testMondialRelayOn?: string | null, testOrderOn?: string | null, testShop2ShopOn?: string | null, hasPlugin: boolean } | null, shippingPolicy: { __typename?: 'ShippingPolicy', freeShippingMinimumOrderAmount?: number | null, pickupPoint?: { __typename?: 'ShippingPolicyPickupPoint', network: PickupPointNetwork, shippingCost: number } | null, freeShippingRules?: Array<{ __typename?: 'ShippingFreeShippingRule', countries?: Array<string> | null, deliveryMethod: ShippingDeliveryMethod, freeShippingMinimumOrderAmount: number, commercialOfferMinimumOrderAmount?: number | null }> | null }, widgets?: Array<{ __typename?: 'Widget', created_at?: string | null, id: string, proposition?: any | null, results?: any | null, state?: WidgetState | null, type?: WidgetType | null } | null> | null } | null };

export type SalesQueryVariables = Exact<{
  status: SaleStatus;
  storeId: StoreRegion;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SalesQuery = { __typename?: 'Query', sales?: { __typename?: 'SalesCache', has_more?: boolean | null, pagination?: number | null, total_sales?: number | null, sales: Array<{ __typename?: 'Sale', badges?: any | null, category?: string | null, end_at_date: string, hide?: boolean | null, id: string, deliver_by_choose?: boolean | null, delivery_offered_until?: string | null, image_header?: string | null, is_selection?: boolean | null, logistics_manager?: string | null, selection_name?: string | null, setup_by?: string | null, start_at_date: string, upcoming_display_forced: boolean, brand?: { __typename?: 'Brand', name?: string | null, contactName?: string | null } | null }> } | null };

export type GetSetupIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSetupIssuesQuery = { __typename?: 'Query', getSetupIssues: Array<{ __typename?: 'SetupIssue', id: string, type: SetupIssueType, description: string }> };

export type GetShopifyLocationsQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
}>;


export type GetShopifyLocationsQuery = { __typename?: 'Query', shopify: { __typename?: 'ShopifyQueries', getShopifyInventoryAvailable: Array<{ __typename?: 'InventoryAvailable', id: string, name: string }> } };

export type GetShopifyPermissionsQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
}>;


export type GetShopifyPermissionsQuery = { __typename?: 'Query', shopify: { __typename?: 'ShopifyQueries', getShopifyPermissions: { __typename?: 'ShopifyPermissions', warning_too_much_permissions: boolean, is_disconnected: boolean, can_create_order: boolean, can_sync_stock: boolean, can_create_draft_order: boolean, can_read_fulfillments: boolean, can_update_stock: boolean, can_create_order_products: boolean, can_read_delivery_services: boolean, can_read_returns: boolean, can_write_returns: boolean, has_stock_protection: boolean, set_product_price: boolean, delivery?: string | null, mondial_relay_code?: string | null, international_carrier_code?: string | null, can_create_order_with_specific_location_id: boolean, inventory_location_ids?: Array<string> | null, can_read_locations: boolean, deliveries?: Array<string> | null, deliveries_list: { __typename?: 'ShopifyPermissionsDeliveries', BE: Array<string>, ES: Array<string>, FR: Array<string>, US: Array<string> } } } };

export type GetShopifyProductsQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
}>;


export type GetShopifyProductsQuery = { __typename?: 'Query', shopify: { __typename?: 'ShopifyQueries', getShopifyProducts: { __typename?: 'ShopifyProductsOutput', error?: string | null, url?: string | null } } };

export type GetShopifyUnfulfilledOrdersQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
}>;


export type GetShopifyUnfulfilledOrdersQuery = { __typename?: 'Query', shopify: { __typename?: 'ShopifyQueries', getShopifyUnfulfilledOrders: { __typename?: 'ShopifyUnfulfilledOrdersOutput', count: number, error?: string | null, url?: string | null } } };

export type OngoingAndUpcomingSalesQueryVariables = Exact<{
  storeId: StoreRegion;
}>;


export type OngoingAndUpcomingSalesQuery = { __typename?: 'Query', ongoingSales?: { __typename?: 'SalesCache', has_more?: boolean | null, pagination?: number | null, total_sales?: number | null, sales: Array<{ __typename?: 'Sale', badges?: any | null, category?: string | null, end_at_date: string, hide?: boolean | null, id: string, image_header?: string | null, is_selection?: boolean | null, logistics_manager?: string | null, sale_status?: SaleStatusFilter | null, selection_name?: string | null, setup_by?: string | null, start_at_date: string, storeId: StoreRegion, upcoming_display_forced: boolean, brand?: { __typename?: 'Brand', id: string, name?: string | null, contactEmail?: string | null, contactName?: string | null } | null }> } | null, upcomingSales?: { __typename?: 'SalesCache', has_more?: boolean | null, pagination?: number | null, total_sales?: number | null, sales: Array<{ __typename?: 'Sale', badges?: any | null, category?: string | null, end_at_date: string, hide?: boolean | null, id: string, image_header?: string | null, is_selection?: boolean | null, logistics_manager?: string | null, sale_status?: SaleStatusFilter | null, selection_name?: string | null, setup_by?: string | null, start_at_date: string, storeId: StoreRegion, upcoming_display_forced: boolean, brand?: { __typename?: 'Brand', id: string, name?: string | null, contactEmail?: string | null, contactName?: string | null } | null }> } | null };

export type GetUploadUrlQueryVariables = Exact<{
  fileType: Scalars['String']['input'];
  uploadType: FileUploadType;
  saleId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUploadUrlQuery = { __typename?: 'Query', getUploadUrl?: any | null };

export type HideOutOfStockProductsAndVariantsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type HideOutOfStockProductsAndVariantsMutation = { __typename?: 'Mutation', hideOutOfStockProductsAndVariants?: any | null };

export type ImageProccessedSubscriptionVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type ImageProccessedSubscription = { __typename?: 'Subscription', imageProccessed: { __typename?: 'ImageProccessed', actionId: string, id: string, url: string } };

export type ImportProductsUpdatedSubscriptionVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type ImportProductsUpdatedSubscription = { __typename?: 'Subscription', importProductsUpdated?: { __typename?: 'importProductsUpdatedPayload', id: string, saleId: string, error?: { __typename?: 'importProductsUpdatedErrorPayload', code?: string | null, message?: string | null } | null } | null };

export type ImportProductsMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportProductsMutation = { __typename?: 'Mutation', importProducts?: string | null };

export type MakePublicFileQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type MakePublicFileQuery = { __typename?: 'Query', makePublicFile?: any | null };

export type MarkSaleTrackingsAsDeliveredMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  filters: MarkSaleTrackingsAsDeliveredFilter;
}>;


export type MarkSaleTrackingsAsDeliveredMutation = { __typename?: 'Mutation', markSaleTrackingsAsDelivered?: string | null };

export type MoveProductsToPositionMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startPosition: Scalars['Int']['input'];
}>;


export type MoveProductsToPositionMutation = { __typename?: 'Mutation', moveProductsToPosition?: any | null };

export type PreviewImageMutationVariables = Exact<{
  image: TransformImageData;
}>;


export type PreviewImageMutation = { __typename?: 'Mutation', previewImage:
    | { __typename: 'ErrorLike', message: string }
    | { __typename: 'ImagePreview', url: string }
   };

export type ProcessProductAudioMutationVariables = Exact<{
  input: ProcessProductAudioInput;
}>;


export type ProcessProductAudioMutation = { __typename?: 'Mutation', processProductAudio: { __typename?: 'ProcessProductAudioResult', audioUrl: string } };

export type ProcessProductVideoMutationVariables = Exact<{
  input: ProcessProductVideoInput;
}>;


export type ProcessProductVideoMutation = { __typename?: 'Mutation', processProductVideo: { __typename?: 'ProcessProductVideoResult', videoUrl: string } };

export type PublishProductsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PublishProductsMutation = { __typename?: 'Mutation', publishProducts?: any | null };

export type PublishSpotlightConfigMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type PublishSpotlightConfigMutation = { __typename?: 'Mutation', publishSpotlightConfig:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SpotlightConfig', blocks: any, status: SpotlightConfigurationStatus, rankSchedule: Array<{ __typename?: 'SpotlightRankTier', fromDay: number, rank: number }> }
    | { __typename: 'SpotlightConfigValidationError', issues: Array<{ __typename?: 'SpotlightConfigValidationIssue', path: Array<string>, code: string, message: string }> }
   };

export type RemoveBackgroundImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
}>;


export type RemoveBackgroundImagesMutation = { __typename?: 'Mutation', removeBackgroundImages?: any | null };

export type RemoveCouponMutationVariables = Exact<{
  couponId: Scalars['Int']['input'];
}>;


export type RemoveCouponMutation = { __typename?: 'Mutation', removeCoupon?: string | null };

export type RemoveGtinsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveGtinsMutation = { __typename?: 'Mutation', removeGtins?: any | null };

export type RemoveImmersiveSaleNextMutationVariables = Exact<{
  nextImmersiveId: Scalars['String']['input'];
}>;


export type RemoveImmersiveSaleNextMutation = { __typename?: 'Mutation', removeImmersiveSaleNext?: boolean | null };

export type RemoveImmersiveSaleMutationVariables = Exact<{
  immersiveId: Scalars['String']['input'];
}>;


export type RemoveImmersiveSaleMutation = { __typename?: 'Mutation', removeImmersiveSale?: boolean | null };

export type RemoveProductCouponsMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}>;


export type RemoveProductCouponsMutation = { __typename?: 'Mutation', removeProductCoupons?: string | null };

export type RemoveProductFromCollectionMutationVariables = Exact<{
  collectionSaleId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}>;


export type RemoveProductFromCollectionMutation = { __typename?: 'Mutation', removeProductFromCollection?: boolean | null };

export type RemoveProductsBadgesMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  badges: Array<ProductBadgeInput> | ProductBadgeInput;
}>;


export type RemoveProductsBadgesMutation = { __typename?: 'Mutation', removeProductsBadges?: any | null };

export type RemoveProductsImagesMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  imageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveProductsImagesMutation = { __typename?: 'Mutation', removeProductsImages?: any | null };

export type RemoveProductsSizeGuideMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveProductsSizeGuideMutation = { __typename?: 'Mutation', removeProductsSizeGuide?: any | null };

export type RemoveVariantsImagesMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveVariantsImagesMutation = { __typename?: 'Mutation', removeProductsVariantsImages?: any | null };

export type RemoveProductsMutationVariables = Exact<{
  productsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  saleId: Scalars['String']['input'];
}>;


export type RemoveProductsMutation = { __typename?: 'Mutation', removeProducts?: string | null };

export type RemoveProvisionalSaleMutationVariables = Exact<{
  key?: InputMaybe<Scalars['String']['input']>;
  dataKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveProvisionalSaleMutation = { __typename?: 'Mutation', deleteDealToCalendar?: string | null };

export type RemoveSaleFiltersConfigMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type RemoveSaleFiltersConfigMutation = { __typename?: 'Mutation', removeSaleFiltersConfig?: boolean | null };

export type RemoveSaleMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
}>;


export type RemoveSaleMutation = { __typename?: 'Mutation', removeSale?: string | null };

export type RemoveShopifyPluginMutationVariables = Exact<{
  sellerId: Scalars['ID']['input'];
}>;


export type RemoveShopifyPluginMutation = { __typename?: 'Mutation', removeShopifyPlugin?: boolean | null };

export type RemoveShopifyVariantIdsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveShopifyVariantIdsMutation = { __typename?: 'Mutation', removeProductsShopifyVariantIds?: any | null };

export type RemoveSkusMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveSkusMutation = { __typename?: 'Mutation', removeSkus?: any | null };

export type RemoveWidgetMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type RemoveWidgetMutation = { __typename?: 'Mutation', removeWidget?: string | null };

export type RenameSaleCustomFilterOptionMutationVariables = Exact<{
  input: RenameSaleCustomFilterOptionInput;
}>;


export type RenameSaleCustomFilterOptionMutation = { __typename?: 'Mutation', renameSaleCustomFilterOption:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SaleCustomFilter', id: string, options: Array<{ __typename?: 'SaleCustomFilterOption', value: string, label: string, position: number, productsCount: number }> }
   };

export type RenameSaleCustomFilterMutationVariables = Exact<{
  input: RenameSaleCustomFilterInput;
}>;


export type RenameSaleCustomFilterMutation = { __typename?: 'Mutation', renameSaleCustomFilter:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SaleCustomFilter', id: string, name: string }
   };

export type ReorderSaleCustomFilterOptionsMutationVariables = Exact<{
  input: ReorderSaleCustomFilterOptionsInput;
}>;


export type ReorderSaleCustomFilterOptionsMutation = { __typename?: 'Mutation', reorderSaleCustomFilterOptions:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SaleCustomFilter', id: string, options: Array<{ __typename?: 'SaleCustomFilterOption', value: string, label: string, position: number, productsCount: number }> }
   };

export type ReplaceProductsDescriptionMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  payload: Array<ReplacePayload> | ReplacePayload;
}>;


export type ReplaceProductsDescriptionMutation = { __typename?: 'Mutation', replaceProductsDescription?: any | null };

export type ReplaceProductsNameMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  payload: Array<ReplacePayload> | ReplacePayload;
}>;


export type ReplaceProductsNameMutation = { __typename?: 'Mutation', replaceProductsName?: any | null };

export type ReplaceSaleCustomFilterContentMutationVariables = Exact<{
  input: ReplaceSaleCustomFilterContentInput;
}>;


export type ReplaceSaleCustomFilterContentMutation = { __typename?: 'Mutation', replaceSaleCustomFilterContent:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SaleCustomFilter', id: string, productsCount: number, options: Array<{ __typename?: 'SaleCustomFilterOption', value: string, label: string, position: number, productsCount: number }> }
   };

export type SalesCountQueryVariables = Exact<{
  storeId: StoreRegion;
}>;


export type SalesCountQuery = { __typename?: 'Query', salesCount?: Array<{ __typename?: 'SaleCount', count?: number | null } | null> | null };

export type SaveImageMutationVariables = Exact<{
  data: SaveImage;
}>;


export type SaveImageMutation = { __typename?: 'Mutation', saveImage:
    | { __typename: 'ErrorLike', message: string }
    | { __typename: 'ImageAdded', source_store_path_key: string, image_storage_path_key: string, image_updated_url: string, source_url: string }
   };

export type SaveImagesMutationVariables = Exact<{
  images: Array<ImageInput> | ImageInput;
  sessionId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
  options?: InputMaybe<SaveImagesOptions>;
}>;


export type SaveImagesMutation = { __typename?: 'Mutation', saveImages?: any | null };

export type SearchBrandQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type SearchBrandQuery = { __typename?: 'Query', searchBrand: Array<{ __typename?: 'Brand', id: string, name?: string | null, about?: string | null, createdAt?: string | null }> };

export type SearchSalesV2QueryVariables = Exact<{
  name: Scalars['String']['input'];
  store: StoreRegion;
  limit: Scalars['Int']['input'];
}>;


export type SearchSalesV2Query = { __typename?: 'Query', searchSalesV2: { __typename?: 'SalesElasticSearch', total?: number | null, hits?: Array<{ __typename?: 'SalesElasticSearchHit', _score: number, _source: any, url?: string | null, _id: string, highlight: any, status?: SaleStatusFilter | null } | null> | null } };

export type SendOnboardingEmailMutationVariables = Exact<{
  brandId: Scalars['String']['input'];
}>;


export type SendOnboardingEmailMutation = { __typename?: 'Mutation', sendOnboardingEmail?: string | null };

export type SetProductAsBestSellerMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  isBestSeller: Scalars['Boolean']['input'];
}>;


export type SetProductAsBestSellerMutation = { __typename?: 'Mutation', setProductAsBestSeller?: any | null };

export type SetProductAsCoverMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  isCover: Scalars['Boolean']['input'];
}>;


export type SetProductAsCoverMutation = { __typename?: 'Mutation', setProductAsCover?: any | null };

export type SetProductHighlightedAsNewMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  isHighlightedAsNew: Scalars['Boolean']['input'];
}>;


export type SetProductHighlightedAsNewMutation = { __typename?: 'Mutation', setProductHighlightedAsNew?: any | null };

export type SetProductsAsUniqueMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetProductsAsUniqueMutation = { __typename?: 'Mutation', setProductsAsUnique?: any | null };

export type SetProductsHideMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type SetProductsHideMutation = { __typename?: 'Mutation', setProductsHide?: any | null };

export type SetSaleReadyMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  checkBy: Scalars['String']['input'];
  previewEmailText?: InputMaybe<Scalars['String']['input']>;
  previewEmailInfoText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetSaleReadyMutation = { __typename?: 'Mutation', setSaleReady?: string | null };

export type SetSetupReadyMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  difficulty: DifficultySetupLevel;
  timeRange: TimeRange;
  reasons: Array<Scalars['String']['input']> | Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetSetupReadyMutation = { __typename?: 'Mutation', setSetupReady?: string | null };

export type SetSetupWaitingForElementsMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  reasons: Array<SetupWaitingReason> | SetupWaitingReason;
  comments?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetSetupWaitingForElementsMutation = { __typename?: 'Mutation', setSetupWaitingForElements?: string | null };

export type SetShopifyStockProtectionMutationVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  protect: Scalars['Boolean']['input'];
}>;


export type SetShopifyStockProtectionMutation = { __typename?: 'Mutation', setShopifyStockProtection?: any | null };

export type ShowHiddenProductsAndVariantsMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ShowHiddenProductsAndVariantsMutation = { __typename?: 'Mutation', showHiddenProductsAndVariants?: any | null };

export type ShuffleProductListMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ShuffleProductListMutation = { __typename?: 'Mutation', shuffleProductList?: any | null };

export type SpotlightConfigQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SpotlightConfigQuery = { __typename?: 'Query', spotlightConfig?: { __typename?: 'SpotlightConfig', blocks: any, status: SpotlightConfigurationStatus, rankSchedule: Array<{ __typename?: 'SpotlightRankTier', fromDay: number, rank: number }> } | null };

export type StartCrossSellingsPreviewMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
  intent?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartCrossSellingsPreviewMutation = { __typename?: 'Mutation', startCrossSellingsPreview:
    | { __typename: 'CrossSellingPreviewSession', sessionId: string, saleId: string, intent: string, status: CrossSellingPreviewStatus, errorCode?: string | null, expiresAt: string, progress?: { __typename?: 'CrossSellingPreviewProgress', phase: CrossSellingPreviewPhase, completedRequests: number, totalRequests: number } | null, preview?: { __typename?: 'CrossSellingPreview', suggestions: Array<{ __typename?: 'CrossSelling', productId: string, products: Array<{ __typename?: 'CrossSellingProduct', productId: string, score?: number | null }> }> } | null }
    | { __typename: 'DomainException', exceptionCode: string }
   };

export type SyncPendingShopifyOrdersMutationVariables = Exact<{
  isDryRun: Scalars['Boolean']['input'];
  sellerId?: InputMaybe<Scalars['String']['input']>;
  saleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncPendingShopifyOrdersMutation = { __typename?: 'Mutation', syncPendingShopifyOrders: { __typename?: 'ShopifySyncPendingOrdersOutput', count: number, error?: string | null } };

export type SyncShopifyStockMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  brandId: Scalars['String']['input'];
}>;


export type SyncShopifyStockMutation = { __typename?: 'Mutation', syncShopifyStock: { __typename?: 'ShopifyStockSyncOutput', sync_count: number, error_count: number } };

export type TranslateProductsWithAiMutationVariables = Exact<{
  input: AiProductsInput;
}>;


export type TranslateProductsWithAiMutation = { __typename?: 'Mutation', translateProductsWithAI: string };

export type UnpublishSpotlightConfigMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type UnpublishSpotlightConfigMutation = { __typename?: 'Mutation', unpublishSpotlightConfig:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SpotlightConfig', blocks: any, status: SpotlightConfigurationStatus, rankSchedule: Array<{ __typename?: 'SpotlightRankTier', fromDay: number, rank: number }> }
    | { __typename: 'SpotlightConfigValidationError', issues: Array<{ __typename?: 'SpotlightConfigValidationIssue', path: Array<string>, code: string, message: string }> }
   };

export type UpdateAccentuateReferralMutationVariables = Exact<{
  data: AccentuateReferralInput;
}>;


export type UpdateAccentuateReferralMutation = { __typename?: 'Mutation', updateAccentuateReferral?: string | null };

export type UpdateBrandMutationVariables = Exact<{
  data?: InputMaybe<BrandUpdate>;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand?: string | null };

export type UpdateCouponMutationVariables = Exact<{
  data: CouponUpdate;
}>;


export type UpdateCouponMutation = { __typename?: 'Mutation', updateCoupon?: string | null };

export type UpdateInvoiceMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice?: string | null };

export type UpdateManyProductCouponMutationVariables = Exact<{
  data: Array<UpdateProductCouponManyInput> | UpdateProductCouponManyInput;
}>;


export type UpdateManyProductCouponMutation = { __typename?: 'Mutation', updateManyProductCoupon?: any | null };

export type UpdateManyProductOptionsMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  data: Array<UpdateProductOptionManyInput> | UpdateProductOptionManyInput;
}>;


export type UpdateManyProductOptionsMutation = { __typename?: 'Mutation', updateManyProductOptions?: Array<{ __typename?: 'ProductOptionError', id: string, message: string }> | null };

export type UpdateManyProductMutationVariables = Exact<{
  data: Array<UpdateProductManyInput> | UpdateProductManyInput;
}>;


export type UpdateManyProductMutation = { __typename?: 'Mutation', updateManyProduct?: any | null };

export type UpdateProductMutationVariables = Exact<{
  data: ProductUpdateInputV3;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProductV4: { __typename?: 'ProductV3', id: string, name: string, sourceUrl?: string | null, description?: string | null, gender?: number | null, isDraft: boolean, type: ProductType, video?: string | null, createdAt?: string | null, updatedAt?: string | null, hide: boolean, hideBy?: string | null, hideAt?: string | null, currency: StoreCurrency, position?: number | null, faq?: Array<string> | null, faqPreOrder?: string | null, faqPostOrder?: string | null, couponExpirationDate?: string | null, couponDetail?: string | null, cgu?: Array<string> | null, isAlcohol?: boolean | null, isDeliveredByChoose?: boolean | null, isReturnable: boolean, badges: Array<{ __typename?: 'ProductBadge', isSpecial: boolean, position: number, value: string }>, images?: Array<{ __typename?: 'Image', id: string, baseKey?: string | null, image?: string | null }> | null, audio?: { __typename?: 'ProductAudio', url: string, label?: string | null } | null, category?: { __typename?: 'ProductCategory', name: string, vat: number } | null, brand: { __typename?: 'ProductBrand', id: string, name: string }, variants: Array<{ __typename?: 'ProductVariantV2', id: string, images?: Array<string | null> | null, stockCount?: number | null, sku?: string | null, gtin?: string | null, position?: number | null, buyingPrice?: number | null, retailPrice?: number | null, price?: number | null, discountPercentage?: number | null, chooseFees?: number | null, hide: boolean, hideBy?: string | null, hideAt?: string | null, absorbedShipping?: number | null, shippingFees?: number | null, deliveryDelays?: number | null, unitsPerPack?: number | null, originCountry?: string | null, options: Array<{ __typename?: 'ProductVariantOptionV2', productOptionId: string, valueId: string }> }>, customFields?: Array<{ __typename?: 'CustomField', key: string, position: number, type?: string | null, value: string }> | null, options?: Array<{ __typename?: 'ProductOptionV3', id: string, type?: string | null, name: string, position: number, values: Array<{ __typename?: 'ProductOptionValueV2', id: string, position: number, value: string }>, images?: Array<{ __typename?: 'Image', id: string, baseKey?: string | null, image?: string | null }> | null }> | null } };

export type UpdateProductsBuyingPriceMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Float']['input'];
}>;


export type UpdateProductsBuyingPriceMutation = { __typename?: 'Mutation', updateProductsBuyingPrice?: any | null };

export type UpdateProductsCategoryMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  category: Scalars['String']['input'];
}>;


export type UpdateProductsCategoryMutation = { __typename?: 'Mutation', updateProductsCategory?: any | null };

export type UpdateProductsCouponExpiresAtMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['LocalDate']['input'];
}>;


export type UpdateProductsCouponExpiresAtMutation = { __typename?: 'Mutation', updateProductsCouponExpiresAt?: any | null };

export type UpdateProductsDeliveryMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type UpdateProductsDeliveryMutation = { __typename?: 'Mutation', updateProductsDelivery?: any | null };

export type UpdateProductsGenderMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Int']['input'];
}>;


export type UpdateProductsGenderMutation = { __typename?: 'Mutation', updateProductsGender?: any | null };

export type UpdateProductsOriginCountryMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['String']['input'];
}>;


export type UpdateProductsOriginCountryMutation = { __typename?: 'Mutation', updateProductsOriginCountry?: any | null };

export type UpdateProductsRetailPriceMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Int']['input'];
}>;


export type UpdateProductsRetailPriceMutation = { __typename?: 'Mutation', updateProductsRetailPrice?: any | null };

export type UpdateProductsReturnEligibilityMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isReturnable: Scalars['Boolean']['input'];
}>;


export type UpdateProductsReturnEligibilityMutation = { __typename?: 'Mutation', updateProductsReturnEligibility?: any | null };

export type UpdateProductsShippingCostMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Float']['input'];
}>;


export type UpdateProductsShippingCostMutation = { __typename?: 'Mutation', updateProductsShippingCost?: any | null };

export type UpdateProductsVatMarginMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type UpdateProductsVatMarginMutation = { __typename?: 'Mutation', updateProductsVatMargin?: any | null };

export type UpdateProvisionalSalePartialMutationVariables = Exact<{
  key?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
}>;


export type UpdateProvisionalSalePartialMutation = { __typename?: 'Mutation', updateDealKey?: string | null };

export type UpdateSaleMutationVariables = Exact<{
  sale: SaleInput;
  brandNameChanged?: InputMaybe<Scalars['Boolean']['input']>;
  skipReadyTrigger?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSaleMutation = { __typename?: 'Mutation', updateSale?: string | null };

export type UpsertNextImmersiveSaleMutationVariables = Exact<{
  nextImmersiveSale: NextImmersiveSaleInput;
}>;


export type UpsertNextImmersiveSaleMutation = { __typename?: 'Mutation', upsertNextImmersiveSale:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'NextImmersiveSale', id: string }
   };

export type UpsertImmersiveSaleMutationVariables = Exact<{
  immersiveSale: ImmersiveSaleInput;
}>;


export type UpsertImmersiveSaleMutation = { __typename?: 'Mutation', upsertImmersiveSale:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'ImmersiveSale', id: string }
   };

export type UpsertSaleFiltersConfigMutationVariables = Exact<{
  input: SaleFiltersConfigInput;
}>;


export type UpsertSaleFiltersConfigMutation = { __typename?: 'Mutation', upsertSaleFiltersConfig:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SaleFiltersConfig', illustrated: boolean, selectedColor?: string | null, hiddenFilterIds: Array<string>, shortcutFilterIds: Array<string>, filterImages: Array<{ __typename?: 'SaleFilterImage', filterId: string, imageUrl: string }> }
   };

export type UpsertSpotlightConfigMutationVariables = Exact<{
  input: SpotlightConfigInput;
}>;


export type UpsertSpotlightConfigMutation = { __typename?: 'Mutation', upsertSpotlightConfig:
    | { __typename: 'DomainException', errorCode: string, extra: Array<{ __typename?: 'ExceptionExtraTuple', key: string, value: string }> }
    | { __typename: 'SpotlightConfig', blocks: any, status: SpotlightConfigurationStatus, rankSchedule: Array<{ __typename?: 'SpotlightRankTier', fromDay: number, rank: number }> }
    | { __typename: 'SpotlightConfigValidationError', issues: Array<{ __typename?: 'SpotlightConfigValidationIssue', path: Array<string>, code: string, message: string }> }
   };

export type ValidateAiFormattedProductDescriptionsMutationVariables = Exact<{
  input: ValidateAiFormattedProductDescriptionsInput;
}>;


export type ValidateAiFormattedProductDescriptionsMutation = { __typename?: 'Mutation', validateAIFormattedProductDescriptions: number };

export type ValidateProductCheckSpellingMutationVariables = Exact<{
  checkId: Scalars['ID']['input'];
}>;


export type ValidateProductCheckSpellingMutation = { __typename?: 'Mutation', validateProductCheckSpelling: boolean };



export const AddImagesToProductsDocument = `
    mutation addImagesToProducts($productIds: [ID!]!, $images: [String!]!) {
  addImagesToProducts(productIds: $productIds, images: $images)
}
    `;

export const useAddImagesToProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddImagesToProductsMutation, TError, AddImagesToProductsMutationVariables, TContext>) => {
    
    return useMutation<AddImagesToProductsMutation, TError, AddImagesToProductsMutationVariables, TContext>(
      {
    mutationKey: ['addImagesToProducts'],
    mutationFn: useFetchData<AddImagesToProductsMutation, AddImagesToProductsMutationVariables>(AddImagesToProductsDocument),
    ...options
  }
    )};

export const AddLinkedProductsDocument = `
    mutation addLinkedProducts($products: [LinkedProductsInput!]!, $metadata: LinkedProductsMetadataInput) {
  addLinkedProducts(products: $products, metadata: $metadata)
}
    `;

export const useAddLinkedProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddLinkedProductsMutation, TError, AddLinkedProductsMutationVariables, TContext>) => {
    
    return useMutation<AddLinkedProductsMutation, TError, AddLinkedProductsMutationVariables, TContext>(
      {
    mutationKey: ['addLinkedProducts'],
    mutationFn: useFetchData<AddLinkedProductsMutation, AddLinkedProductsMutationVariables>(AddLinkedProductsDocument),
    ...options
  }
    )};

export const AddProductCouponsDocument = `
    mutation addProductCoupons($productId: ID!, $codes: [String!]!, $variantId: ID!) {
  addProductCouponsV2(productId: $productId, codes: $codes, variantId: $variantId)
}
    `;

export const useAddProductCouponsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProductCouponsMutation, TError, AddProductCouponsMutationVariables, TContext>) => {
    
    return useMutation<AddProductCouponsMutation, TError, AddProductCouponsMutationVariables, TContext>(
      {
    mutationKey: ['addProductCoupons'],
    mutationFn: useFetchData<AddProductCouponsMutation, AddProductCouponsMutationVariables>(AddProductCouponsDocument),
    ...options
  }
    )};

export const AddProductToCollectionDocument = `
    mutation addProductToCollection($collectionSaleId: ID!, $productId: ID!, $isBestseller: Boolean!, $filters: [CustomFilterInput!]!) {
  addProductToCollection(
    collectionSaleId: $collectionSaleId
    productId: $productId
    isBestseller: $isBestseller
    filters: $filters
  )
}
    `;

export const useAddProductToCollectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProductToCollectionMutation, TError, AddProductToCollectionMutationVariables, TContext>) => {
    
    return useMutation<AddProductToCollectionMutation, TError, AddProductToCollectionMutationVariables, TContext>(
      {
    mutationKey: ['addProductToCollection'],
    mutationFn: useFetchData<AddProductToCollectionMutation, AddProductToCollectionMutationVariables>(AddProductToCollectionDocument),
    ...options
  }
    )};

export const AddProductsBadgesDocument = `
    mutation addProductsBadges($productIds: [ID!]!, $badges: [ProductBadgeInput!]!) {
  addProductsBadges(productIds: $productIds, badges: $badges)
}
    `;

export const useAddProductsBadgesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProductsBadgesMutation, TError, AddProductsBadgesMutationVariables, TContext>) => {
    
    return useMutation<AddProductsBadgesMutation, TError, AddProductsBadgesMutationVariables, TContext>(
      {
    mutationKey: ['addProductsBadges'],
    mutationFn: useFetchData<AddProductsBadgesMutation, AddProductsBadgesMutationVariables>(AddProductsBadgesDocument),
    ...options
  }
    )};

export const AddSizeGuidesToProductsDocument = `
    mutation addSizeGuidesToProducts($productIds: [ID!]!, $sizeGuides: [String!]!) {
  addSizeGuidesToProducts(productIds: $productIds, sizeGuides: $sizeGuides)
}
    `;

export const useAddSizeGuidesToProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSizeGuidesToProductsMutation, TError, AddSizeGuidesToProductsMutationVariables, TContext>) => {
    
    return useMutation<AddSizeGuidesToProductsMutation, TError, AddSizeGuidesToProductsMutationVariables, TContext>(
      {
    mutationKey: ['addSizeGuidesToProducts'],
    mutationFn: useFetchData<AddSizeGuidesToProductsMutation, AddSizeGuidesToProductsMutationVariables>(AddSizeGuidesToProductsDocument),
    ...options
  }
    )};

export const AddTextToProductsDescriptionDocument = `
    mutation addTextToProductsDescription($productIds: [ID!]!, $payload: AddTextPayload!) {
  addTextToProductsDescription(productIds: $productIds, payload: $payload)
}
    `;

export const useAddTextToProductsDescriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTextToProductsDescriptionMutation, TError, AddTextToProductsDescriptionMutationVariables, TContext>) => {
    
    return useMutation<AddTextToProductsDescriptionMutation, TError, AddTextToProductsDescriptionMutationVariables, TContext>(
      {
    mutationKey: ['addTextToProductsDescription'],
    mutationFn: useFetchData<AddTextToProductsDescriptionMutation, AddTextToProductsDescriptionMutationVariables>(AddTextToProductsDescriptionDocument),
    ...options
  }
    )};

export const AddTextToProductsNameDocument = `
    mutation addTextToProductsName($productIds: [ID!]!, $payload: AddTextPayload!) {
  addTextToProductsName(productIds: $productIds, payload: $payload)
}
    `;

export const useAddTextToProductsNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddTextToProductsNameMutation, TError, AddTextToProductsNameMutationVariables, TContext>) => {
    
    return useMutation<AddTextToProductsNameMutation, TError, AddTextToProductsNameMutationVariables, TContext>(
      {
    mutationKey: ['addTextToProductsName'],
    mutationFn: useFetchData<AddTextToProductsNameMutation, AddTextToProductsNameMutationVariables>(AddTextToProductsNameDocument),
    ...options
  }
    )};

export const AiProductsUpdatedDocument = `
    subscription aiProductsUpdated($sessionId: ID!) {
  aiProductsUpdated(sessionId: $sessionId) {
    sessionId
    data {
      productId
      description
      name
      traceId
    }
    error {
      code
      message
    }
  }
}
    `;
export const AlignBottomImagesDocument = `
    mutation alignBottomImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  alignBottomImages(images: $images, sessionId: $sessionId, actionId: $actionId)
}
    `;

export const useAlignBottomImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AlignBottomImagesMutation, TError, AlignBottomImagesMutationVariables, TContext>) => {
    
    return useMutation<AlignBottomImagesMutation, TError, AlignBottomImagesMutationVariables, TContext>(
      {
    mutationKey: ['alignBottomImages'],
    mutationFn: useFetchData<AlignBottomImagesMutation, AlignBottomImagesMutationVariables>(AlignBottomImagesDocument),
    ...options
  }
    )};

export const AlignTopImagesDocument = `
    mutation alignTopImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  alignTopImages(images: $images, sessionId: $sessionId, actionId: $actionId)
}
    `;

export const useAlignTopImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AlignTopImagesMutation, TError, AlignTopImagesMutationVariables, TContext>) => {
    
    return useMutation<AlignTopImagesMutation, TError, AlignTopImagesMutationVariables, TContext>(
      {
    mutationKey: ['alignTopImages'],
    mutationFn: useFetchData<AlignTopImagesMutation, AlignTopImagesMutationVariables>(AlignTopImagesDocument),
    ...options
  }
    )};

export const ChangeProductColorToOptionDocument = `
    mutation changeProductColorToOption($productIds: [ID!]!) {
  changeProductColorToOption(productIds: $productIds)
}
    `;

export const useChangeProductColorToOptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeProductColorToOptionMutation, TError, ChangeProductColorToOptionMutationVariables, TContext>) => {
    
    return useMutation<ChangeProductColorToOptionMutation, TError, ChangeProductColorToOptionMutationVariables, TContext>(
      {
    mutationKey: ['changeProductColorToOption'],
    mutationFn: useFetchData<ChangeProductColorToOptionMutation, ChangeProductColorToOptionMutationVariables>(ChangeProductColorToOptionDocument),
    ...options
  }
    )};

export const ChangeProductOptionToColorDocument = `
    mutation changeProductOptionToColor($productIds: [ID!]!) {
  changeProductOptionToColor(productIds: $productIds)
}
    `;

export const useChangeProductOptionToColorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeProductOptionToColorMutation, TError, ChangeProductOptionToColorMutationVariables, TContext>) => {
    
    return useMutation<ChangeProductOptionToColorMutation, TError, ChangeProductOptionToColorMutationVariables, TContext>(
      {
    mutationKey: ['changeProductOptionToColor'],
    mutationFn: useFetchData<ChangeProductOptionToColorMutation, ChangeProductOptionToColorMutationVariables>(ChangeProductOptionToColorDocument),
    ...options
  }
    )};

export const CheckShopifyInventoryDocument = `
    query checkShopifyInventory($sellerId: ID!, $saleId: ID!) {
  shopify {
    checkShopifyInventory(sellerId: $sellerId, saleId: $saleId) {
      skusErrors {
        sku
        barcode
        reason
        shopifySkus
        shopifyBarcodes
        shopifyStatus
        shopifyIds
      }
      skusOutofstock
      skusCheck {
        sku
        barcode
        sellableOnlineQuantity
        inventoryPolicy
        inventoryManagement
        status
      }
    }
  }
}
    `;

export const useCheckShopifyInventoryQuery = <
      TData = CheckShopifyInventoryQuery,
      TError = unknown
    >(
      variables: CheckShopifyInventoryQueryVariables,
      options?: Omit<UseQueryOptions<CheckShopifyInventoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckShopifyInventoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckShopifyInventoryQuery, TError, TData>(
      {
    queryKey: ['checkShopifyInventory', variables],
    queryFn: useFetchData<CheckShopifyInventoryQuery, CheckShopifyInventoryQueryVariables>(CheckShopifyInventoryDocument).bind(null, variables),
    ...options
  }
    )};

useCheckShopifyInventoryQuery.getKey = (variables: CheckShopifyInventoryQueryVariables) => ['checkShopifyInventory', variables];

export const useInfiniteCheckShopifyInventoryQuery = <
      TData = InfiniteData<CheckShopifyInventoryQuery>,
      TError = unknown
    >(
      variables: CheckShopifyInventoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckShopifyInventoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckShopifyInventoryQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CheckShopifyInventoryQuery, CheckShopifyInventoryQueryVariables>(CheckShopifyInventoryDocument)
    return useInfiniteQuery<CheckShopifyInventoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['checkShopifyInventory.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckShopifyInventoryQuery.getKey = (variables: CheckShopifyInventoryQueryVariables) => ['checkShopifyInventory.infinite', variables];

export const CopyProductDocument = `
    mutation copyProduct($productId: ID!, $keepImages: Boolean!) {
  copyProductV2(productId: $productId, keepImages: $keepImages)
}
    `;

export const useCopyProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CopyProductMutation, TError, CopyProductMutationVariables, TContext>) => {
    
    return useMutation<CopyProductMutation, TError, CopyProductMutationVariables, TContext>(
      {
    mutationKey: ['copyProduct'],
    mutationFn: useFetchData<CopyProductMutation, CopyProductMutationVariables>(CopyProductDocument),
    ...options
  }
    )};

export const CopySaleDocument = `
    mutation copySale($saleId: String!) {
  copySale(saleId: $saleId)
}
    `;

export const useCopySaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CopySaleMutation, TError, CopySaleMutationVariables, TContext>) => {
    
    return useMutation<CopySaleMutation, TError, CopySaleMutationVariables, TContext>(
      {
    mutationKey: ['copySale'],
    mutationFn: useFetchData<CopySaleMutation, CopySaleMutationVariables>(CopySaleDocument),
    ...options
  }
    )};

export const CouponsChangedDocument = `
    subscription CouponsChanged {
  couponsChanged
}
    `;
export const CrawlDriveImagesDocument = `
    mutation crawlDriveImages($urlData: [CrawlDriveUrlDataInput!]!) {
  crawlDriveImages(urlData: $urlData) {
    productName
    images
  }
}
    `;

export const useCrawlDriveImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CrawlDriveImagesMutation, TError, CrawlDriveImagesMutationVariables, TContext>) => {
    
    return useMutation<CrawlDriveImagesMutation, TError, CrawlDriveImagesMutationVariables, TContext>(
      {
    mutationKey: ['crawlDriveImages'],
    mutationFn: useFetchData<CrawlDriveImagesMutation, CrawlDriveImagesMutationVariables>(CrawlDriveImagesDocument),
    ...options
  }
    )};

export const CrawlProductsDocument = `
    mutation crawlProducts($saleId: String!, $urls: [String!]!) {
  crawlProducts(saleId: $saleId, urls: $urls)
}
    `;

export const useCrawlProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CrawlProductsMutation, TError, CrawlProductsMutationVariables, TContext>) => {
    
    return useMutation<CrawlProductsMutation, TError, CrawlProductsMutationVariables, TContext>(
      {
    mutationKey: ['crawlProducts'],
    mutationFn: useFetchData<CrawlProductsMutation, CrawlProductsMutationVariables>(CrawlProductsDocument),
    ...options
  }
    )};

export const CrawlingProductsUpdatedDocument = `
    subscription crawlingProductsUpdated($saleId: String!) {
  crawlingProductsUpdated(saleId: $saleId) {
    id
    saleId
    data {
      composition
      description
      images
    }
    error {
      code
      message
    }
  }
}
    `;
export const CreateDurationWidgetDocument = `
    mutation createDurationWidget($saleId: String!) {
  createDurationWidget(saleId: $saleId)
}
    `;

export const useCreateDurationWidgetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDurationWidgetMutation, TError, CreateDurationWidgetMutationVariables, TContext>) => {
    
    return useMutation<CreateDurationWidgetMutation, TError, CreateDurationWidgetMutationVariables, TContext>(
      {
    mutationKey: ['createDurationWidget'],
    mutationFn: useFetchData<CreateDurationWidgetMutation, CreateDurationWidgetMutationVariables>(CreateDurationWidgetDocument),
    ...options
  }
    )};

export const CreateLogisticFileDocument = `
    mutation createLogisticFile($saleId: String!, $brandId: String) {
  createLogisticFile(saleId: $saleId, brandId: $brandId)
}
    `;

export const useCreateLogisticFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLogisticFileMutation, TError, CreateLogisticFileMutationVariables, TContext>) => {
    
    return useMutation<CreateLogisticFileMutation, TError, CreateLogisticFileMutationVariables, TContext>(
      {
    mutationKey: ['createLogisticFile'],
    mutationFn: useFetchData<CreateLogisticFileMutation, CreateLogisticFileMutationVariables>(CreateLogisticFileDocument),
    ...options
  }
    )};

export const CreateSaleCustomFilterDocument = `
    mutation createSaleCustomFilter($input: CreateSaleCustomFilterInput!) {
  createSaleCustomFilter(input: $input) {
    ... on SaleCustomFilter {
      __typename
      id
      name
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useCreateSaleCustomFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSaleCustomFilterMutation, TError, CreateSaleCustomFilterMutationVariables, TContext>) => {
    
    return useMutation<CreateSaleCustomFilterMutation, TError, CreateSaleCustomFilterMutationVariables, TContext>(
      {
    mutationKey: ['createSaleCustomFilter'],
    mutationFn: useFetchData<CreateSaleCustomFilterMutation, CreateSaleCustomFilterMutationVariables>(CreateSaleCustomFilterDocument),
    ...options
  }
    )};

export const CreateShopifyTestOrderDocument = `
    mutation CreateShopifyTestOrder($input: ShopifyTestOrderInput!) {
  createShopifyTestOrder(input: $input) {
    error
    success
  }
}
    `;

export const useCreateShopifyTestOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateShopifyTestOrderMutation, TError, CreateShopifyTestOrderMutationVariables, TContext>) => {
    
    return useMutation<CreateShopifyTestOrderMutation, TError, CreateShopifyTestOrderMutationVariables, TContext>(
      {
    mutationKey: ['CreateShopifyTestOrder'],
    mutationFn: useFetchData<CreateShopifyTestOrderMutation, CreateShopifyTestOrderMutationVariables>(CreateShopifyTestOrderDocument),
    ...options
  }
    )};

export const CreateUploadUrlsDocument = `
    mutation createUploadUrls($input: [UploadUrlInput!]!) {
  createUploadUrls(input: $input) {
    ... on UploadUrl {
      __typename
      url
      key
      publicUrl
    }
    ... on ErrorLike {
      __typename
      message
    }
  }
}
    `;

export const useCreateUploadUrlsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUploadUrlsMutation, TError, CreateUploadUrlsMutationVariables, TContext>) => {
    
    return useMutation<CreateUploadUrlsMutation, TError, CreateUploadUrlsMutationVariables, TContext>(
      {
    mutationKey: ['createUploadUrls'],
    mutationFn: useFetchData<CreateUploadUrlsMutation, CreateUploadUrlsMutationVariables>(CreateUploadUrlsDocument),
    ...options
  }
    )};

export const CropBelowFacesImagesDocument = `
    mutation cropBelowFacesImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  cropBelowFacesImages(
    images: $images
    sessionId: $sessionId
    actionId: $actionId
  )
}
    `;

export const useCropBelowFacesImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CropBelowFacesImagesMutation, TError, CropBelowFacesImagesMutationVariables, TContext>) => {
    
    return useMutation<CropBelowFacesImagesMutation, TError, CropBelowFacesImagesMutationVariables, TContext>(
      {
    mutationKey: ['cropBelowFacesImages'],
    mutationFn: useFetchData<CropBelowFacesImagesMutation, CropBelowFacesImagesMutationVariables>(CropBelowFacesImagesDocument),
    ...options
  }
    )};

export const CrossSellingPreviewUpdatedDocument = `
    subscription crossSellingPreviewUpdated($sessionId: ID!) {
  crossSellingPreviewUpdated(sessionId: $sessionId) {
    sessionId
    saleId
    intent
    status
    progress {
      phase
      completedRequests
      totalRequests
    }
    preview {
      suggestions {
        productId
        products {
          productId
          score
        }
      }
    }
    errorCode
    expiresAt
  }
}
    `;
export const DeleteSaleCustomFilterDocument = `
    mutation deleteSaleCustomFilter($saleId: ID!, $filterId: ID!) {
  deleteSaleCustomFilter(saleId: $saleId, filterId: $filterId)
}
    `;

export const useDeleteSaleCustomFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSaleCustomFilterMutation, TError, DeleteSaleCustomFilterMutationVariables, TContext>) => {
    
    return useMutation<DeleteSaleCustomFilterMutation, TError, DeleteSaleCustomFilterMutationVariables, TContext>(
      {
    mutationKey: ['deleteSaleCustomFilter'],
    mutationFn: useFetchData<DeleteSaleCustomFilterMutation, DeleteSaleCustomFilterMutationVariables>(DeleteSaleCustomFilterDocument),
    ...options
  }
    )};

export const DismissProductCheckDocument = `
    mutation dismissProductCheck($checkId: ID!) {
  dismissProductCheck(checkId: $checkId)
}
    `;

export const useDismissProductCheckMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DismissProductCheckMutation, TError, DismissProductCheckMutationVariables, TContext>) => {
    
    return useMutation<DismissProductCheckMutation, TError, DismissProductCheckMutationVariables, TContext>(
      {
    mutationKey: ['dismissProductCheck'],
    mutationFn: useFetchData<DismissProductCheckMutation, DismissProductCheckMutationVariables>(DismissProductCheckDocument),
    ...options
  }
    )};

export const ExtendImagesDocument = `
    mutation extendImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  extendImages(images: $images, sessionId: $sessionId, actionId: $actionId)
}
    `;

export const useExtendImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExtendImagesMutation, TError, ExtendImagesMutationVariables, TContext>) => {
    
    return useMutation<ExtendImagesMutation, TError, ExtendImagesMutationVariables, TContext>(
      {
    mutationKey: ['extendImages'],
    mutationFn: useFetchData<ExtendImagesMutation, ExtendImagesMutationVariables>(ExtendImagesDocument),
    ...options
  }
    )};

export const FillImagesDocument = `
    mutation fillImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  fillImages(images: $images, sessionId: $sessionId, actionId: $actionId)
}
    `;

export const useFillImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillImagesMutation, TError, FillImagesMutationVariables, TContext>) => {
    
    return useMutation<FillImagesMutation, TError, FillImagesMutationVariables, TContext>(
      {
    mutationKey: ['fillImages'],
    mutationFn: useFetchData<FillImagesMutation, FillImagesMutationVariables>(FillImagesDocument),
    ...options
  }
    )};

export const FitImagesDocument = `
    mutation fitImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  fitImages(images: $images, sessionId: $sessionId, actionId: $actionId)
}
    `;

export const useFitImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FitImagesMutation, TError, FitImagesMutationVariables, TContext>) => {
    
    return useMutation<FitImagesMutation, TError, FitImagesMutationVariables, TContext>(
      {
    mutationKey: ['fitImages'],
    mutationFn: useFetchData<FitImagesMutation, FitImagesMutationVariables>(FitImagesDocument),
    ...options
  }
    )};

export const FormatProductsDescriptionDocument = `
    mutation formatProductsDescription($productIds: [ID!]!) {
  formatProductsDescription(productIds: $productIds)
}
    `;

export const useFormatProductsDescriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FormatProductsDescriptionMutation, TError, FormatProductsDescriptionMutationVariables, TContext>) => {
    
    return useMutation<FormatProductsDescriptionMutation, TError, FormatProductsDescriptionMutationVariables, TContext>(
      {
    mutationKey: ['formatProductsDescription'],
    mutationFn: useFetchData<FormatProductsDescriptionMutation, FormatProductsDescriptionMutationVariables>(FormatProductsDescriptionDocument),
    ...options
  }
    )};

export const FormatProductsWithAiDocument = `
    mutation formatProductsWithAI($input: AIProductsInput!) {
  formatProductsWithAI(input: $input)
}
    `;

export const useFormatProductsWithAiMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FormatProductsWithAiMutation, TError, FormatProductsWithAiMutationVariables, TContext>) => {
    
    return useMutation<FormatProductsWithAiMutation, TError, FormatProductsWithAiMutationVariables, TContext>(
      {
    mutationKey: ['formatProductsWithAI'],
    mutationFn: useFetchData<FormatProductsWithAiMutation, FormatProductsWithAiMutationVariables>(FormatProductsWithAiDocument),
    ...options
  }
    )};

export const GenerateImmersiveCatchlinesDocument = `
    mutation generateImmersiveCatchlines($saleId: ID!, $type: ImmersiveCatchlineType!) {
  generateImmersiveCatchlines(saleId: $saleId, type: $type) {
    __typename
    ... on ImmersiveCatchlineGenerationResult {
      status
      suggestions
    }
    ... on DomainException {
      errorCode
    }
  }
}
    `;

export const useGenerateImmersiveCatchlinesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateImmersiveCatchlinesMutation, TError, GenerateImmersiveCatchlinesMutationVariables, TContext>) => {
    
    return useMutation<GenerateImmersiveCatchlinesMutation, TError, GenerateImmersiveCatchlinesMutationVariables, TContext>(
      {
    mutationKey: ['generateImmersiveCatchlines'],
    mutationFn: useFetchData<GenerateImmersiveCatchlinesMutation, GenerateImmersiveCatchlinesMutationVariables>(GenerateImmersiveCatchlinesDocument),
    ...options
  }
    )};

export const GenerateSpotlightVideoThumbnailDocument = `
    mutation generateSpotlightVideoThumbnail($saleId: ID!, $videoKey: String!) {
  generateSpotlightVideoThumbnail(saleId: $saleId, videoKey: $videoKey) {
    ... on SpotlightVideoThumbnail {
      __typename
      key
      publicUrl
    }
    ... on DomainException {
      __typename
      errorCode
    }
  }
}
    `;

export const useGenerateSpotlightVideoThumbnailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateSpotlightVideoThumbnailMutation, TError, GenerateSpotlightVideoThumbnailMutationVariables, TContext>) => {
    
    return useMutation<GenerateSpotlightVideoThumbnailMutation, TError, GenerateSpotlightVideoThumbnailMutationVariables, TContext>(
      {
    mutationKey: ['generateSpotlightVideoThumbnail'],
    mutationFn: useFetchData<GenerateSpotlightVideoThumbnailMutation, GenerateSpotlightVideoThumbnailMutationVariables>(GenerateSpotlightVideoThumbnailDocument),
    ...options
  }
    )};

export const BadgesDocument = `
    query badges($storeId: StoreRegion!) {
  badges(storeId: $storeId) {
    name
    svg
  }
}
    `;

export const useBadgesQuery = <
      TData = BadgesQuery,
      TError = unknown
    >(
      variables: BadgesQueryVariables,
      options?: Omit<UseQueryOptions<BadgesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BadgesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BadgesQuery, TError, TData>(
      {
    queryKey: ['badges', variables],
    queryFn: useFetchData<BadgesQuery, BadgesQueryVariables>(BadgesDocument).bind(null, variables),
    ...options
  }
    )};

useBadgesQuery.getKey = (variables: BadgesQueryVariables) => ['badges', variables];

export const useInfiniteBadgesQuery = <
      TData = InfiniteData<BadgesQuery>,
      TError = unknown
    >(
      variables: BadgesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BadgesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BadgesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BadgesQuery, BadgesQueryVariables>(BadgesDocument)
    return useInfiniteQuery<BadgesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['badges.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBadgesQuery.getKey = (variables: BadgesQueryVariables) => ['badges.infinite', variables];

export const BrandDocument = `
    query brand($brandId: ID!) {
  brand(id: $brandId) {
    about
    contactName
    id
    instagram
    name
  }
}
    `;

export const useBrandQuery = <
      TData = BrandQuery,
      TError = unknown
    >(
      variables: BrandQueryVariables,
      options?: Omit<UseQueryOptions<BrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandQuery, TError, TData>(
      {
    queryKey: ['brand', variables],
    queryFn: useFetchData<BrandQuery, BrandQueryVariables>(BrandDocument).bind(null, variables),
    ...options
  }
    )};

useBrandQuery.getKey = (variables: BrandQueryVariables) => ['brand', variables];

export const useInfiniteBrandQuery = <
      TData = InfiniteData<BrandQuery>,
      TError = unknown
    >(
      variables: BrandQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandQuery, BrandQueryVariables>(BrandDocument)
    return useInfiniteQuery<BrandQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['brand.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandQuery.getKey = (variables: BrandQueryVariables) => ['brand.infinite', variables];

export const CalendarSalesDocument = `
    query CalendarSales($status: SaleStatus!, $storeId: StoreRegion!) {
  calendarSales(status: $status, storeId: $storeId) {
    sales {
      brand {
        id
        name
        contactEmail
        contactName
        website
        instagram
      }
      cancellation_level
      category
      deliver_by_choose
      end_at_date
      forecast
      gender
      hide
      hubspot_category
      hubspot_deal_id
      hubspot_selection_id
      hubspot_team_name
      hubspot_tiering
      hubspot_top_brand_type
      id
      is_cancelled
      is_ready
      is_setup
      isShopify
      hubspot_demande_point_relais
      logistics_manager
      note
      operation_type
      hasPreviews
      hasHeader
      hasDescription
      sale_status
      selection_name
      setup_status
      setup_by
      shippingPolicy {
        pickupPoint {
          network
          shippingCost
        }
      }
      shopify {
        hasCredentials
        isStockLive
        testMondialRelayOn
        testOrderOn
        testShop2ShopOn
      }
      start_at_date
      stats_stock
      storeId
      total_sales
      url_google_drive
      url_google_drive_not_validated
      pricingErrorsCount
      deal {
        link
      }
    }
  }
}
    `;

export const useCalendarSalesQuery = <
      TData = CalendarSalesQuery,
      TError = unknown
    >(
      variables: CalendarSalesQueryVariables,
      options?: Omit<UseQueryOptions<CalendarSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CalendarSalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CalendarSalesQuery, TError, TData>(
      {
    queryKey: ['CalendarSales', variables],
    queryFn: useFetchData<CalendarSalesQuery, CalendarSalesQueryVariables>(CalendarSalesDocument).bind(null, variables),
    ...options
  }
    )};

useCalendarSalesQuery.getKey = (variables: CalendarSalesQueryVariables) => ['CalendarSales', variables];

export const useInfiniteCalendarSalesQuery = <
      TData = InfiniteData<CalendarSalesQuery>,
      TError = unknown
    >(
      variables: CalendarSalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CalendarSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CalendarSalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CalendarSalesQuery, CalendarSalesQueryVariables>(CalendarSalesDocument)
    return useInfiniteQuery<CalendarSalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CalendarSales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCalendarSalesQuery.getKey = (variables: CalendarSalesQueryVariables) => ['CalendarSales.infinite', variables];

export const CategoriesDocument = `
    query Categories {
  categories {
    ids
    sub_categories {
      category
      ids
    }
    category
  }
}
    `;

export const useCategoriesQuery = <
      TData = CategoriesQuery,
      TError = unknown
    >(
      variables?: CategoriesQueryVariables,
      options?: Omit<UseQueryOptions<CategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Categories'] : ['Categories', variables],
    queryFn: useFetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument).bind(null, variables),
    ...options
  }
    )};

useCategoriesQuery.getKey = (variables?: CategoriesQueryVariables) => variables === undefined ? ['Categories'] : ['Categories', variables];

export const useInfiniteCategoriesQuery = <
      TData = InfiniteData<CategoriesQuery>,
      TError = unknown
    >(
      variables: CategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument)
    return useInfiniteQuery<CategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Categories.infinite'] : ['Categories.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoriesQuery.getKey = (variables?: CategoriesQueryVariables) => variables === undefined ? ['Categories.infinite'] : ['Categories.infinite', variables];

export const CategoryEssentialOptionsDocument = `
    query CategoryEssentialOptions($categoryId: String!) {
  categoryEssentialOptions(categoryId: $categoryId) {
    text
    type
    values
    placeholders
  }
}
    `;

export const useCategoryEssentialOptionsQuery = <
      TData = CategoryEssentialOptionsQuery,
      TError = unknown
    >(
      variables: CategoryEssentialOptionsQueryVariables,
      options?: Omit<UseQueryOptions<CategoryEssentialOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryEssentialOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryEssentialOptionsQuery, TError, TData>(
      {
    queryKey: ['CategoryEssentialOptions', variables],
    queryFn: useFetchData<CategoryEssentialOptionsQuery, CategoryEssentialOptionsQueryVariables>(CategoryEssentialOptionsDocument).bind(null, variables),
    ...options
  }
    )};

useCategoryEssentialOptionsQuery.getKey = (variables: CategoryEssentialOptionsQueryVariables) => ['CategoryEssentialOptions', variables];

export const useInfiniteCategoryEssentialOptionsQuery = <
      TData = InfiniteData<CategoryEssentialOptionsQuery>,
      TError = unknown
    >(
      variables: CategoryEssentialOptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryEssentialOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryEssentialOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CategoryEssentialOptionsQuery, CategoryEssentialOptionsQueryVariables>(CategoryEssentialOptionsDocument)
    return useInfiniteQuery<CategoryEssentialOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryEssentialOptions.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryEssentialOptionsQuery.getKey = (variables: CategoryEssentialOptionsQueryVariables) => ['CategoryEssentialOptions.infinite', variables];

export const CategoryOptionsDocument = `
    query CategoryOptions($categoryId: String!) {
  categoryOptions(categoryId: $categoryId) {
    text
    type
    values
    placeholders
  }
}
    `;

export const useCategoryOptionsQuery = <
      TData = CategoryOptionsQuery,
      TError = unknown
    >(
      variables: CategoryOptionsQueryVariables,
      options?: Omit<UseQueryOptions<CategoryOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryOptionsQuery, TError, TData>(
      {
    queryKey: ['CategoryOptions', variables],
    queryFn: useFetchData<CategoryOptionsQuery, CategoryOptionsQueryVariables>(CategoryOptionsDocument).bind(null, variables),
    ...options
  }
    )};

useCategoryOptionsQuery.getKey = (variables: CategoryOptionsQueryVariables) => ['CategoryOptions', variables];

export const useInfiniteCategoryOptionsQuery = <
      TData = InfiniteData<CategoryOptionsQuery>,
      TError = unknown
    >(
      variables: CategoryOptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CategoryOptionsQuery, CategoryOptionsQueryVariables>(CategoryOptionsDocument)
    return useInfiniteQuery<CategoryOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryOptions.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryOptionsQuery.getKey = (variables: CategoryOptionsQueryVariables) => ['CategoryOptions.infinite', variables];

export const CategoryTreeDocument = `
    query CategoryTree {
  categoryTree {
    id
    label
    tva
    notReturnable
    subCategories {
      id
      label
      tva
      notReturnable
      subCategories {
        id
        label
        tva
        notReturnable
        subCategories {
          id
          label
          tva
          notReturnable
          subCategories {
            id
            label
            tva
            notReturnable
            subCategories {
              id
              label
              tva
              notReturnable
              subCategories {
                id
                label
                tva
                notReturnable
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useCategoryTreeQuery = <
      TData = CategoryTreeQuery,
      TError = unknown
    >(
      variables?: CategoryTreeQueryVariables,
      options?: Omit<UseQueryOptions<CategoryTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryTreeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryTreeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CategoryTree'] : ['CategoryTree', variables],
    queryFn: useFetchData<CategoryTreeQuery, CategoryTreeQueryVariables>(CategoryTreeDocument).bind(null, variables),
    ...options
  }
    )};

useCategoryTreeQuery.getKey = (variables?: CategoryTreeQueryVariables) => variables === undefined ? ['CategoryTree'] : ['CategoryTree', variables];

export const useInfiniteCategoryTreeQuery = <
      TData = InfiniteData<CategoryTreeQuery>,
      TError = unknown
    >(
      variables: CategoryTreeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryTreeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryTreeQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CategoryTreeQuery, CategoryTreeQueryVariables>(CategoryTreeDocument)
    return useInfiniteQuery<CategoryTreeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CategoryTree.infinite'] : ['CategoryTree.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryTreeQuery.getKey = (variables?: CategoryTreeQueryVariables) => variables === undefined ? ['CategoryTree.infinite'] : ['CategoryTree.infinite', variables];

export const CouponsDocument = `
    query Coupons($status: CouponStatus!, $storeId: StoreRegion!) {
  coupons(status: $status, store_id: $storeId) {
    id
    code
    type
    value
    start_at
    expires_at
    quantity
    quantity_per_user
    minimum_order_amount
    first_order_only
    total_used
    store_id
  }
}
    `;

export const useCouponsQuery = <
      TData = CouponsQuery,
      TError = unknown
    >(
      variables: CouponsQueryVariables,
      options?: Omit<UseQueryOptions<CouponsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CouponsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CouponsQuery, TError, TData>(
      {
    queryKey: ['Coupons', variables],
    queryFn: useFetchData<CouponsQuery, CouponsQueryVariables>(CouponsDocument).bind(null, variables),
    ...options
  }
    )};

useCouponsQuery.getKey = (variables: CouponsQueryVariables) => ['Coupons', variables];

export const useInfiniteCouponsQuery = <
      TData = InfiniteData<CouponsQuery>,
      TError = unknown
    >(
      variables: CouponsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CouponsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CouponsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CouponsQuery, CouponsQueryVariables>(CouponsDocument)
    return useInfiniteQuery<CouponsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Coupons.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCouponsQuery.getKey = (variables: CouponsQueryVariables) => ['Coupons.infinite', variables];

export const CrossSellingPreviewSessionDocument = `
    query crossSellingPreviewSession($sessionId: ID!) {
  crossSellingPreviewSession(sessionId: $sessionId) {
    sessionId
    saleId
    intent
    status
    progress {
      phase
      completedRequests
      totalRequests
    }
    preview {
      suggestions {
        productId
        products {
          productId
          score
        }
      }
    }
    errorCode
    expiresAt
  }
}
    `;

export const useCrossSellingPreviewSessionQuery = <
      TData = CrossSellingPreviewSessionQuery,
      TError = unknown
    >(
      variables: CrossSellingPreviewSessionQueryVariables,
      options?: Omit<UseQueryOptions<CrossSellingPreviewSessionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CrossSellingPreviewSessionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CrossSellingPreviewSessionQuery, TError, TData>(
      {
    queryKey: ['crossSellingPreviewSession', variables],
    queryFn: useFetchData<CrossSellingPreviewSessionQuery, CrossSellingPreviewSessionQueryVariables>(CrossSellingPreviewSessionDocument).bind(null, variables),
    ...options
  }
    )};

useCrossSellingPreviewSessionQuery.getKey = (variables: CrossSellingPreviewSessionQueryVariables) => ['crossSellingPreviewSession', variables];

export const useInfiniteCrossSellingPreviewSessionQuery = <
      TData = InfiniteData<CrossSellingPreviewSessionQuery>,
      TError = unknown
    >(
      variables: CrossSellingPreviewSessionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CrossSellingPreviewSessionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CrossSellingPreviewSessionQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CrossSellingPreviewSessionQuery, CrossSellingPreviewSessionQueryVariables>(CrossSellingPreviewSessionDocument)
    return useInfiniteQuery<CrossSellingPreviewSessionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['crossSellingPreviewSession.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCrossSellingPreviewSessionQuery.getKey = (variables: CrossSellingPreviewSessionQueryVariables) => ['crossSellingPreviewSession.infinite', variables];

export const GetImagesByProductIdsDocument = `
    query getImagesByProductIds($productIds: [ID!]!) {
  getImagesByProductIds(productIds: $productIds) {
    id
    productId
    url
    originalUrl
    currentVersion
    isCover
    isVariantCover
    isOriginal
    aspect
  }
}
    `;

export const useGetImagesByProductIdsQuery = <
      TData = GetImagesByProductIdsQuery,
      TError = unknown
    >(
      variables: GetImagesByProductIdsQueryVariables,
      options?: Omit<UseQueryOptions<GetImagesByProductIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetImagesByProductIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetImagesByProductIdsQuery, TError, TData>(
      {
    queryKey: ['getImagesByProductIds', variables],
    queryFn: useFetchData<GetImagesByProductIdsQuery, GetImagesByProductIdsQueryVariables>(GetImagesByProductIdsDocument).bind(null, variables),
    ...options
  }
    )};

useGetImagesByProductIdsQuery.getKey = (variables: GetImagesByProductIdsQueryVariables) => ['getImagesByProductIds', variables];

export const useInfiniteGetImagesByProductIdsQuery = <
      TData = InfiniteData<GetImagesByProductIdsQuery>,
      TError = unknown
    >(
      variables: GetImagesByProductIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetImagesByProductIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetImagesByProductIdsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetImagesByProductIdsQuery, GetImagesByProductIdsQueryVariables>(GetImagesByProductIdsDocument)
    return useInfiniteQuery<GetImagesByProductIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getImagesByProductIds.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetImagesByProductIdsQuery.getKey = (variables: GetImagesByProductIdsQueryVariables) => ['getImagesByProductIds.infinite', variables];

export const GetImmersiveCalendarDocument = `
    query getImmersiveCalendar($storeId: StoreRegion!, $startAt: LocalDate!, $endAt: LocalDate!) {
  marketing {
    getImmersiveCalendar(store: $storeId, startAt: $startAt, endAt: $endAt) {
      date
      current {
        id
        saleId
        videoUrl
        imageUrl
        brandLogoUrl
        stickerUrl
        description
        saleName
        buttonText
        url
        startAt
        endAt
        universeIds
        status
        showForDays
        forceFirstPosition
      }
      stillActive {
        id
        saleId
        videoUrl
        imageUrl
        brandLogoUrl
        stickerUrl
        description
        saleName
        buttonText
        url
        startAt
        endAt
        universeIds
        status
        showForDays
        forceFirstPosition
      }
    }
  }
}
    `;

export const useGetImmersiveCalendarQuery = <
      TData = GetImmersiveCalendarQuery,
      TError = unknown
    >(
      variables: GetImmersiveCalendarQueryVariables,
      options?: Omit<UseQueryOptions<GetImmersiveCalendarQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetImmersiveCalendarQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetImmersiveCalendarQuery, TError, TData>(
      {
    queryKey: ['getImmersiveCalendar', variables],
    queryFn: useFetchData<GetImmersiveCalendarQuery, GetImmersiveCalendarQueryVariables>(GetImmersiveCalendarDocument).bind(null, variables),
    ...options
  }
    )};

useGetImmersiveCalendarQuery.getKey = (variables: GetImmersiveCalendarQueryVariables) => ['getImmersiveCalendar', variables];

export const useInfiniteGetImmersiveCalendarQuery = <
      TData = InfiniteData<GetImmersiveCalendarQuery>,
      TError = unknown
    >(
      variables: GetImmersiveCalendarQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetImmersiveCalendarQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetImmersiveCalendarQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetImmersiveCalendarQuery, GetImmersiveCalendarQueryVariables>(GetImmersiveCalendarDocument)
    return useInfiniteQuery<GetImmersiveCalendarQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getImmersiveCalendar.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetImmersiveCalendarQuery.getKey = (variables: GetImmersiveCalendarQueryVariables) => ['getImmersiveCalendar.infinite', variables];

export const GetImmersiveSalesDocument = `
    query getImmersiveSales($storeId: StoreRegion!, $startAt: LocalDate!, $endAt: LocalDate!) {
  marketing {
    getImmersiveSales(store: $storeId, startAt: $startAt, endAt: $endAt) {
      id
      saleId
      videoUrl
      imageUrl
      brandLogoUrl
      stickerUrl
      description
      saleName
      buttonText
      url
      startAt
      endAt
      universeIds
      status
      showForDays
      forceFirstPosition
    }
  }
}
    `;

export const useGetImmersiveSalesQuery = <
      TData = GetImmersiveSalesQuery,
      TError = unknown
    >(
      variables: GetImmersiveSalesQueryVariables,
      options?: Omit<UseQueryOptions<GetImmersiveSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetImmersiveSalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetImmersiveSalesQuery, TError, TData>(
      {
    queryKey: ['getImmersiveSales', variables],
    queryFn: useFetchData<GetImmersiveSalesQuery, GetImmersiveSalesQueryVariables>(GetImmersiveSalesDocument).bind(null, variables),
    ...options
  }
    )};

useGetImmersiveSalesQuery.getKey = (variables: GetImmersiveSalesQueryVariables) => ['getImmersiveSales', variables];

export const useInfiniteGetImmersiveSalesQuery = <
      TData = InfiniteData<GetImmersiveSalesQuery>,
      TError = unknown
    >(
      variables: GetImmersiveSalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetImmersiveSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetImmersiveSalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetImmersiveSalesQuery, GetImmersiveSalesQueryVariables>(GetImmersiveSalesDocument)
    return useInfiniteQuery<GetImmersiveSalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getImmersiveSales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetImmersiveSalesQuery.getKey = (variables: GetImmersiveSalesQueryVariables) => ['getImmersiveSales.infinite', variables];

export const NextCollectionSaleDocument = `
    query nextCollectionSale {
  nextCollectionSale {
    saleId
    name
    customFilters {
      id
      label
      values {
        value
        label
      }
    }
  }
}
    `;

export const useNextCollectionSaleQuery = <
      TData = NextCollectionSaleQuery,
      TError = unknown
    >(
      variables?: NextCollectionSaleQueryVariables,
      options?: Omit<UseQueryOptions<NextCollectionSaleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NextCollectionSaleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NextCollectionSaleQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['nextCollectionSale'] : ['nextCollectionSale', variables],
    queryFn: useFetchData<NextCollectionSaleQuery, NextCollectionSaleQueryVariables>(NextCollectionSaleDocument).bind(null, variables),
    ...options
  }
    )};

useNextCollectionSaleQuery.getKey = (variables?: NextCollectionSaleQueryVariables) => variables === undefined ? ['nextCollectionSale'] : ['nextCollectionSale', variables];

export const useInfiniteNextCollectionSaleQuery = <
      TData = InfiniteData<NextCollectionSaleQuery>,
      TError = unknown
    >(
      variables: NextCollectionSaleQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NextCollectionSaleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NextCollectionSaleQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NextCollectionSaleQuery, NextCollectionSaleQueryVariables>(NextCollectionSaleDocument)
    return useInfiniteQuery<NextCollectionSaleQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['nextCollectionSale.infinite'] : ['nextCollectionSale.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNextCollectionSaleQuery.getKey = (variables?: NextCollectionSaleQueryVariables) => variables === undefined ? ['nextCollectionSale.infinite'] : ['nextCollectionSale.infinite', variables];

export const GetNextImmersiveSalesDocument = `
    query GetNextImmersiveSales($storeId: StoreRegion!, $startAt: LocalDate!, $endAt: LocalDate!) {
  marketing {
    getNextImmersiveSales(store: $storeId, startAt: $startAt, endAt: $endAt) {
      id
      saleId
      displayFromDayOffset
      videoUrl
      imageUrl
      brandLogoUrl
      brandName
      description
      descriptionTranslationKey
      url
      startAt
      endAt
      preTeasingDates {
        startAt
        endAt
      }
      forceFirstPositionDates
      saleStartAt
      status
      universeIds
    }
  }
}
    `;

export const useGetNextImmersiveSalesQuery = <
      TData = GetNextImmersiveSalesQuery,
      TError = unknown
    >(
      variables: GetNextImmersiveSalesQueryVariables,
      options?: Omit<UseQueryOptions<GetNextImmersiveSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNextImmersiveSalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNextImmersiveSalesQuery, TError, TData>(
      {
    queryKey: ['GetNextImmersiveSales', variables],
    queryFn: useFetchData<GetNextImmersiveSalesQuery, GetNextImmersiveSalesQueryVariables>(GetNextImmersiveSalesDocument).bind(null, variables),
    ...options
  }
    )};

useGetNextImmersiveSalesQuery.getKey = (variables: GetNextImmersiveSalesQueryVariables) => ['GetNextImmersiveSales', variables];

export const useInfiniteGetNextImmersiveSalesQuery = <
      TData = InfiniteData<GetNextImmersiveSalesQuery>,
      TError = unknown
    >(
      variables: GetNextImmersiveSalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetNextImmersiveSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetNextImmersiveSalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetNextImmersiveSalesQuery, GetNextImmersiveSalesQueryVariables>(GetNextImmersiveSalesDocument)
    return useInfiniteQuery<GetNextImmersiveSalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetNextImmersiveSales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetNextImmersiveSalesQuery.getKey = (variables: GetNextImmersiveSalesQueryVariables) => ['GetNextImmersiveSales.infinite', variables];

export const GetProductCouponsDocument = `
    query getProductCoupons($productId: String!, $variantId: ID, $count: Int!) {
  getProductCouponsV2(productId: $productId, variantId: $variantId, count: $count) {
    boughtCodes
    codes {
      code
      order_id
      product_id
      variant_id
    }
    total
  }
}
    `;

export const useGetProductCouponsQuery = <
      TData = GetProductCouponsQuery,
      TError = unknown
    >(
      variables: GetProductCouponsQueryVariables,
      options?: Omit<UseQueryOptions<GetProductCouponsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductCouponsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductCouponsQuery, TError, TData>(
      {
    queryKey: ['getProductCoupons', variables],
    queryFn: useFetchData<GetProductCouponsQuery, GetProductCouponsQueryVariables>(GetProductCouponsDocument).bind(null, variables),
    ...options
  }
    )};

useGetProductCouponsQuery.getKey = (variables: GetProductCouponsQueryVariables) => ['getProductCoupons', variables];

export const useInfiniteGetProductCouponsQuery = <
      TData = InfiniteData<GetProductCouponsQuery>,
      TError = unknown
    >(
      variables: GetProductCouponsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductCouponsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductCouponsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetProductCouponsQuery, GetProductCouponsQueryVariables>(GetProductCouponsDocument)
    return useInfiniteQuery<GetProductCouponsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getProductCoupons.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductCouponsQuery.getKey = (variables: GetProductCouponsQueryVariables) => ['getProductCoupons.infinite', variables];

export const ProductLinkedProductsDocument = `
    query productLinkedProducts($productId: String!) {
  product(productId: $productId) {
    id
    linkedProducts {
      productId
      relatedProductId
    }
  }
}
    `;

export const useProductLinkedProductsQuery = <
      TData = ProductLinkedProductsQuery,
      TError = unknown
    >(
      variables: ProductLinkedProductsQueryVariables,
      options?: Omit<UseQueryOptions<ProductLinkedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductLinkedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductLinkedProductsQuery, TError, TData>(
      {
    queryKey: ['productLinkedProducts', variables],
    queryFn: useFetchData<ProductLinkedProductsQuery, ProductLinkedProductsQueryVariables>(ProductLinkedProductsDocument).bind(null, variables),
    ...options
  }
    )};

useProductLinkedProductsQuery.getKey = (variables: ProductLinkedProductsQueryVariables) => ['productLinkedProducts', variables];

export const useInfiniteProductLinkedProductsQuery = <
      TData = InfiniteData<ProductLinkedProductsQuery>,
      TError = unknown
    >(
      variables: ProductLinkedProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductLinkedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductLinkedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProductLinkedProductsQuery, ProductLinkedProductsQueryVariables>(ProductLinkedProductsDocument)
    return useInfiniteQuery<ProductLinkedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['productLinkedProducts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProductLinkedProductsQuery.getKey = (variables: ProductLinkedProductsQueryVariables) => ['productLinkedProducts.infinite', variables];

export const GetProductDocument = `
    query getProduct($productId: String!) {
  product(productId: $productId) {
    id
    type
    isDraft
    isAlcohol
    badges {
      isSpecial
      position
      value
    }
    sourceUrl
    hasVatMargin
    hide
    hideBy
    hideAt
    category {
      name
      vat
    }
    description
    name
    modelSizeInfos
    sizeAdvices
    currency
    brand {
      id
      name
    }
    variants {
      id
      position
      isUnique
      options {
        productOptionId
        valueId
      }
      hide
      hideBy
      hideAt
      gtin
      sku
      shopify_variant_id
      images
      absorbedShipping
      buyingPrice
      chooseFees
      deliveryDelays
      discountPercentage
      eeePrice
      retailPrice
      price
      shippingFees
      weightGram
      widthMillimeter
      heightMillimeter
      lengthMillimeter
      unitsPerPack
      stockCount
      originCountry
    }
    options {
      id
      type
      name
      images {
        id
        baseKey
        image
      }
      position
      values {
        id
        value
        position
      }
    }
    gender
    couponDetail
    couponExpirationDate
    cgu
    faqPreOrder
    faq
    faqPostOrder
    customFields {
      key
      position
      type
      value
    }
    isCobrand
    isCobrandFeatured
    isBestSeller
    isHighlightedAsNew
    isCover
    isReturnable
    isDeliveredByChoose
    isGiveaway
    position
    images {
      id
      baseKey
      image
    }
    video
    audio {
      url
      label
    }
    inCollections {
      collectionSaleId
      isBestseller
      customFilters {
        filterId
        selectedValues
      }
    }
  }
}
    `;

export const useGetProductQuery = <
      TData = GetProductQuery,
      TError = unknown
    >(
      variables: GetProductQueryVariables,
      options?: Omit<UseQueryOptions<GetProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductQuery, TError, TData>(
      {
    queryKey: ['getProduct', variables],
    queryFn: useFetchData<GetProductQuery, GetProductQueryVariables>(GetProductDocument).bind(null, variables),
    ...options
  }
    )};

useGetProductQuery.getKey = (variables: GetProductQueryVariables) => ['getProduct', variables];

export const useInfiniteGetProductQuery = <
      TData = InfiniteData<GetProductQuery>,
      TError = unknown
    >(
      variables: GetProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetProductQuery, GetProductQueryVariables>(GetProductDocument)
    return useInfiniteQuery<GetProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getProduct.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductQuery.getKey = (variables: GetProductQueryVariables) => ['getProduct.infinite', variables];

export const ProvisionalSalesDocument = `
    query ProvisionalSales($storeId: StoreRegion!) {
  provisionalSales(storeId: $storeId) {
    id
    name
    category
    saleBy
    startsAt
    brandHasShopify
    forecast
    hubspotId
    hubspotCategory
    hubspot_team_name
    hubspot_tiering
    hubspot_top_brand_type
    hubspot_demande_point_relais
    cancellationLevel
    operationType
    gender
    instagramId
    website
    note
    brandSaleCount
    shopify {
      hasCredentials
      isStockLive
      testMondialRelayOn
      testOrderOn
      testShop2ShopOn
    }
    deal {
      link
    }
  }
}
    `;

export const useProvisionalSalesQuery = <
      TData = ProvisionalSalesQuery,
      TError = unknown
    >(
      variables: ProvisionalSalesQueryVariables,
      options?: Omit<UseQueryOptions<ProvisionalSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProvisionalSalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProvisionalSalesQuery, TError, TData>(
      {
    queryKey: ['ProvisionalSales', variables],
    queryFn: useFetchData<ProvisionalSalesQuery, ProvisionalSalesQueryVariables>(ProvisionalSalesDocument).bind(null, variables),
    ...options
  }
    )};

useProvisionalSalesQuery.getKey = (variables: ProvisionalSalesQueryVariables) => ['ProvisionalSales', variables];

export const useInfiniteProvisionalSalesQuery = <
      TData = InfiniteData<ProvisionalSalesQuery>,
      TError = unknown
    >(
      variables: ProvisionalSalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProvisionalSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProvisionalSalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProvisionalSalesQuery, ProvisionalSalesQueryVariables>(ProvisionalSalesDocument)
    return useInfiniteQuery<ProvisionalSalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProvisionalSales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProvisionalSalesQuery.getKey = (variables: ProvisionalSalesQueryVariables) => ['ProvisionalSales.infinite', variables];

export const ReferralBlockDocument = `
    query referralBlock($store: StoreRegion!) {
  marketing {
    referralBlock(store: $store) {
      bigImage
      btnCta
      date
      smallImage
      tagline
      title
    }
  }
}
    `;

export const useReferralBlockQuery = <
      TData = ReferralBlockQuery,
      TError = unknown
    >(
      variables: ReferralBlockQueryVariables,
      options?: Omit<UseQueryOptions<ReferralBlockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReferralBlockQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReferralBlockQuery, TError, TData>(
      {
    queryKey: ['referralBlock', variables],
    queryFn: useFetchData<ReferralBlockQuery, ReferralBlockQueryVariables>(ReferralBlockDocument).bind(null, variables),
    ...options
  }
    )};

useReferralBlockQuery.getKey = (variables: ReferralBlockQueryVariables) => ['referralBlock', variables];

export const useInfiniteReferralBlockQuery = <
      TData = InfiniteData<ReferralBlockQuery>,
      TError = unknown
    >(
      variables: ReferralBlockQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ReferralBlockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ReferralBlockQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ReferralBlockQuery, ReferralBlockQueryVariables>(ReferralBlockDocument)
    return useInfiniteQuery<ReferralBlockQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['referralBlock.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteReferralBlockQuery.getKey = (variables: ReferralBlockQueryVariables) => ['referralBlock.infinite', variables];

export const GetReferralUploadUrlDocument = `
    query getReferralUploadUrl($fileType: String!, $saleId: String!, $uploadType: MarketingReferralImageType!) {
  marketing {
    getReferralUploadUrl(
      fileType: $fileType
      saleId: $saleId
      uploadType: $uploadType
    ) {
      key
      url
    }
  }
}
    `;

export const useGetReferralUploadUrlQuery = <
      TData = GetReferralUploadUrlQuery,
      TError = unknown
    >(
      variables: GetReferralUploadUrlQueryVariables,
      options?: Omit<UseQueryOptions<GetReferralUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReferralUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReferralUploadUrlQuery, TError, TData>(
      {
    queryKey: ['getReferralUploadUrl', variables],
    queryFn: useFetchData<GetReferralUploadUrlQuery, GetReferralUploadUrlQueryVariables>(GetReferralUploadUrlDocument).bind(null, variables),
    ...options
  }
    )};

useGetReferralUploadUrlQuery.getKey = (variables: GetReferralUploadUrlQueryVariables) => ['getReferralUploadUrl', variables];

export const useInfiniteGetReferralUploadUrlQuery = <
      TData = InfiniteData<GetReferralUploadUrlQuery>,
      TError = unknown
    >(
      variables: GetReferralUploadUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetReferralUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetReferralUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetReferralUploadUrlQuery, GetReferralUploadUrlQueryVariables>(GetReferralUploadUrlDocument)
    return useInfiniteQuery<GetReferralUploadUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getReferralUploadUrl.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetReferralUploadUrlQuery.getKey = (variables: GetReferralUploadUrlQueryVariables) => ['getReferralUploadUrl.infinite', variables];

export const SaleAppFiltersDocument = `
    query saleAppFilters($saleId: ID!) {
  saleAppFilters(saleId: $saleId) {
    displayed {
      id
      label
    }
    shortcutable {
      id
      label
    }
  }
}
    `;

export const useSaleAppFiltersQuery = <
      TData = SaleAppFiltersQuery,
      TError = unknown
    >(
      variables: SaleAppFiltersQueryVariables,
      options?: Omit<UseQueryOptions<SaleAppFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleAppFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleAppFiltersQuery, TError, TData>(
      {
    queryKey: ['saleAppFilters', variables],
    queryFn: useFetchData<SaleAppFiltersQuery, SaleAppFiltersQueryVariables>(SaleAppFiltersDocument).bind(null, variables),
    ...options
  }
    )};

useSaleAppFiltersQuery.getKey = (variables: SaleAppFiltersQueryVariables) => ['saleAppFilters', variables];

export const useInfiniteSaleAppFiltersQuery = <
      TData = InfiniteData<SaleAppFiltersQuery>,
      TError = unknown
    >(
      variables: SaleAppFiltersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleAppFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleAppFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleAppFiltersQuery, SaleAppFiltersQueryVariables>(SaleAppFiltersDocument)
    return useInfiniteQuery<SaleAppFiltersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['saleAppFilters.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleAppFiltersQuery.getKey = (variables: SaleAppFiltersQueryVariables) => ['saleAppFilters.infinite', variables];

export const SaleCustomFiltersDocument = `
    query saleCustomFilters($saleId: ID!) {
  saleCustomFilters(saleId: $saleId) {
    id
    name
    productsCount
    options {
      value
      label
      position
      productsCount
    }
  }
}
    `;

export const useSaleCustomFiltersQuery = <
      TData = SaleCustomFiltersQuery,
      TError = unknown
    >(
      variables: SaleCustomFiltersQueryVariables,
      options?: Omit<UseQueryOptions<SaleCustomFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleCustomFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleCustomFiltersQuery, TError, TData>(
      {
    queryKey: ['saleCustomFilters', variables],
    queryFn: useFetchData<SaleCustomFiltersQuery, SaleCustomFiltersQueryVariables>(SaleCustomFiltersDocument).bind(null, variables),
    ...options
  }
    )};

useSaleCustomFiltersQuery.getKey = (variables: SaleCustomFiltersQueryVariables) => ['saleCustomFilters', variables];

export const useInfiniteSaleCustomFiltersQuery = <
      TData = InfiniteData<SaleCustomFiltersQuery>,
      TError = unknown
    >(
      variables: SaleCustomFiltersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleCustomFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleCustomFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleCustomFiltersQuery, SaleCustomFiltersQueryVariables>(SaleCustomFiltersDocument)
    return useInfiniteQuery<SaleCustomFiltersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['saleCustomFilters.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleCustomFiltersQuery.getKey = (variables: SaleCustomFiltersQueryVariables) => ['saleCustomFilters.infinite', variables];

export const SaleLinkedProductsMetadataDocument = `
    query saleLinkedProductsMetadata($saleId: String!) {
  sale(key: $saleId) {
    id
    linkedProductsMetadata {
      titleKey
      titleFallback
    }
  }
}
    `;

export const useSaleLinkedProductsMetadataQuery = <
      TData = SaleLinkedProductsMetadataQuery,
      TError = unknown
    >(
      variables: SaleLinkedProductsMetadataQueryVariables,
      options?: Omit<UseQueryOptions<SaleLinkedProductsMetadataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleLinkedProductsMetadataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleLinkedProductsMetadataQuery, TError, TData>(
      {
    queryKey: ['saleLinkedProductsMetadata', variables],
    queryFn: useFetchData<SaleLinkedProductsMetadataQuery, SaleLinkedProductsMetadataQueryVariables>(SaleLinkedProductsMetadataDocument).bind(null, variables),
    ...options
  }
    )};

useSaleLinkedProductsMetadataQuery.getKey = (variables: SaleLinkedProductsMetadataQueryVariables) => ['saleLinkedProductsMetadata', variables];

export const useInfiniteSaleLinkedProductsMetadataQuery = <
      TData = InfiniteData<SaleLinkedProductsMetadataQuery>,
      TError = unknown
    >(
      variables: SaleLinkedProductsMetadataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleLinkedProductsMetadataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleLinkedProductsMetadataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleLinkedProductsMetadataQuery, SaleLinkedProductsMetadataQueryVariables>(SaleLinkedProductsMetadataDocument)
    return useInfiniteQuery<SaleLinkedProductsMetadataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['saleLinkedProductsMetadata.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleLinkedProductsMetadataQuery.getKey = (variables: SaleLinkedProductsMetadataQueryVariables) => ['saleLinkedProductsMetadata.infinite', variables];

export const SaleLinkedProductsDocument = `
    query saleLinkedProducts($saleId: String!) {
  sale(key: $saleId) {
    id
    linkedProducts {
      productId
      relatedProductId
    }
  }
}
    `;

export const useSaleLinkedProductsQuery = <
      TData = SaleLinkedProductsQuery,
      TError = unknown
    >(
      variables: SaleLinkedProductsQueryVariables,
      options?: Omit<UseQueryOptions<SaleLinkedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleLinkedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleLinkedProductsQuery, TError, TData>(
      {
    queryKey: ['saleLinkedProducts', variables],
    queryFn: useFetchData<SaleLinkedProductsQuery, SaleLinkedProductsQueryVariables>(SaleLinkedProductsDocument).bind(null, variables),
    ...options
  }
    )};

useSaleLinkedProductsQuery.getKey = (variables: SaleLinkedProductsQueryVariables) => ['saleLinkedProducts', variables];

export const useInfiniteSaleLinkedProductsQuery = <
      TData = InfiniteData<SaleLinkedProductsQuery>,
      TError = unknown
    >(
      variables: SaleLinkedProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleLinkedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleLinkedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleLinkedProductsQuery, SaleLinkedProductsQueryVariables>(SaleLinkedProductsDocument)
    return useInfiniteQuery<SaleLinkedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['saleLinkedProducts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleLinkedProductsQuery.getKey = (variables: SaleLinkedProductsQueryVariables) => ['saleLinkedProducts.infinite', variables];

export const GetSaleProductCheckCountDocument = `
    query getSaleProductCheckCount($saleId: ID!) {
  saleProductCheckCount(saleId: $saleId) {
    tva
    unit_price
    public_price
    sizes
    informations
    description_coherence
    description_spelling
    warranties
    history_price
    wrong_shopify_variant_id
    wrong_barcode
  }
}
    `;

export const useGetSaleProductCheckCountQuery = <
      TData = GetSaleProductCheckCountQuery,
      TError = unknown
    >(
      variables: GetSaleProductCheckCountQueryVariables,
      options?: Omit<UseQueryOptions<GetSaleProductCheckCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSaleProductCheckCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSaleProductCheckCountQuery, TError, TData>(
      {
    queryKey: ['getSaleProductCheckCount', variables],
    queryFn: useFetchData<GetSaleProductCheckCountQuery, GetSaleProductCheckCountQueryVariables>(GetSaleProductCheckCountDocument).bind(null, variables),
    ...options
  }
    )};

useGetSaleProductCheckCountQuery.getKey = (variables: GetSaleProductCheckCountQueryVariables) => ['getSaleProductCheckCount', variables];

export const useInfiniteGetSaleProductCheckCountQuery = <
      TData = InfiniteData<GetSaleProductCheckCountQuery>,
      TError = unknown
    >(
      variables: GetSaleProductCheckCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSaleProductCheckCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSaleProductCheckCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetSaleProductCheckCountQuery, GetSaleProductCheckCountQueryVariables>(GetSaleProductCheckCountDocument)
    return useInfiniteQuery<GetSaleProductCheckCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSaleProductCheckCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSaleProductCheckCountQuery.getKey = (variables: GetSaleProductCheckCountQueryVariables) => ['getSaleProductCheckCount.infinite', variables];

export const GetSaleProductCheckStatusesDocument = `
    query getSaleProductCheckStatuses($saleId: ID!) {
  saleProductCheckStatuses(saleId: $saleId) {
    id
    productId
    variantId
    checkType
    status
    severity
    message
    data {
      ... on SpellingCheckData {
        spellingErrors: errors {
          original
          correction
        }
      }
      ... on PublicPriceCheckData {
        choose_price
        shopify_price
        choose_discount_price
        shopify_discount_price
      }
      ... on SizesCheckData {
        id
        original
        correction
      }
      ... on CoherenceCheckData {
        coherenceErrors: errors
      }
      ... on InformationCheckData {
        present
        missing {
          key
          importance
        }
      }
    }
    dismissedAt
    dismissedBy
    createdAt
    updatedAt
  }
}
    `;

export const useGetSaleProductCheckStatusesQuery = <
      TData = GetSaleProductCheckStatusesQuery,
      TError = unknown
    >(
      variables: GetSaleProductCheckStatusesQueryVariables,
      options?: Omit<UseQueryOptions<GetSaleProductCheckStatusesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSaleProductCheckStatusesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSaleProductCheckStatusesQuery, TError, TData>(
      {
    queryKey: ['getSaleProductCheckStatuses', variables],
    queryFn: useFetchData<GetSaleProductCheckStatusesQuery, GetSaleProductCheckStatusesQueryVariables>(GetSaleProductCheckStatusesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSaleProductCheckStatusesQuery.getKey = (variables: GetSaleProductCheckStatusesQueryVariables) => ['getSaleProductCheckStatuses', variables];

export const useInfiniteGetSaleProductCheckStatusesQuery = <
      TData = InfiniteData<GetSaleProductCheckStatusesQuery>,
      TError = unknown
    >(
      variables: GetSaleProductCheckStatusesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSaleProductCheckStatusesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSaleProductCheckStatusesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetSaleProductCheckStatusesQuery, GetSaleProductCheckStatusesQueryVariables>(GetSaleProductCheckStatusesDocument)
    return useInfiniteQuery<GetSaleProductCheckStatusesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSaleProductCheckStatuses.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSaleProductCheckStatusesQuery.getKey = (variables: GetSaleProductCheckStatusesQueryVariables) => ['getSaleProductCheckStatuses.infinite', variables];

export const SaleDocument = `
    query sale($key: String!) {
  sale(key: $key) {
    badges
    brand {
      id
      name
      contactName
      sale_objectif_name
      contactPhone
      accept_contract
      about
      contactEmail
      instagram
      address
      is_autoentrepreneur
      shipping_restricted_to_france
      emailedAt
      invitationLink
      plugins {
        shopify
      }
    }
    cashbackPolicy {
      delayInDays
      thresholds {
        threshold
        cashbackAmount
      }
    }
    category
    collectionSale {
      saleId
      name
      customFilters {
        id
        label
      }
      readonlyFilters {
        id
        label
        values {
          value
          label
        }
      }
      bestsellersProducts
    }
    currency
    customFilters {
      id
      label
      values {
        value
        label
      }
    }
    filtersConfig {
      illustrated
      selectedColor
      hiddenFilterIds
      shortcutFilterIds
      filterImages {
        filterId
        imageUrl
      }
    }
    deliver_by_choose
    delivery_delays
    deal {
      link
    }
    delivery_offered_until
    description
    disable_sorting
    end_at
    end_at_date
    giveawayPolicies {
      saleId
      overOrderAmount
      productId
      triggerProductId
      dateRange {
        startAt
        endAt
      }
    }
    has_orders
    hasReturnableProducts
    hide
    hubspot_campaign_type
    hubspot_deal_id
    hubspot_selection_id
    id
    image_header
    video_header
    initial_start_at
    invoice {
      is_invoice_ready
      invoice_amount
      invoice_by
      invoice_on
      paid_on
      proof_paid_url
      paid_amount
      paid_by
    }
    is_cancelled
    is_ready
    is_selection
    is_setup
    isShopify
    hubspot_demande_point_relais
    logistics_manager
    marketingVideo {
      url
      coverImageUrl
      label
      title
    }
    newImages {
      baseKey
      id
      image
      properties {
        full
        gender
      }
    }
    newPreviews {
      baseKey
      full
      id
      image
    }
    operation_type
    products {
      badges {
        isSpecial
        position
        value
      }
      brand {
        id
        name
      }
      campaign {
        startAt
        endAt
      }
      category {
        name
        vat
      }
      currency
      customFields {
        key
        position
        type
        value
      }
      description
      hasVatMargin
      hide
      hideBy
      hideAt
      id
      images {
        id
        baseKey
        image
      }
      video
      audio {
        url
        label
      }
      importCsvPosition
      isCobrand
      isCobrandFeatured
      isBestSeller
      isHighlightedAsNew
      isCover
      isDeliveredByChoose
      isDraft
      isGiveaway
      isReturnable
      modelSizeInfos
      name
      options {
        id
        type
        name
        images {
          id
          baseKey
          image
        }
        position
        values {
          id
          value
          position
        }
      }
      position
      sourceUrl
      sizeAdvices
      couponDetail
      couponExpirationDate
      cgu
      faqPreOrder
      faq
      faqPostOrder
      variants {
        id
        position
        isUnique
        options {
          productOptionId
          valueId
        }
        hide
        hideBy
        hideAt
        gtin
        sku
        shopify_variant_id
        images
        absorbedShipping
        buyingPrice
        chooseFees
        computedDeliveryDelays
        discountPercentage
        eeePrice
        retailPrice
        price
        shippingFees
        weightGram
        widthMillimeter
        heightMillimeter
        lengthMillimeter
        stockCount
        originCountry
        unitsPerPack
        customFilters {
          filterId
          selectedValues
        }
      }
      type
      readonlyFilters {
        filterId
        selectedValues
      }
    }
    sale_status
    selection_name
    setup_by
    disable_automatic_extension
    shopify {
      testMondialRelayOn
      testOrderOn
      testShop2ShopOn
      hasPlugin
    }
    shippingPolicy {
      freeShippingMinimumOrderAmount
      pickupPoint {
        network
        shippingCost
      }
      freeShippingRules {
        countries
        deliveryMethod
        freeShippingMinimumOrderAmount
        commercialOfferMinimumOrderAmount
      }
    }
    start_at
    start_at_date
    status
    storeId
    tva
    upcoming_display_forced
    url
    url_google_drive
    widgets {
      created_at
      id
      proposition
      results
      state
      type
    }
  }
}
    `;

export const useSaleQuery = <
      TData = SaleQuery,
      TError = unknown
    >(
      variables: SaleQueryVariables,
      options?: Omit<UseQueryOptions<SaleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SaleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SaleQuery, TError, TData>(
      {
    queryKey: ['sale', variables],
    queryFn: useFetchData<SaleQuery, SaleQueryVariables>(SaleDocument).bind(null, variables),
    ...options
  }
    )};

useSaleQuery.getKey = (variables: SaleQueryVariables) => ['sale', variables];

export const useInfiniteSaleQuery = <
      TData = InfiniteData<SaleQuery>,
      TError = unknown
    >(
      variables: SaleQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SaleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SaleQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SaleQuery, SaleQueryVariables>(SaleDocument)
    return useInfiniteQuery<SaleQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['sale.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSaleQuery.getKey = (variables: SaleQueryVariables) => ['sale.infinite', variables];

export const SalesDocument = `
    query Sales($status: SaleStatus!, $storeId: StoreRegion!, $offset: Int) {
  sales(status: $status, storeId: $storeId, offset: $offset) {
    has_more
    pagination
    sales {
      badges
      brand {
        name
        contactName
      }
      category
      end_at_date
      hide
      id
      deliver_by_choose
      delivery_offered_until
      image_header
      is_selection
      logistics_manager
      selection_name
      setup_by
      start_at_date
      upcoming_display_forced
    }
    total_sales
  }
}
    `;

export const useSalesQuery = <
      TData = SalesQuery,
      TError = unknown
    >(
      variables: SalesQueryVariables,
      options?: Omit<UseQueryOptions<SalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SalesQuery, TError, TData>(
      {
    queryKey: ['Sales', variables],
    queryFn: useFetchData<SalesQuery, SalesQueryVariables>(SalesDocument).bind(null, variables),
    ...options
  }
    )};

useSalesQuery.getKey = (variables: SalesQueryVariables) => ['Sales', variables];

export const useInfiniteSalesQuery = <
      TData = InfiniteData<SalesQuery>,
      TError = unknown
    >(
      variables: SalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SalesQuery, SalesQueryVariables>(SalesDocument)
    return useInfiniteQuery<SalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Sales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSalesQuery.getKey = (variables: SalesQueryVariables) => ['Sales.infinite', variables];

export const GetSetupIssuesDocument = `
    query getSetupIssues {
  getSetupIssues {
    id
    type
    description
  }
}
    `;

export const useGetSetupIssuesQuery = <
      TData = GetSetupIssuesQuery,
      TError = unknown
    >(
      variables?: GetSetupIssuesQueryVariables,
      options?: Omit<UseQueryOptions<GetSetupIssuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSetupIssuesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSetupIssuesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSetupIssues'] : ['getSetupIssues', variables],
    queryFn: useFetchData<GetSetupIssuesQuery, GetSetupIssuesQueryVariables>(GetSetupIssuesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSetupIssuesQuery.getKey = (variables?: GetSetupIssuesQueryVariables) => variables === undefined ? ['getSetupIssues'] : ['getSetupIssues', variables];

export const useInfiniteGetSetupIssuesQuery = <
      TData = InfiniteData<GetSetupIssuesQuery>,
      TError = unknown
    >(
      variables: GetSetupIssuesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSetupIssuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSetupIssuesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetSetupIssuesQuery, GetSetupIssuesQueryVariables>(GetSetupIssuesDocument)
    return useInfiniteQuery<GetSetupIssuesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSetupIssues.infinite'] : ['getSetupIssues.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSetupIssuesQuery.getKey = (variables?: GetSetupIssuesQueryVariables) => variables === undefined ? ['getSetupIssues.infinite'] : ['getSetupIssues.infinite', variables];

export const GetShopifyLocationsDocument = `
    query GetShopifyLocations($sellerId: ID!) {
  shopify {
    getShopifyInventoryAvailable(sellerId: $sellerId) {
      id
      name
    }
  }
}
    `;

export const useGetShopifyLocationsQuery = <
      TData = GetShopifyLocationsQuery,
      TError = unknown
    >(
      variables: GetShopifyLocationsQueryVariables,
      options?: Omit<UseQueryOptions<GetShopifyLocationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetShopifyLocationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetShopifyLocationsQuery, TError, TData>(
      {
    queryKey: ['GetShopifyLocations', variables],
    queryFn: useFetchData<GetShopifyLocationsQuery, GetShopifyLocationsQueryVariables>(GetShopifyLocationsDocument).bind(null, variables),
    ...options
  }
    )};

useGetShopifyLocationsQuery.getKey = (variables: GetShopifyLocationsQueryVariables) => ['GetShopifyLocations', variables];

export const useInfiniteGetShopifyLocationsQuery = <
      TData = InfiniteData<GetShopifyLocationsQuery>,
      TError = unknown
    >(
      variables: GetShopifyLocationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetShopifyLocationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetShopifyLocationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetShopifyLocationsQuery, GetShopifyLocationsQueryVariables>(GetShopifyLocationsDocument)
    return useInfiniteQuery<GetShopifyLocationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetShopifyLocations.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetShopifyLocationsQuery.getKey = (variables: GetShopifyLocationsQueryVariables) => ['GetShopifyLocations.infinite', variables];

export const GetShopifyPermissionsDocument = `
    query GetShopifyPermissions($sellerId: ID!) {
  shopify {
    getShopifyPermissions(sellerId: $sellerId) {
      warning_too_much_permissions
      is_disconnected
      can_create_order
      can_sync_stock
      can_create_draft_order
      can_read_fulfillments
      can_update_stock
      can_create_order_products
      can_read_delivery_services
      can_read_returns
      can_write_returns
      has_stock_protection
      set_product_price
      delivery
      mondial_relay_code
      international_carrier_code
      can_create_order_with_specific_location_id
      inventory_location_ids
      can_read_locations
      deliveries_list {
        BE
        ES
        FR
        US
      }
      deliveries
    }
  }
}
    `;

export const useGetShopifyPermissionsQuery = <
      TData = GetShopifyPermissionsQuery,
      TError = unknown
    >(
      variables: GetShopifyPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<GetShopifyPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetShopifyPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetShopifyPermissionsQuery, TError, TData>(
      {
    queryKey: ['GetShopifyPermissions', variables],
    queryFn: useFetchData<GetShopifyPermissionsQuery, GetShopifyPermissionsQueryVariables>(GetShopifyPermissionsDocument).bind(null, variables),
    ...options
  }
    )};

useGetShopifyPermissionsQuery.getKey = (variables: GetShopifyPermissionsQueryVariables) => ['GetShopifyPermissions', variables];

export const useInfiniteGetShopifyPermissionsQuery = <
      TData = InfiniteData<GetShopifyPermissionsQuery>,
      TError = unknown
    >(
      variables: GetShopifyPermissionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetShopifyPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetShopifyPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetShopifyPermissionsQuery, GetShopifyPermissionsQueryVariables>(GetShopifyPermissionsDocument)
    return useInfiniteQuery<GetShopifyPermissionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetShopifyPermissions.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetShopifyPermissionsQuery.getKey = (variables: GetShopifyPermissionsQueryVariables) => ['GetShopifyPermissions.infinite', variables];

export const GetShopifyProductsDocument = `
    query GetShopifyProducts($sellerId: ID!, $saleId: ID!) {
  shopify {
    getShopifyProducts(sellerId: $sellerId, saleId: $saleId) {
      error
      url
    }
  }
}
    `;

export const useGetShopifyProductsQuery = <
      TData = GetShopifyProductsQuery,
      TError = unknown
    >(
      variables: GetShopifyProductsQueryVariables,
      options?: Omit<UseQueryOptions<GetShopifyProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetShopifyProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetShopifyProductsQuery, TError, TData>(
      {
    queryKey: ['GetShopifyProducts', variables],
    queryFn: useFetchData<GetShopifyProductsQuery, GetShopifyProductsQueryVariables>(GetShopifyProductsDocument).bind(null, variables),
    ...options
  }
    )};

useGetShopifyProductsQuery.getKey = (variables: GetShopifyProductsQueryVariables) => ['GetShopifyProducts', variables];

export const useInfiniteGetShopifyProductsQuery = <
      TData = InfiniteData<GetShopifyProductsQuery>,
      TError = unknown
    >(
      variables: GetShopifyProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetShopifyProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetShopifyProductsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetShopifyProductsQuery, GetShopifyProductsQueryVariables>(GetShopifyProductsDocument)
    return useInfiniteQuery<GetShopifyProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetShopifyProducts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetShopifyProductsQuery.getKey = (variables: GetShopifyProductsQueryVariables) => ['GetShopifyProducts.infinite', variables];

export const GetShopifyUnfulfilledOrdersDocument = `
    query GetShopifyUnfulfilledOrders($sellerId: ID!, $saleId: ID!) {
  shopify {
    getShopifyUnfulfilledOrders(sellerId: $sellerId, saleId: $saleId) {
      count
      error
      url
    }
  }
}
    `;

export const useGetShopifyUnfulfilledOrdersQuery = <
      TData = GetShopifyUnfulfilledOrdersQuery,
      TError = unknown
    >(
      variables: GetShopifyUnfulfilledOrdersQueryVariables,
      options?: Omit<UseQueryOptions<GetShopifyUnfulfilledOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetShopifyUnfulfilledOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetShopifyUnfulfilledOrdersQuery, TError, TData>(
      {
    queryKey: ['GetShopifyUnfulfilledOrders', variables],
    queryFn: useFetchData<GetShopifyUnfulfilledOrdersQuery, GetShopifyUnfulfilledOrdersQueryVariables>(GetShopifyUnfulfilledOrdersDocument).bind(null, variables),
    ...options
  }
    )};

useGetShopifyUnfulfilledOrdersQuery.getKey = (variables: GetShopifyUnfulfilledOrdersQueryVariables) => ['GetShopifyUnfulfilledOrders', variables];

export const useInfiniteGetShopifyUnfulfilledOrdersQuery = <
      TData = InfiniteData<GetShopifyUnfulfilledOrdersQuery>,
      TError = unknown
    >(
      variables: GetShopifyUnfulfilledOrdersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetShopifyUnfulfilledOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetShopifyUnfulfilledOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetShopifyUnfulfilledOrdersQuery, GetShopifyUnfulfilledOrdersQueryVariables>(GetShopifyUnfulfilledOrdersDocument)
    return useInfiniteQuery<GetShopifyUnfulfilledOrdersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetShopifyUnfulfilledOrders.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetShopifyUnfulfilledOrdersQuery.getKey = (variables: GetShopifyUnfulfilledOrdersQueryVariables) => ['GetShopifyUnfulfilledOrders.infinite', variables];

export const OngoingAndUpcomingSalesDocument = `
    query ongoingAndUpcomingSales($storeId: StoreRegion!) {
  ongoingSales: sales(status: ONGOING, storeId: $storeId) {
    has_more
    pagination
    sales {
      badges
      brand {
        id
        name
        contactEmail
        contactName
      }
      category
      end_at_date
      hide
      id
      image_header
      is_selection
      logistics_manager
      sale_status
      selection_name
      setup_by
      start_at_date
      storeId
      upcoming_display_forced
    }
    total_sales
  }
  upcomingSales: sales(status: UPCOMING, storeId: $storeId) {
    has_more
    pagination
    sales {
      badges
      brand {
        id
        name
        contactEmail
        contactName
      }
      category
      end_at_date
      hide
      id
      image_header
      is_selection
      logistics_manager
      sale_status
      selection_name
      setup_by
      start_at_date
      storeId
      upcoming_display_forced
    }
    total_sales
  }
}
    `;

export const useOngoingAndUpcomingSalesQuery = <
      TData = OngoingAndUpcomingSalesQuery,
      TError = unknown
    >(
      variables: OngoingAndUpcomingSalesQueryVariables,
      options?: Omit<UseQueryOptions<OngoingAndUpcomingSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OngoingAndUpcomingSalesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OngoingAndUpcomingSalesQuery, TError, TData>(
      {
    queryKey: ['ongoingAndUpcomingSales', variables],
    queryFn: useFetchData<OngoingAndUpcomingSalesQuery, OngoingAndUpcomingSalesQueryVariables>(OngoingAndUpcomingSalesDocument).bind(null, variables),
    ...options
  }
    )};

useOngoingAndUpcomingSalesQuery.getKey = (variables: OngoingAndUpcomingSalesQueryVariables) => ['ongoingAndUpcomingSales', variables];

export const useInfiniteOngoingAndUpcomingSalesQuery = <
      TData = InfiniteData<OngoingAndUpcomingSalesQuery>,
      TError = unknown
    >(
      variables: OngoingAndUpcomingSalesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OngoingAndUpcomingSalesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OngoingAndUpcomingSalesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OngoingAndUpcomingSalesQuery, OngoingAndUpcomingSalesQueryVariables>(OngoingAndUpcomingSalesDocument)
    return useInfiniteQuery<OngoingAndUpcomingSalesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ongoingAndUpcomingSales.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOngoingAndUpcomingSalesQuery.getKey = (variables: OngoingAndUpcomingSalesQueryVariables) => ['ongoingAndUpcomingSales.infinite', variables];

export const GetUploadUrlDocument = `
    query GetUploadUrl($fileType: String!, $uploadType: FileUploadType!, $saleId: String!, $name: String) {
  getUploadUrl(
    fileType: $fileType
    uploadType: $uploadType
    saleId: $saleId
    name: $name
  )
}
    `;

export const useGetUploadUrlQuery = <
      TData = GetUploadUrlQuery,
      TError = unknown
    >(
      variables: GetUploadUrlQueryVariables,
      options?: Omit<UseQueryOptions<GetUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUploadUrlQuery, TError, TData>(
      {
    queryKey: ['GetUploadUrl', variables],
    queryFn: useFetchData<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument).bind(null, variables),
    ...options
  }
    )};

useGetUploadUrlQuery.getKey = (variables: GetUploadUrlQueryVariables) => ['GetUploadUrl', variables];

export const useInfiniteGetUploadUrlQuery = <
      TData = InfiniteData<GetUploadUrlQuery>,
      TError = unknown
    >(
      variables: GetUploadUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument)
    return useInfiniteQuery<GetUploadUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUploadUrl.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUploadUrlQuery.getKey = (variables: GetUploadUrlQueryVariables) => ['GetUploadUrl.infinite', variables];

export const HideOutOfStockProductsAndVariantsDocument = `
    mutation hideOutOfStockProductsAndVariants($productIds: [ID!]!) {
  hideOutOfStockProductsAndVariants(productIds: $productIds)
}
    `;

export const useHideOutOfStockProductsAndVariantsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<HideOutOfStockProductsAndVariantsMutation, TError, HideOutOfStockProductsAndVariantsMutationVariables, TContext>) => {
    
    return useMutation<HideOutOfStockProductsAndVariantsMutation, TError, HideOutOfStockProductsAndVariantsMutationVariables, TContext>(
      {
    mutationKey: ['hideOutOfStockProductsAndVariants'],
    mutationFn: useFetchData<HideOutOfStockProductsAndVariantsMutation, HideOutOfStockProductsAndVariantsMutationVariables>(HideOutOfStockProductsAndVariantsDocument),
    ...options
  }
    )};

export const ImageProccessedDocument = `
    subscription imageProccessed($sessionId: ID!) {
  imageProccessed(sessionId: $sessionId) {
    actionId
    id
    url
  }
}
    `;
export const ImportProductsUpdatedDocument = `
    subscription importProductsUpdated($saleId: String!) {
  importProductsUpdated(saleId: $saleId) {
    id
    saleId
    error {
      code
      message
    }
  }
}
    `;
export const ImportProductsDocument = `
    mutation importProducts($saleId: String!, $sync: Boolean, $url: String) {
  importProducts(saleId: $saleId, sync: $sync, url: $url)
}
    `;

export const useImportProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportProductsMutation, TError, ImportProductsMutationVariables, TContext>) => {
    
    return useMutation<ImportProductsMutation, TError, ImportProductsMutationVariables, TContext>(
      {
    mutationKey: ['importProducts'],
    mutationFn: useFetchData<ImportProductsMutation, ImportProductsMutationVariables>(ImportProductsDocument),
    ...options
  }
    )};

export const MakePublicFileDocument = `
    query makePublicFile($url: String!) {
  makePublicFile(url: $url)
}
    `;

export const useMakePublicFileQuery = <
      TData = MakePublicFileQuery,
      TError = unknown
    >(
      variables: MakePublicFileQueryVariables,
      options?: Omit<UseQueryOptions<MakePublicFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MakePublicFileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MakePublicFileQuery, TError, TData>(
      {
    queryKey: ['makePublicFile', variables],
    queryFn: useFetchData<MakePublicFileQuery, MakePublicFileQueryVariables>(MakePublicFileDocument).bind(null, variables),
    ...options
  }
    )};

useMakePublicFileQuery.getKey = (variables: MakePublicFileQueryVariables) => ['makePublicFile', variables];

export const useInfiniteMakePublicFileQuery = <
      TData = InfiniteData<MakePublicFileQuery>,
      TError = unknown
    >(
      variables: MakePublicFileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MakePublicFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MakePublicFileQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<MakePublicFileQuery, MakePublicFileQueryVariables>(MakePublicFileDocument)
    return useInfiniteQuery<MakePublicFileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['makePublicFile.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteMakePublicFileQuery.getKey = (variables: MakePublicFileQueryVariables) => ['makePublicFile.infinite', variables];

export const MarkSaleTrackingsAsDeliveredDocument = `
    mutation markSaleTrackingsAsDelivered($saleId: String!, $filters: markSaleTrackingsAsDeliveredFilter!) {
  markSaleTrackingsAsDelivered(saleId: $saleId, filters: $filters)
}
    `;

export const useMarkSaleTrackingsAsDeliveredMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkSaleTrackingsAsDeliveredMutation, TError, MarkSaleTrackingsAsDeliveredMutationVariables, TContext>) => {
    
    return useMutation<MarkSaleTrackingsAsDeliveredMutation, TError, MarkSaleTrackingsAsDeliveredMutationVariables, TContext>(
      {
    mutationKey: ['markSaleTrackingsAsDelivered'],
    mutationFn: useFetchData<MarkSaleTrackingsAsDeliveredMutation, MarkSaleTrackingsAsDeliveredMutationVariables>(MarkSaleTrackingsAsDeliveredDocument),
    ...options
  }
    )};

export const MoveProductsToPositionDocument = `
    mutation moveProductsToPosition($saleId: String!, $productIds: [ID!]!, $startPosition: Int!) {
  moveProductsToPosition(
    saleId: $saleId
    productIds: $productIds
    startPosition: $startPosition
  )
}
    `;

export const useMoveProductsToPositionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveProductsToPositionMutation, TError, MoveProductsToPositionMutationVariables, TContext>) => {
    
    return useMutation<MoveProductsToPositionMutation, TError, MoveProductsToPositionMutationVariables, TContext>(
      {
    mutationKey: ['moveProductsToPosition'],
    mutationFn: useFetchData<MoveProductsToPositionMutation, MoveProductsToPositionMutationVariables>(MoveProductsToPositionDocument),
    ...options
  }
    )};

export const PreviewImageDocument = `
    mutation previewImage($image: TransformImageData!) {
  previewImage(image: $image) {
    __typename
    ... on ImagePreview {
      url
    }
    ... on ErrorLike {
      message
    }
  }
}
    `;

export const usePreviewImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PreviewImageMutation, TError, PreviewImageMutationVariables, TContext>) => {
    
    return useMutation<PreviewImageMutation, TError, PreviewImageMutationVariables, TContext>(
      {
    mutationKey: ['previewImage'],
    mutationFn: useFetchData<PreviewImageMutation, PreviewImageMutationVariables>(PreviewImageDocument),
    ...options
  }
    )};

export const ProcessProductAudioDocument = `
    mutation processProductAudio($input: ProcessProductAudioInput!) {
  processProductAudio(input: $input) {
    audioUrl
  }
}
    `;

export const useProcessProductAudioMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ProcessProductAudioMutation, TError, ProcessProductAudioMutationVariables, TContext>) => {
    
    return useMutation<ProcessProductAudioMutation, TError, ProcessProductAudioMutationVariables, TContext>(
      {
    mutationKey: ['processProductAudio'],
    mutationFn: useFetchData<ProcessProductAudioMutation, ProcessProductAudioMutationVariables>(ProcessProductAudioDocument),
    ...options
  }
    )};

export const ProcessProductVideoDocument = `
    mutation processProductVideo($input: ProcessProductVideoInput!) {
  processProductVideo(input: $input) {
    videoUrl
  }
}
    `;

export const useProcessProductVideoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ProcessProductVideoMutation, TError, ProcessProductVideoMutationVariables, TContext>) => {
    
    return useMutation<ProcessProductVideoMutation, TError, ProcessProductVideoMutationVariables, TContext>(
      {
    mutationKey: ['processProductVideo'],
    mutationFn: useFetchData<ProcessProductVideoMutation, ProcessProductVideoMutationVariables>(ProcessProductVideoDocument),
    ...options
  }
    )};

export const PublishProductsDocument = `
    mutation publishProducts($productIds: [ID!]!) {
  publishProducts(productIds: $productIds)
}
    `;

export const usePublishProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishProductsMutation, TError, PublishProductsMutationVariables, TContext>) => {
    
    return useMutation<PublishProductsMutation, TError, PublishProductsMutationVariables, TContext>(
      {
    mutationKey: ['publishProducts'],
    mutationFn: useFetchData<PublishProductsMutation, PublishProductsMutationVariables>(PublishProductsDocument),
    ...options
  }
    )};

export const PublishSpotlightConfigDocument = `
    mutation publishSpotlightConfig($saleId: ID!) {
  publishSpotlightConfig(saleId: $saleId) {
    ... on SpotlightConfig {
      __typename
      blocks
      status
      rankSchedule {
        fromDay
        rank
      }
    }
    ... on SpotlightConfigValidationError {
      __typename
      issues {
        path
        code
        message
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const usePublishSpotlightConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishSpotlightConfigMutation, TError, PublishSpotlightConfigMutationVariables, TContext>) => {
    
    return useMutation<PublishSpotlightConfigMutation, TError, PublishSpotlightConfigMutationVariables, TContext>(
      {
    mutationKey: ['publishSpotlightConfig'],
    mutationFn: useFetchData<PublishSpotlightConfigMutation, PublishSpotlightConfigMutationVariables>(PublishSpotlightConfigDocument),
    ...options
  }
    )};

export const RemoveBackgroundImagesDocument = `
    mutation removeBackgroundImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!) {
  removeBackgroundImages(
    images: $images
    sessionId: $sessionId
    actionId: $actionId
  )
}
    `;

export const useRemoveBackgroundImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveBackgroundImagesMutation, TError, RemoveBackgroundImagesMutationVariables, TContext>) => {
    
    return useMutation<RemoveBackgroundImagesMutation, TError, RemoveBackgroundImagesMutationVariables, TContext>(
      {
    mutationKey: ['removeBackgroundImages'],
    mutationFn: useFetchData<RemoveBackgroundImagesMutation, RemoveBackgroundImagesMutationVariables>(RemoveBackgroundImagesDocument),
    ...options
  }
    )};

export const RemoveCouponDocument = `
    mutation removeCoupon($couponId: Int!) {
  removeCoupon(couponId: $couponId)
}
    `;

export const useRemoveCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCouponMutation, TError, RemoveCouponMutationVariables, TContext>) => {
    
    return useMutation<RemoveCouponMutation, TError, RemoveCouponMutationVariables, TContext>(
      {
    mutationKey: ['removeCoupon'],
    mutationFn: useFetchData<RemoveCouponMutation, RemoveCouponMutationVariables>(RemoveCouponDocument),
    ...options
  }
    )};

export const RemoveGtinsDocument = `
    mutation removeGtins($productIds: [ID!]!) {
  removeGtins(productIds: $productIds)
}
    `;

export const useRemoveGtinsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveGtinsMutation, TError, RemoveGtinsMutationVariables, TContext>) => {
    
    return useMutation<RemoveGtinsMutation, TError, RemoveGtinsMutationVariables, TContext>(
      {
    mutationKey: ['removeGtins'],
    mutationFn: useFetchData<RemoveGtinsMutation, RemoveGtinsMutationVariables>(RemoveGtinsDocument),
    ...options
  }
    )};

export const RemoveImmersiveSaleNextDocument = `
    mutation removeImmersiveSaleNext($nextImmersiveId: String!) {
  removeImmersiveSaleNext(nextImmersiveId: $nextImmersiveId)
}
    `;

export const useRemoveImmersiveSaleNextMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveImmersiveSaleNextMutation, TError, RemoveImmersiveSaleNextMutationVariables, TContext>) => {
    
    return useMutation<RemoveImmersiveSaleNextMutation, TError, RemoveImmersiveSaleNextMutationVariables, TContext>(
      {
    mutationKey: ['removeImmersiveSaleNext'],
    mutationFn: useFetchData<RemoveImmersiveSaleNextMutation, RemoveImmersiveSaleNextMutationVariables>(RemoveImmersiveSaleNextDocument),
    ...options
  }
    )};

export const RemoveImmersiveSaleDocument = `
    mutation removeImmersiveSale($immersiveId: String!) {
  removeImmersiveSale(immersiveId: $immersiveId)
}
    `;

export const useRemoveImmersiveSaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveImmersiveSaleMutation, TError, RemoveImmersiveSaleMutationVariables, TContext>) => {
    
    return useMutation<RemoveImmersiveSaleMutation, TError, RemoveImmersiveSaleMutationVariables, TContext>(
      {
    mutationKey: ['removeImmersiveSale'],
    mutationFn: useFetchData<RemoveImmersiveSaleMutation, RemoveImmersiveSaleMutationVariables>(RemoveImmersiveSaleDocument),
    ...options
  }
    )};

export const RemoveProductCouponsDocument = `
    mutation removeProductCoupons($saleId: String!, $productId: String!, $variantId: String!) {
  removeProductCoupons(
    saleId: $saleId
    productId: $productId
    variantId: $variantId
  )
}
    `;

export const useRemoveProductCouponsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductCouponsMutation, TError, RemoveProductCouponsMutationVariables, TContext>) => {
    
    return useMutation<RemoveProductCouponsMutation, TError, RemoveProductCouponsMutationVariables, TContext>(
      {
    mutationKey: ['removeProductCoupons'],
    mutationFn: useFetchData<RemoveProductCouponsMutation, RemoveProductCouponsMutationVariables>(RemoveProductCouponsDocument),
    ...options
  }
    )};

export const RemoveProductFromCollectionDocument = `
    mutation removeProductFromCollection($collectionSaleId: ID!, $productId: ID!) {
  removeProductFromCollection(
    collectionSaleId: $collectionSaleId
    productId: $productId
  )
}
    `;

export const useRemoveProductFromCollectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductFromCollectionMutation, TError, RemoveProductFromCollectionMutationVariables, TContext>) => {
    
    return useMutation<RemoveProductFromCollectionMutation, TError, RemoveProductFromCollectionMutationVariables, TContext>(
      {
    mutationKey: ['removeProductFromCollection'],
    mutationFn: useFetchData<RemoveProductFromCollectionMutation, RemoveProductFromCollectionMutationVariables>(RemoveProductFromCollectionDocument),
    ...options
  }
    )};

export const RemoveProductsBadgesDocument = `
    mutation removeProductsBadges($productIds: [ID!]!, $badges: [ProductBadgeInput!]!) {
  removeProductsBadges(productIds: $productIds, badges: $badges)
}
    `;

export const useRemoveProductsBadgesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductsBadgesMutation, TError, RemoveProductsBadgesMutationVariables, TContext>) => {
    
    return useMutation<RemoveProductsBadgesMutation, TError, RemoveProductsBadgesMutationVariables, TContext>(
      {
    mutationKey: ['removeProductsBadges'],
    mutationFn: useFetchData<RemoveProductsBadgesMutation, RemoveProductsBadgesMutationVariables>(RemoveProductsBadgesDocument),
    ...options
  }
    )};

export const RemoveProductsImagesDocument = `
    mutation removeProductsImages($productIds: [ID!]!, $imageIds: [ID!]!) {
  removeProductsImages(productIds: $productIds, imageIds: $imageIds)
}
    `;

export const useRemoveProductsImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductsImagesMutation, TError, RemoveProductsImagesMutationVariables, TContext>) => {
    
    return useMutation<RemoveProductsImagesMutation, TError, RemoveProductsImagesMutationVariables, TContext>(
      {
    mutationKey: ['removeProductsImages'],
    mutationFn: useFetchData<RemoveProductsImagesMutation, RemoveProductsImagesMutationVariables>(RemoveProductsImagesDocument),
    ...options
  }
    )};

export const RemoveProductsSizeGuideDocument = `
    mutation removeProductsSizeGuide($productIds: [ID!]!) {
  removeProductsSizeGuide(productIds: $productIds)
}
    `;

export const useRemoveProductsSizeGuideMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductsSizeGuideMutation, TError, RemoveProductsSizeGuideMutationVariables, TContext>) => {
    
    return useMutation<RemoveProductsSizeGuideMutation, TError, RemoveProductsSizeGuideMutationVariables, TContext>(
      {
    mutationKey: ['removeProductsSizeGuide'],
    mutationFn: useFetchData<RemoveProductsSizeGuideMutation, RemoveProductsSizeGuideMutationVariables>(RemoveProductsSizeGuideDocument),
    ...options
  }
    )};

export const RemoveVariantsImagesDocument = `
    mutation removeVariantsImages($productIds: [ID!]!) {
  removeProductsVariantsImages(productIds: $productIds)
}
    `;

export const useRemoveVariantsImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveVariantsImagesMutation, TError, RemoveVariantsImagesMutationVariables, TContext>) => {
    
    return useMutation<RemoveVariantsImagesMutation, TError, RemoveVariantsImagesMutationVariables, TContext>(
      {
    mutationKey: ['removeVariantsImages'],
    mutationFn: useFetchData<RemoveVariantsImagesMutation, RemoveVariantsImagesMutationVariables>(RemoveVariantsImagesDocument),
    ...options
  }
    )};

export const RemoveProductsDocument = `
    mutation removeProducts($productsIds: [String!]!, $saleId: String!) {
  removeProducts(productsIds: $productsIds, saleId: $saleId)
}
    `;

export const useRemoveProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductsMutation, TError, RemoveProductsMutationVariables, TContext>) => {
    
    return useMutation<RemoveProductsMutation, TError, RemoveProductsMutationVariables, TContext>(
      {
    mutationKey: ['removeProducts'],
    mutationFn: useFetchData<RemoveProductsMutation, RemoveProductsMutationVariables>(RemoveProductsDocument),
    ...options
  }
    )};

export const RemoveProvisionalSaleDocument = `
    mutation removeProvisionalSale($key: String, $dataKey: String) {
  deleteDealToCalendar(key: $key, dataKey: $dataKey)
}
    `;

export const useRemoveProvisionalSaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProvisionalSaleMutation, TError, RemoveProvisionalSaleMutationVariables, TContext>) => {
    
    return useMutation<RemoveProvisionalSaleMutation, TError, RemoveProvisionalSaleMutationVariables, TContext>(
      {
    mutationKey: ['removeProvisionalSale'],
    mutationFn: useFetchData<RemoveProvisionalSaleMutation, RemoveProvisionalSaleMutationVariables>(RemoveProvisionalSaleDocument),
    ...options
  }
    )};

export const RemoveSaleFiltersConfigDocument = `
    mutation removeSaleFiltersConfig($saleId: ID!) {
  removeSaleFiltersConfig(saleId: $saleId)
}
    `;

export const useRemoveSaleFiltersConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSaleFiltersConfigMutation, TError, RemoveSaleFiltersConfigMutationVariables, TContext>) => {
    
    return useMutation<RemoveSaleFiltersConfigMutation, TError, RemoveSaleFiltersConfigMutationVariables, TContext>(
      {
    mutationKey: ['removeSaleFiltersConfig'],
    mutationFn: useFetchData<RemoveSaleFiltersConfigMutation, RemoveSaleFiltersConfigMutationVariables>(RemoveSaleFiltersConfigDocument),
    ...options
  }
    )};

export const RemoveSaleDocument = `
    mutation removeSale($saleId: String!) {
  removeSale(saleId: $saleId)
}
    `;

export const useRemoveSaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSaleMutation, TError, RemoveSaleMutationVariables, TContext>) => {
    
    return useMutation<RemoveSaleMutation, TError, RemoveSaleMutationVariables, TContext>(
      {
    mutationKey: ['removeSale'],
    mutationFn: useFetchData<RemoveSaleMutation, RemoveSaleMutationVariables>(RemoveSaleDocument),
    ...options
  }
    )};

export const RemoveShopifyPluginDocument = `
    mutation removeShopifyPlugin($sellerId: ID!) {
  removeShopifyPlugin(sellerId: $sellerId)
}
    `;

export const useRemoveShopifyPluginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveShopifyPluginMutation, TError, RemoveShopifyPluginMutationVariables, TContext>) => {
    
    return useMutation<RemoveShopifyPluginMutation, TError, RemoveShopifyPluginMutationVariables, TContext>(
      {
    mutationKey: ['removeShopifyPlugin'],
    mutationFn: useFetchData<RemoveShopifyPluginMutation, RemoveShopifyPluginMutationVariables>(RemoveShopifyPluginDocument),
    ...options
  }
    )};

export const RemoveShopifyVariantIdsDocument = `
    mutation removeShopifyVariantIds($productIds: [ID!]!) {
  removeProductsShopifyVariantIds(productIds: $productIds)
}
    `;

export const useRemoveShopifyVariantIdsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveShopifyVariantIdsMutation, TError, RemoveShopifyVariantIdsMutationVariables, TContext>) => {
    
    return useMutation<RemoveShopifyVariantIdsMutation, TError, RemoveShopifyVariantIdsMutationVariables, TContext>(
      {
    mutationKey: ['removeShopifyVariantIds'],
    mutationFn: useFetchData<RemoveShopifyVariantIdsMutation, RemoveShopifyVariantIdsMutationVariables>(RemoveShopifyVariantIdsDocument),
    ...options
  }
    )};

export const RemoveSkusDocument = `
    mutation removeSkus($productIds: [ID!]!) {
  removeSkus(productIds: $productIds)
}
    `;

export const useRemoveSkusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSkusMutation, TError, RemoveSkusMutationVariables, TContext>) => {
    
    return useMutation<RemoveSkusMutation, TError, RemoveSkusMutationVariables, TContext>(
      {
    mutationKey: ['removeSkus'],
    mutationFn: useFetchData<RemoveSkusMutation, RemoveSkusMutationVariables>(RemoveSkusDocument),
    ...options
  }
    )};

export const RemoveWidgetDocument = `
    mutation removeWidget($saleId: String!, $id: String!) {
  removeWidget(saleId: $saleId, id: $id)
}
    `;

export const useRemoveWidgetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveWidgetMutation, TError, RemoveWidgetMutationVariables, TContext>) => {
    
    return useMutation<RemoveWidgetMutation, TError, RemoveWidgetMutationVariables, TContext>(
      {
    mutationKey: ['removeWidget'],
    mutationFn: useFetchData<RemoveWidgetMutation, RemoveWidgetMutationVariables>(RemoveWidgetDocument),
    ...options
  }
    )};

export const RenameSaleCustomFilterOptionDocument = `
    mutation renameSaleCustomFilterOption($input: RenameSaleCustomFilterOptionInput!) {
  renameSaleCustomFilterOption(input: $input) {
    ... on SaleCustomFilter {
      __typename
      id
      options {
        value
        label
        position
        productsCount
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useRenameSaleCustomFilterOptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameSaleCustomFilterOptionMutation, TError, RenameSaleCustomFilterOptionMutationVariables, TContext>) => {
    
    return useMutation<RenameSaleCustomFilterOptionMutation, TError, RenameSaleCustomFilterOptionMutationVariables, TContext>(
      {
    mutationKey: ['renameSaleCustomFilterOption'],
    mutationFn: useFetchData<RenameSaleCustomFilterOptionMutation, RenameSaleCustomFilterOptionMutationVariables>(RenameSaleCustomFilterOptionDocument),
    ...options
  }
    )};

export const RenameSaleCustomFilterDocument = `
    mutation renameSaleCustomFilter($input: RenameSaleCustomFilterInput!) {
  renameSaleCustomFilter(input: $input) {
    ... on SaleCustomFilter {
      __typename
      id
      name
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useRenameSaleCustomFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameSaleCustomFilterMutation, TError, RenameSaleCustomFilterMutationVariables, TContext>) => {
    
    return useMutation<RenameSaleCustomFilterMutation, TError, RenameSaleCustomFilterMutationVariables, TContext>(
      {
    mutationKey: ['renameSaleCustomFilter'],
    mutationFn: useFetchData<RenameSaleCustomFilterMutation, RenameSaleCustomFilterMutationVariables>(RenameSaleCustomFilterDocument),
    ...options
  }
    )};

export const ReorderSaleCustomFilterOptionsDocument = `
    mutation reorderSaleCustomFilterOptions($input: ReorderSaleCustomFilterOptionsInput!) {
  reorderSaleCustomFilterOptions(input: $input) {
    ... on SaleCustomFilter {
      __typename
      id
      options {
        value
        label
        position
        productsCount
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useReorderSaleCustomFilterOptionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderSaleCustomFilterOptionsMutation, TError, ReorderSaleCustomFilterOptionsMutationVariables, TContext>) => {
    
    return useMutation<ReorderSaleCustomFilterOptionsMutation, TError, ReorderSaleCustomFilterOptionsMutationVariables, TContext>(
      {
    mutationKey: ['reorderSaleCustomFilterOptions'],
    mutationFn: useFetchData<ReorderSaleCustomFilterOptionsMutation, ReorderSaleCustomFilterOptionsMutationVariables>(ReorderSaleCustomFilterOptionsDocument),
    ...options
  }
    )};

export const ReplaceProductsDescriptionDocument = `
    mutation replaceProductsDescription($productIds: [ID!]!, $payload: [ReplacePayload!]!) {
  replaceProductsDescription(productIds: $productIds, payload: $payload)
}
    `;

export const useReplaceProductsDescriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReplaceProductsDescriptionMutation, TError, ReplaceProductsDescriptionMutationVariables, TContext>) => {
    
    return useMutation<ReplaceProductsDescriptionMutation, TError, ReplaceProductsDescriptionMutationVariables, TContext>(
      {
    mutationKey: ['replaceProductsDescription'],
    mutationFn: useFetchData<ReplaceProductsDescriptionMutation, ReplaceProductsDescriptionMutationVariables>(ReplaceProductsDescriptionDocument),
    ...options
  }
    )};

export const ReplaceProductsNameDocument = `
    mutation replaceProductsName($productIds: [ID!]!, $payload: [ReplacePayload!]!) {
  replaceProductsName(productIds: $productIds, payload: $payload)
}
    `;

export const useReplaceProductsNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReplaceProductsNameMutation, TError, ReplaceProductsNameMutationVariables, TContext>) => {
    
    return useMutation<ReplaceProductsNameMutation, TError, ReplaceProductsNameMutationVariables, TContext>(
      {
    mutationKey: ['replaceProductsName'],
    mutationFn: useFetchData<ReplaceProductsNameMutation, ReplaceProductsNameMutationVariables>(ReplaceProductsNameDocument),
    ...options
  }
    )};

export const ReplaceSaleCustomFilterContentDocument = `
    mutation replaceSaleCustomFilterContent($input: ReplaceSaleCustomFilterContentInput!) {
  replaceSaleCustomFilterContent(input: $input) {
    ... on SaleCustomFilter {
      __typename
      id
      productsCount
      options {
        value
        label
        position
        productsCount
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useReplaceSaleCustomFilterContentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReplaceSaleCustomFilterContentMutation, TError, ReplaceSaleCustomFilterContentMutationVariables, TContext>) => {
    
    return useMutation<ReplaceSaleCustomFilterContentMutation, TError, ReplaceSaleCustomFilterContentMutationVariables, TContext>(
      {
    mutationKey: ['replaceSaleCustomFilterContent'],
    mutationFn: useFetchData<ReplaceSaleCustomFilterContentMutation, ReplaceSaleCustomFilterContentMutationVariables>(ReplaceSaleCustomFilterContentDocument),
    ...options
  }
    )};

export const SalesCountDocument = `
    query SalesCount($storeId: StoreRegion!) {
  salesCount(storeId: $storeId) {
    count
  }
}
    `;

export const useSalesCountQuery = <
      TData = SalesCountQuery,
      TError = unknown
    >(
      variables: SalesCountQueryVariables,
      options?: Omit<UseQueryOptions<SalesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SalesCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SalesCountQuery, TError, TData>(
      {
    queryKey: ['SalesCount', variables],
    queryFn: useFetchData<SalesCountQuery, SalesCountQueryVariables>(SalesCountDocument).bind(null, variables),
    ...options
  }
    )};

useSalesCountQuery.getKey = (variables: SalesCountQueryVariables) => ['SalesCount', variables];

export const useInfiniteSalesCountQuery = <
      TData = InfiniteData<SalesCountQuery>,
      TError = unknown
    >(
      variables: SalesCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SalesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SalesCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SalesCountQuery, SalesCountQueryVariables>(SalesCountDocument)
    return useInfiniteQuery<SalesCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SalesCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSalesCountQuery.getKey = (variables: SalesCountQueryVariables) => ['SalesCount.infinite', variables];

export const SaveImageDocument = `
    mutation saveImage($data: SaveImage!) {
  saveImage(data: $data) {
    __typename
    ... on ImageAdded {
      source_store_path_key
      image_storage_path_key
      image_updated_url
      source_url
    }
    ... on ErrorLike {
      message
    }
  }
}
    `;

export const useSaveImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveImageMutation, TError, SaveImageMutationVariables, TContext>) => {
    
    return useMutation<SaveImageMutation, TError, SaveImageMutationVariables, TContext>(
      {
    mutationKey: ['saveImage'],
    mutationFn: useFetchData<SaveImageMutation, SaveImageMutationVariables>(SaveImageDocument),
    ...options
  }
    )};

export const SaveImagesDocument = `
    mutation saveImages($images: [ImageInput!]!, $sessionId: ID!, $actionId: ID!, $options: SaveImagesOptions) {
  saveImages(
    images: $images
    sessionId: $sessionId
    actionId: $actionId
    options: $options
  )
}
    `;

export const useSaveImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveImagesMutation, TError, SaveImagesMutationVariables, TContext>) => {
    
    return useMutation<SaveImagesMutation, TError, SaveImagesMutationVariables, TContext>(
      {
    mutationKey: ['saveImages'],
    mutationFn: useFetchData<SaveImagesMutation, SaveImagesMutationVariables>(SaveImagesDocument),
    ...options
  }
    )};

export const SearchBrandDocument = `
    query searchBrand($name: String!) {
  searchBrand(name: $name) {
    id
    name
    about
    createdAt
  }
}
    `;

export const useSearchBrandQuery = <
      TData = SearchBrandQuery,
      TError = unknown
    >(
      variables: SearchBrandQueryVariables,
      options?: Omit<UseQueryOptions<SearchBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchBrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchBrandQuery, TError, TData>(
      {
    queryKey: ['searchBrand', variables],
    queryFn: useFetchData<SearchBrandQuery, SearchBrandQueryVariables>(SearchBrandDocument).bind(null, variables),
    ...options
  }
    )};

useSearchBrandQuery.getKey = (variables: SearchBrandQueryVariables) => ['searchBrand', variables];

export const useInfiniteSearchBrandQuery = <
      TData = InfiniteData<SearchBrandQuery>,
      TError = unknown
    >(
      variables: SearchBrandQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchBrandQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchBrandQuery, SearchBrandQueryVariables>(SearchBrandDocument)
    return useInfiniteQuery<SearchBrandQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchBrand.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchBrandQuery.getKey = (variables: SearchBrandQueryVariables) => ['searchBrand.infinite', variables];

export const SearchSalesV2Document = `
    query searchSalesV2($name: String!, $store: StoreRegion!, $limit: Int!) {
  searchSalesV2(name: $name, store: $store, limit: $limit) {
    hits {
      _score
      _source
      url
      _id
      highlight
      status
    }
    total
  }
}
    `;

export const useSearchSalesV2Query = <
      TData = SearchSalesV2Query,
      TError = unknown
    >(
      variables: SearchSalesV2QueryVariables,
      options?: Omit<UseQueryOptions<SearchSalesV2Query, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchSalesV2Query, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchSalesV2Query, TError, TData>(
      {
    queryKey: ['searchSalesV2', variables],
    queryFn: useFetchData<SearchSalesV2Query, SearchSalesV2QueryVariables>(SearchSalesV2Document).bind(null, variables),
    ...options
  }
    )};

useSearchSalesV2Query.getKey = (variables: SearchSalesV2QueryVariables) => ['searchSalesV2', variables];

export const useInfiniteSearchSalesV2Query = <
      TData = InfiniteData<SearchSalesV2Query>,
      TError = unknown
    >(
      variables: SearchSalesV2QueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchSalesV2Query, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchSalesV2Query, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchSalesV2Query, SearchSalesV2QueryVariables>(SearchSalesV2Document)
    return useInfiniteQuery<SearchSalesV2Query, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchSalesV2.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchSalesV2Query.getKey = (variables: SearchSalesV2QueryVariables) => ['searchSalesV2.infinite', variables];

export const SendOnboardingEmailDocument = `
    mutation sendOnboardingEmail($brandId: String!) {
  sendOnboardingEmail(brandId: $brandId)
}
    `;

export const useSendOnboardingEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendOnboardingEmailMutation, TError, SendOnboardingEmailMutationVariables, TContext>) => {
    
    return useMutation<SendOnboardingEmailMutation, TError, SendOnboardingEmailMutationVariables, TContext>(
      {
    mutationKey: ['sendOnboardingEmail'],
    mutationFn: useFetchData<SendOnboardingEmailMutation, SendOnboardingEmailMutationVariables>(SendOnboardingEmailDocument),
    ...options
  }
    )};

export const SetProductAsBestSellerDocument = `
    mutation setProductAsBestSeller($productId: ID!, $isBestSeller: Boolean!) {
  setProductAsBestSeller(productId: $productId, isBestSeller: $isBestSeller)
}
    `;

export const useSetProductAsBestSellerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductAsBestSellerMutation, TError, SetProductAsBestSellerMutationVariables, TContext>) => {
    
    return useMutation<SetProductAsBestSellerMutation, TError, SetProductAsBestSellerMutationVariables, TContext>(
      {
    mutationKey: ['setProductAsBestSeller'],
    mutationFn: useFetchData<SetProductAsBestSellerMutation, SetProductAsBestSellerMutationVariables>(SetProductAsBestSellerDocument),
    ...options
  }
    )};

export const SetProductAsCoverDocument = `
    mutation setProductAsCover($productId: ID!, $isCover: Boolean!) {
  setProductAsCover(productId: $productId, isCover: $isCover)
}
    `;

export const useSetProductAsCoverMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductAsCoverMutation, TError, SetProductAsCoverMutationVariables, TContext>) => {
    
    return useMutation<SetProductAsCoverMutation, TError, SetProductAsCoverMutationVariables, TContext>(
      {
    mutationKey: ['setProductAsCover'],
    mutationFn: useFetchData<SetProductAsCoverMutation, SetProductAsCoverMutationVariables>(SetProductAsCoverDocument),
    ...options
  }
    )};

export const SetProductHighlightedAsNewDocument = `
    mutation setProductHighlightedAsNew($productId: ID!, $isHighlightedAsNew: Boolean!) {
  setProductHighlightedAsNew(
    productId: $productId
    isHighlightedAsNew: $isHighlightedAsNew
  )
}
    `;

export const useSetProductHighlightedAsNewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductHighlightedAsNewMutation, TError, SetProductHighlightedAsNewMutationVariables, TContext>) => {
    
    return useMutation<SetProductHighlightedAsNewMutation, TError, SetProductHighlightedAsNewMutationVariables, TContext>(
      {
    mutationKey: ['setProductHighlightedAsNew'],
    mutationFn: useFetchData<SetProductHighlightedAsNewMutation, SetProductHighlightedAsNewMutationVariables>(SetProductHighlightedAsNewDocument),
    ...options
  }
    )};

export const SetProductsAsUniqueDocument = `
    mutation setProductsAsUnique($productIds: [ID!]!) {
  setProductsAsUnique(productIds: $productIds)
}
    `;

export const useSetProductsAsUniqueMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductsAsUniqueMutation, TError, SetProductsAsUniqueMutationVariables, TContext>) => {
    
    return useMutation<SetProductsAsUniqueMutation, TError, SetProductsAsUniqueMutationVariables, TContext>(
      {
    mutationKey: ['setProductsAsUnique'],
    mutationFn: useFetchData<SetProductsAsUniqueMutation, SetProductsAsUniqueMutationVariables>(SetProductsAsUniqueDocument),
    ...options
  }
    )};

export const SetProductsHideDocument = `
    mutation setProductsHide($productIds: [ID!]!, $value: Boolean!) {
  setProductsHide(productIds: $productIds, value: $value)
}
    `;

export const useSetProductsHideMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductsHideMutation, TError, SetProductsHideMutationVariables, TContext>) => {
    
    return useMutation<SetProductsHideMutation, TError, SetProductsHideMutationVariables, TContext>(
      {
    mutationKey: ['setProductsHide'],
    mutationFn: useFetchData<SetProductsHideMutation, SetProductsHideMutationVariables>(SetProductsHideDocument),
    ...options
  }
    )};

export const SetSaleReadyDocument = `
    mutation setSaleReady($saleId: String!, $checkBy: String!, $previewEmailText: String, $previewEmailInfoText: String) {
  setSaleReady(
    saleId: $saleId
    checkBy: $checkBy
    previewEmailText: $previewEmailText
    previewEmailInfoText: $previewEmailInfoText
  )
}
    `;

export const useSetSaleReadyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetSaleReadyMutation, TError, SetSaleReadyMutationVariables, TContext>) => {
    
    return useMutation<SetSaleReadyMutation, TError, SetSaleReadyMutationVariables, TContext>(
      {
    mutationKey: ['setSaleReady'],
    mutationFn: useFetchData<SetSaleReadyMutation, SetSaleReadyMutationVariables>(SetSaleReadyDocument),
    ...options
  }
    )};

export const SetSetupReadyDocument = `
    mutation setSetupReady($saleId: String!, $difficulty: DifficultySetupLevel!, $timeRange: TimeRange!, $reasons: [String!]!, $comments: String) {
  setSetupReady(
    saleId: $saleId
    difficulty: $difficulty
    timeRange: $timeRange
    reasons: $reasons
    comments: $comments
  )
}
    `;

export const useSetSetupReadyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetSetupReadyMutation, TError, SetSetupReadyMutationVariables, TContext>) => {
    
    return useMutation<SetSetupReadyMutation, TError, SetSetupReadyMutationVariables, TContext>(
      {
    mutationKey: ['setSetupReady'],
    mutationFn: useFetchData<SetSetupReadyMutation, SetSetupReadyMutationVariables>(SetSetupReadyDocument),
    ...options
  }
    )};

export const SetSetupWaitingForElementsDocument = `
    mutation setSetupWaitingForElements($saleId: String!, $reasons: [SetupWaitingReason!]!, $comments: String) {
  setSetupWaitingForElements(
    saleId: $saleId
    reasons: $reasons
    comments: $comments
  )
}
    `;

export const useSetSetupWaitingForElementsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetSetupWaitingForElementsMutation, TError, SetSetupWaitingForElementsMutationVariables, TContext>) => {
    
    return useMutation<SetSetupWaitingForElementsMutation, TError, SetSetupWaitingForElementsMutationVariables, TContext>(
      {
    mutationKey: ['setSetupWaitingForElements'],
    mutationFn: useFetchData<SetSetupWaitingForElementsMutation, SetSetupWaitingForElementsMutationVariables>(SetSetupWaitingForElementsDocument),
    ...options
  }
    )};

export const SetShopifyStockProtectionDocument = `
    mutation setShopifyStockProtection($sellerId: ID!, $protect: Boolean!) {
  setShopifyStockProtection(sellerId: $sellerId, protect: $protect)
}
    `;

export const useSetShopifyStockProtectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetShopifyStockProtectionMutation, TError, SetShopifyStockProtectionMutationVariables, TContext>) => {
    
    return useMutation<SetShopifyStockProtectionMutation, TError, SetShopifyStockProtectionMutationVariables, TContext>(
      {
    mutationKey: ['setShopifyStockProtection'],
    mutationFn: useFetchData<SetShopifyStockProtectionMutation, SetShopifyStockProtectionMutationVariables>(SetShopifyStockProtectionDocument),
    ...options
  }
    )};

export const ShowHiddenProductsAndVariantsDocument = `
    mutation showHiddenProductsAndVariants($productIds: [ID!]!) {
  showHiddenProductsAndVariants(productIds: $productIds)
}
    `;

export const useShowHiddenProductsAndVariantsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ShowHiddenProductsAndVariantsMutation, TError, ShowHiddenProductsAndVariantsMutationVariables, TContext>) => {
    
    return useMutation<ShowHiddenProductsAndVariantsMutation, TError, ShowHiddenProductsAndVariantsMutationVariables, TContext>(
      {
    mutationKey: ['showHiddenProductsAndVariants'],
    mutationFn: useFetchData<ShowHiddenProductsAndVariantsMutation, ShowHiddenProductsAndVariantsMutationVariables>(ShowHiddenProductsAndVariantsDocument),
    ...options
  }
    )};

export const ShuffleProductListDocument = `
    mutation shuffleProductList($productIds: [ID!]!) {
  shuffleProductList(productIds: $productIds)
}
    `;

export const useShuffleProductListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ShuffleProductListMutation, TError, ShuffleProductListMutationVariables, TContext>) => {
    
    return useMutation<ShuffleProductListMutation, TError, ShuffleProductListMutationVariables, TContext>(
      {
    mutationKey: ['shuffleProductList'],
    mutationFn: useFetchData<ShuffleProductListMutation, ShuffleProductListMutationVariables>(ShuffleProductListDocument),
    ...options
  }
    )};

export const SpotlightConfigDocument = `
    query spotlightConfig($saleId: ID!) {
  spotlightConfig(saleId: $saleId) {
    blocks
    status
    rankSchedule {
      fromDay
      rank
    }
  }
}
    `;

export const useSpotlightConfigQuery = <
      TData = SpotlightConfigQuery,
      TError = unknown
    >(
      variables: SpotlightConfigQueryVariables,
      options?: Omit<UseQueryOptions<SpotlightConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SpotlightConfigQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SpotlightConfigQuery, TError, TData>(
      {
    queryKey: ['spotlightConfig', variables],
    queryFn: useFetchData<SpotlightConfigQuery, SpotlightConfigQueryVariables>(SpotlightConfigDocument).bind(null, variables),
    ...options
  }
    )};

useSpotlightConfigQuery.getKey = (variables: SpotlightConfigQueryVariables) => ['spotlightConfig', variables];

export const useInfiniteSpotlightConfigQuery = <
      TData = InfiniteData<SpotlightConfigQuery>,
      TError = unknown
    >(
      variables: SpotlightConfigQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SpotlightConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SpotlightConfigQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SpotlightConfigQuery, SpotlightConfigQueryVariables>(SpotlightConfigDocument)
    return useInfiniteQuery<SpotlightConfigQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['spotlightConfig.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSpotlightConfigQuery.getKey = (variables: SpotlightConfigQueryVariables) => ['spotlightConfig.infinite', variables];

export const StartCrossSellingsPreviewDocument = `
    mutation startCrossSellingsPreview($saleId: ID!, $intent: String) {
  startCrossSellingsPreview(saleId: $saleId, intent: $intent) {
    __typename
    ... on CrossSellingPreviewSession {
      sessionId
      saleId
      intent
      status
      progress {
        phase
        completedRequests
        totalRequests
      }
      preview {
        suggestions {
          productId
          products {
            productId
            score
          }
        }
      }
      errorCode
      expiresAt
    }
    ... on DomainException {
      exceptionCode: errorCode
    }
  }
}
    `;

export const useStartCrossSellingsPreviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartCrossSellingsPreviewMutation, TError, StartCrossSellingsPreviewMutationVariables, TContext>) => {
    
    return useMutation<StartCrossSellingsPreviewMutation, TError, StartCrossSellingsPreviewMutationVariables, TContext>(
      {
    mutationKey: ['startCrossSellingsPreview'],
    mutationFn: useFetchData<StartCrossSellingsPreviewMutation, StartCrossSellingsPreviewMutationVariables>(StartCrossSellingsPreviewDocument),
    ...options
  }
    )};

export const SyncPendingShopifyOrdersDocument = `
    mutation SyncPendingShopifyOrders($isDryRun: Boolean!, $sellerId: String, $saleId: String) {
  syncPendingShopifyOrders(
    isDryRun: $isDryRun
    sellerId: $sellerId
    saleId: $saleId
  ) {
    count
    error
  }
}
    `;

export const useSyncPendingShopifyOrdersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncPendingShopifyOrdersMutation, TError, SyncPendingShopifyOrdersMutationVariables, TContext>) => {
    
    return useMutation<SyncPendingShopifyOrdersMutation, TError, SyncPendingShopifyOrdersMutationVariables, TContext>(
      {
    mutationKey: ['SyncPendingShopifyOrders'],
    mutationFn: useFetchData<SyncPendingShopifyOrdersMutation, SyncPendingShopifyOrdersMutationVariables>(SyncPendingShopifyOrdersDocument),
    ...options
  }
    )};

export const SyncShopifyStockDocument = `
    mutation syncShopifyStock($saleId: String!, $brandId: String!) {
  syncShopifyStock(saleId: $saleId, brandId: $brandId) {
    sync_count
    error_count
  }
}
    `;

export const useSyncShopifyStockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncShopifyStockMutation, TError, SyncShopifyStockMutationVariables, TContext>) => {
    
    return useMutation<SyncShopifyStockMutation, TError, SyncShopifyStockMutationVariables, TContext>(
      {
    mutationKey: ['syncShopifyStock'],
    mutationFn: useFetchData<SyncShopifyStockMutation, SyncShopifyStockMutationVariables>(SyncShopifyStockDocument),
    ...options
  }
    )};

export const TranslateProductsWithAiDocument = `
    mutation translateProductsWithAI($input: AIProductsInput!) {
  translateProductsWithAI(input: $input)
}
    `;

export const useTranslateProductsWithAiMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TranslateProductsWithAiMutation, TError, TranslateProductsWithAiMutationVariables, TContext>) => {
    
    return useMutation<TranslateProductsWithAiMutation, TError, TranslateProductsWithAiMutationVariables, TContext>(
      {
    mutationKey: ['translateProductsWithAI'],
    mutationFn: useFetchData<TranslateProductsWithAiMutation, TranslateProductsWithAiMutationVariables>(TranslateProductsWithAiDocument),
    ...options
  }
    )};

export const UnpublishSpotlightConfigDocument = `
    mutation unpublishSpotlightConfig($saleId: ID!) {
  unpublishSpotlightConfig(saleId: $saleId) {
    ... on SpotlightConfig {
      __typename
      blocks
      status
      rankSchedule {
        fromDay
        rank
      }
    }
    ... on SpotlightConfigValidationError {
      __typename
      issues {
        path
        code
        message
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useUnpublishSpotlightConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnpublishSpotlightConfigMutation, TError, UnpublishSpotlightConfigMutationVariables, TContext>) => {
    
    return useMutation<UnpublishSpotlightConfigMutation, TError, UnpublishSpotlightConfigMutationVariables, TContext>(
      {
    mutationKey: ['unpublishSpotlightConfig'],
    mutationFn: useFetchData<UnpublishSpotlightConfigMutation, UnpublishSpotlightConfigMutationVariables>(UnpublishSpotlightConfigDocument),
    ...options
  }
    )};

export const UpdateAccentuateReferralDocument = `
    mutation updateAccentuateReferral($data: AccentuateReferralInput!) {
  updateAccentuateReferral(data: $data)
}
    `;

export const useUpdateAccentuateReferralMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAccentuateReferralMutation, TError, UpdateAccentuateReferralMutationVariables, TContext>) => {
    
    return useMutation<UpdateAccentuateReferralMutation, TError, UpdateAccentuateReferralMutationVariables, TContext>(
      {
    mutationKey: ['updateAccentuateReferral'],
    mutationFn: useFetchData<UpdateAccentuateReferralMutation, UpdateAccentuateReferralMutationVariables>(UpdateAccentuateReferralDocument),
    ...options
  }
    )};

export const UpdateBrandDocument = `
    mutation updateBrand($data: BrandUpdate) {
  updateBrand(data: $data)
}
    `;

export const useUpdateBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBrandMutation, TError, UpdateBrandMutationVariables, TContext>) => {
    
    return useMutation<UpdateBrandMutation, TError, UpdateBrandMutationVariables, TContext>(
      {
    mutationKey: ['updateBrand'],
    mutationFn: useFetchData<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument),
    ...options
  }
    )};

export const UpdateCouponDocument = `
    mutation updateCoupon($data: CouponUpdate!) {
  updateCoupon(data: $data)
}
    `;

export const useUpdateCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCouponMutation, TError, UpdateCouponMutationVariables, TContext>) => {
    
    return useMutation<UpdateCouponMutation, TError, UpdateCouponMutationVariables, TContext>(
      {
    mutationKey: ['updateCoupon'],
    mutationFn: useFetchData<UpdateCouponMutation, UpdateCouponMutationVariables>(UpdateCouponDocument),
    ...options
  }
    )};

export const UpdateInvoiceDocument = `
    mutation UpdateInvoice($saleId: String!, $data: Json) {
  updateInvoice(saleId: $saleId, data: $data)
}
    `;

export const useUpdateInvoiceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInvoiceMutation, TError, UpdateInvoiceMutationVariables, TContext>) => {
    
    return useMutation<UpdateInvoiceMutation, TError, UpdateInvoiceMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInvoice'],
    mutationFn: useFetchData<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument),
    ...options
  }
    )};

export const UpdateManyProductCouponDocument = `
    mutation updateManyProductCoupon($data: [UpdateProductCouponManyInput!]!) {
  updateManyProductCoupon(data: $data)
}
    `;

export const useUpdateManyProductCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateManyProductCouponMutation, TError, UpdateManyProductCouponMutationVariables, TContext>) => {
    
    return useMutation<UpdateManyProductCouponMutation, TError, UpdateManyProductCouponMutationVariables, TContext>(
      {
    mutationKey: ['updateManyProductCoupon'],
    mutationFn: useFetchData<UpdateManyProductCouponMutation, UpdateManyProductCouponMutationVariables>(UpdateManyProductCouponDocument),
    ...options
  }
    )};

export const UpdateManyProductOptionsDocument = `
    mutation updateManyProductOptions($saleId: String!, $data: [UpdateProductOptionManyInput!]!) {
  updateManyProductOptions(saleId: $saleId, data: $data) {
    id
    message
  }
}
    `;

export const useUpdateManyProductOptionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateManyProductOptionsMutation, TError, UpdateManyProductOptionsMutationVariables, TContext>) => {
    
    return useMutation<UpdateManyProductOptionsMutation, TError, UpdateManyProductOptionsMutationVariables, TContext>(
      {
    mutationKey: ['updateManyProductOptions'],
    mutationFn: useFetchData<UpdateManyProductOptionsMutation, UpdateManyProductOptionsMutationVariables>(UpdateManyProductOptionsDocument),
    ...options
  }
    )};

export const UpdateManyProductDocument = `
    mutation updateManyProduct($data: [UpdateProductManyInput!]!) {
  updateManyProduct(data: $data)
}
    `;

export const useUpdateManyProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateManyProductMutation, TError, UpdateManyProductMutationVariables, TContext>) => {
    
    return useMutation<UpdateManyProductMutation, TError, UpdateManyProductMutationVariables, TContext>(
      {
    mutationKey: ['updateManyProduct'],
    mutationFn: useFetchData<UpdateManyProductMutation, UpdateManyProductMutationVariables>(UpdateManyProductDocument),
    ...options
  }
    )};

export const UpdateProductDocument = `
    mutation updateProduct($data: ProductUpdateInputV3!) {
  updateProductV4(data: $data) {
    id
    name
    sourceUrl
    description
    gender
    badges {
      isSpecial
      position
      value
    }
    isDraft
    type
    images {
      id
      baseKey
      image
    }
    video
    audio {
      url
      label
    }
    category {
      name
      vat
    }
    createdAt
    updatedAt
    hide
    hideBy
    hideAt
    brand {
      id
      name
    }
    currency
    variants {
      id
      images
      stockCount
      sku
      gtin
      position
      buyingPrice
      retailPrice
      price
      discountPercentage
      chooseFees
      hide
      hideBy
      hideAt
      absorbedShipping
      shippingFees
      deliveryDelays
      unitsPerPack
      originCountry
      options {
        productOptionId
        valueId
      }
    }
    position
    faq
    faqPreOrder
    faqPostOrder
    couponExpirationDate
    couponDetail
    cgu
    isAlcohol
    customFields {
      key
      position
      type
      value
    }
    options {
      id
      type
      name
      position
      values {
        id
        position
        value
      }
      images {
        id
        baseKey
        image
      }
    }
    isDeliveredByChoose
    isReturnable
  }
}
    `;

export const useUpdateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>(
      {
    mutationKey: ['updateProduct'],
    mutationFn: useFetchData<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument),
    ...options
  }
    )};

export const UpdateProductsBuyingPriceDocument = `
    mutation updateProductsBuyingPrice($productIds: [ID!]!, $value: Float!) {
  updateProductsBuyingPrice(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsBuyingPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsBuyingPriceMutation, TError, UpdateProductsBuyingPriceMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsBuyingPriceMutation, TError, UpdateProductsBuyingPriceMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsBuyingPrice'],
    mutationFn: useFetchData<UpdateProductsBuyingPriceMutation, UpdateProductsBuyingPriceMutationVariables>(UpdateProductsBuyingPriceDocument),
    ...options
  }
    )};

export const UpdateProductsCategoryDocument = `
    mutation updateProductsCategory($productIds: [ID!]!, $category: String!) {
  updateProductsCategory(productIds: $productIds, category: $category)
}
    `;

export const useUpdateProductsCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsCategoryMutation, TError, UpdateProductsCategoryMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsCategoryMutation, TError, UpdateProductsCategoryMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsCategory'],
    mutationFn: useFetchData<UpdateProductsCategoryMutation, UpdateProductsCategoryMutationVariables>(UpdateProductsCategoryDocument),
    ...options
  }
    )};

export const UpdateProductsCouponExpiresAtDocument = `
    mutation updateProductsCouponExpiresAt($productIds: [ID!]!, $value: LocalDate!) {
  updateProductsCouponExpiresAt(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsCouponExpiresAtMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsCouponExpiresAtMutation, TError, UpdateProductsCouponExpiresAtMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsCouponExpiresAtMutation, TError, UpdateProductsCouponExpiresAtMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsCouponExpiresAt'],
    mutationFn: useFetchData<UpdateProductsCouponExpiresAtMutation, UpdateProductsCouponExpiresAtMutationVariables>(UpdateProductsCouponExpiresAtDocument),
    ...options
  }
    )};

export const UpdateProductsDeliveryDocument = `
    mutation updateProductsDelivery($productIds: [ID!]!, $value: Boolean!) {
  updateProductsDelivery(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsDeliveryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsDeliveryMutation, TError, UpdateProductsDeliveryMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsDeliveryMutation, TError, UpdateProductsDeliveryMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsDelivery'],
    mutationFn: useFetchData<UpdateProductsDeliveryMutation, UpdateProductsDeliveryMutationVariables>(UpdateProductsDeliveryDocument),
    ...options
  }
    )};

export const UpdateProductsGenderDocument = `
    mutation updateProductsGender($productIds: [ID!]!, $value: Int!) {
  updateProductsGender(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsGenderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsGenderMutation, TError, UpdateProductsGenderMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsGenderMutation, TError, UpdateProductsGenderMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsGender'],
    mutationFn: useFetchData<UpdateProductsGenderMutation, UpdateProductsGenderMutationVariables>(UpdateProductsGenderDocument),
    ...options
  }
    )};

export const UpdateProductsOriginCountryDocument = `
    mutation updateProductsOriginCountry($productIds: [ID!]!, $value: String!) {
  updateProductsOriginCountry(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsOriginCountryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsOriginCountryMutation, TError, UpdateProductsOriginCountryMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsOriginCountryMutation, TError, UpdateProductsOriginCountryMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsOriginCountry'],
    mutationFn: useFetchData<UpdateProductsOriginCountryMutation, UpdateProductsOriginCountryMutationVariables>(UpdateProductsOriginCountryDocument),
    ...options
  }
    )};

export const UpdateProductsRetailPriceDocument = `
    mutation updateProductsRetailPrice($productIds: [ID!]!, $value: Int!) {
  updateProductsRetailPrice(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsRetailPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsRetailPriceMutation, TError, UpdateProductsRetailPriceMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsRetailPriceMutation, TError, UpdateProductsRetailPriceMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsRetailPrice'],
    mutationFn: useFetchData<UpdateProductsRetailPriceMutation, UpdateProductsRetailPriceMutationVariables>(UpdateProductsRetailPriceDocument),
    ...options
  }
    )};

export const UpdateProductsReturnEligibilityDocument = `
    mutation updateProductsReturnEligibility($productIds: [ID!]!, $isReturnable: Boolean!) {
  updateProductsReturnEligibility(
    productIds: $productIds
    isReturnable: $isReturnable
  )
}
    `;

export const useUpdateProductsReturnEligibilityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsReturnEligibilityMutation, TError, UpdateProductsReturnEligibilityMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsReturnEligibilityMutation, TError, UpdateProductsReturnEligibilityMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsReturnEligibility'],
    mutationFn: useFetchData<UpdateProductsReturnEligibilityMutation, UpdateProductsReturnEligibilityMutationVariables>(UpdateProductsReturnEligibilityDocument),
    ...options
  }
    )};

export const UpdateProductsShippingCostDocument = `
    mutation updateProductsShippingCost($productIds: [ID!]!, $value: Float!) {
  updateProductsShippingCost(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsShippingCostMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsShippingCostMutation, TError, UpdateProductsShippingCostMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsShippingCostMutation, TError, UpdateProductsShippingCostMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsShippingCost'],
    mutationFn: useFetchData<UpdateProductsShippingCostMutation, UpdateProductsShippingCostMutationVariables>(UpdateProductsShippingCostDocument),
    ...options
  }
    )};

export const UpdateProductsVatMarginDocument = `
    mutation updateProductsVatMargin($productIds: [ID!]!, $value: Boolean!) {
  updateProductsVatMargin(productIds: $productIds, value: $value)
}
    `;

export const useUpdateProductsVatMarginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductsVatMarginMutation, TError, UpdateProductsVatMarginMutationVariables, TContext>) => {
    
    return useMutation<UpdateProductsVatMarginMutation, TError, UpdateProductsVatMarginMutationVariables, TContext>(
      {
    mutationKey: ['updateProductsVatMargin'],
    mutationFn: useFetchData<UpdateProductsVatMarginMutation, UpdateProductsVatMarginMutationVariables>(UpdateProductsVatMarginDocument),
    ...options
  }
    )};

export const UpdateProvisionalSalePartialDocument = `
    mutation updateProvisionalSalePartial($key: String, $data: Json) {
  updateDealKey(key: $key, data: $data)
}
    `;

export const useUpdateProvisionalSalePartialMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProvisionalSalePartialMutation, TError, UpdateProvisionalSalePartialMutationVariables, TContext>) => {
    
    return useMutation<UpdateProvisionalSalePartialMutation, TError, UpdateProvisionalSalePartialMutationVariables, TContext>(
      {
    mutationKey: ['updateProvisionalSalePartial'],
    mutationFn: useFetchData<UpdateProvisionalSalePartialMutation, UpdateProvisionalSalePartialMutationVariables>(UpdateProvisionalSalePartialDocument),
    ...options
  }
    )};

export const UpdateSaleDocument = `
    mutation updateSale($sale: SaleInput!, $brandNameChanged: Boolean, $skipReadyTrigger: Boolean) {
  updateSale(
    sale: $sale
    brandNameChanged: $brandNameChanged
    skipReadyTrigger: $skipReadyTrigger
  )
}
    `;

export const useUpdateSaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSaleMutation, TError, UpdateSaleMutationVariables, TContext>) => {
    
    return useMutation<UpdateSaleMutation, TError, UpdateSaleMutationVariables, TContext>(
      {
    mutationKey: ['updateSale'],
    mutationFn: useFetchData<UpdateSaleMutation, UpdateSaleMutationVariables>(UpdateSaleDocument),
    ...options
  }
    )};

export const UpsertNextImmersiveSaleDocument = `
    mutation UpsertNextImmersiveSale($nextImmersiveSale: NextImmersiveSaleInput!) {
  upsertNextImmersiveSale(nextImmersiveSale: $nextImmersiveSale) {
    ... on NextImmersiveSale {
      __typename
      id
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useUpsertNextImmersiveSaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertNextImmersiveSaleMutation, TError, UpsertNextImmersiveSaleMutationVariables, TContext>) => {
    
    return useMutation<UpsertNextImmersiveSaleMutation, TError, UpsertNextImmersiveSaleMutationVariables, TContext>(
      {
    mutationKey: ['UpsertNextImmersiveSale'],
    mutationFn: useFetchData<UpsertNextImmersiveSaleMutation, UpsertNextImmersiveSaleMutationVariables>(UpsertNextImmersiveSaleDocument),
    ...options
  }
    )};

export const UpsertImmersiveSaleDocument = `
    mutation upsertImmersiveSale($immersiveSale: ImmersiveSaleInput!) {
  upsertImmersiveSale(immersiveSale: $immersiveSale) {
    ... on ImmersiveSale {
      __typename
      id
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useUpsertImmersiveSaleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertImmersiveSaleMutation, TError, UpsertImmersiveSaleMutationVariables, TContext>) => {
    
    return useMutation<UpsertImmersiveSaleMutation, TError, UpsertImmersiveSaleMutationVariables, TContext>(
      {
    mutationKey: ['upsertImmersiveSale'],
    mutationFn: useFetchData<UpsertImmersiveSaleMutation, UpsertImmersiveSaleMutationVariables>(UpsertImmersiveSaleDocument),
    ...options
  }
    )};

export const UpsertSaleFiltersConfigDocument = `
    mutation upsertSaleFiltersConfig($input: SaleFiltersConfigInput!) {
  upsertSaleFiltersConfig(input: $input) {
    ... on SaleFiltersConfig {
      __typename
      illustrated
      selectedColor
      hiddenFilterIds
      shortcutFilterIds
      filterImages {
        filterId
        imageUrl
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useUpsertSaleFiltersConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertSaleFiltersConfigMutation, TError, UpsertSaleFiltersConfigMutationVariables, TContext>) => {
    
    return useMutation<UpsertSaleFiltersConfigMutation, TError, UpsertSaleFiltersConfigMutationVariables, TContext>(
      {
    mutationKey: ['upsertSaleFiltersConfig'],
    mutationFn: useFetchData<UpsertSaleFiltersConfigMutation, UpsertSaleFiltersConfigMutationVariables>(UpsertSaleFiltersConfigDocument),
    ...options
  }
    )};

export const UpsertSpotlightConfigDocument = `
    mutation upsertSpotlightConfig($input: SpotlightConfigInput!) {
  upsertSpotlightConfig(input: $input) {
    ... on SpotlightConfig {
      __typename
      blocks
      status
      rankSchedule {
        fromDay
        rank
      }
    }
    ... on SpotlightConfigValidationError {
      __typename
      issues {
        path
        code
        message
      }
    }
    ... on DomainException {
      __typename
      errorCode
      extra {
        key
        value
      }
    }
  }
}
    `;

export const useUpsertSpotlightConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertSpotlightConfigMutation, TError, UpsertSpotlightConfigMutationVariables, TContext>) => {
    
    return useMutation<UpsertSpotlightConfigMutation, TError, UpsertSpotlightConfigMutationVariables, TContext>(
      {
    mutationKey: ['upsertSpotlightConfig'],
    mutationFn: useFetchData<UpsertSpotlightConfigMutation, UpsertSpotlightConfigMutationVariables>(UpsertSpotlightConfigDocument),
    ...options
  }
    )};

export const ValidateAiFormattedProductDescriptionsDocument = `
    mutation validateAIFormattedProductDescriptions($input: ValidateAIFormattedProductDescriptionsInput!) {
  validateAIFormattedProductDescriptions(input: $input)
}
    `;

export const useValidateAiFormattedProductDescriptionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateAiFormattedProductDescriptionsMutation, TError, ValidateAiFormattedProductDescriptionsMutationVariables, TContext>) => {
    
    return useMutation<ValidateAiFormattedProductDescriptionsMutation, TError, ValidateAiFormattedProductDescriptionsMutationVariables, TContext>(
      {
    mutationKey: ['validateAIFormattedProductDescriptions'],
    mutationFn: useFetchData<ValidateAiFormattedProductDescriptionsMutation, ValidateAiFormattedProductDescriptionsMutationVariables>(ValidateAiFormattedProductDescriptionsDocument),
    ...options
  }
    )};

export const ValidateProductCheckSpellingDocument = `
    mutation validateProductCheckSpelling($checkId: ID!) {
  validateProductCheckSpelling(checkId: $checkId)
}
    `;

export const useValidateProductCheckSpellingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateProductCheckSpellingMutation, TError, ValidateProductCheckSpellingMutationVariables, TContext>) => {
    
    return useMutation<ValidateProductCheckSpellingMutation, TError, ValidateProductCheckSpellingMutationVariables, TContext>(
      {
    mutationKey: ['validateProductCheckSpelling'],
    mutationFn: useFetchData<ValidateProductCheckSpellingMutation, ValidateProductCheckSpellingMutationVariables>(ValidateProductCheckSpellingDocument),
    ...options
  }
    )};
